export var headers = {
	"Project-Id-Version": "oxappsuite",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2025-05-16 16:40-0500",
	"Last-Translator": "Timothy Friesen <timothy@workshop-chapina.com>",
	Language: "en_GB",
	"Language-Team": "English <kde-i18n-doc@kde.org>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Lokalize 21.12.3"
};
export default {
	headers: headers,
	"\u0000 and \u0001": [
	" and "
],
	"\u0000%1$d %2$s\u0001": [
	"%1$d %2$s"
],
	"\u0000%1$d Day\u0001%1$d Days": [
	"%1$d Day",
	"%1$d Days"
],
	"\u0000%1$d Hour\u0001%1$d Hours": [
	"%1$d Hour",
	"%1$d Hours"
],
	"\u0000%1$d Minute\u0001%1$d Minutes": [
	"%1$d Minute",
	"%1$d Minutes"
],
	"\u0000%1$d Week\u0001%1$d Weeks": [
	"%1$d Week",
	"%1$d Weeks"
],
	"\u0000%1$d address selected\u0001%1$d addresses selected": [
	"%1$d address selected",
	"%1$d addresses selected"
],
	"\u0000%1$d appointment\u0001%1$d appointments": [
	"%1$d appointment",
	"%1$d appointments"
],
	"\u0000%1$d attachment\u0001%1$d attachments": [
	"%1$d attachment",
	"%1$d attachments"
],
	"\u0000%1$d autocomplete entry found\u0001%1$d autocomplete entries found": [
	"%1$d autocomplete entry found",
	"%1$d autocomplete entries found"
],
	"\u0000%1$d contact\u0001%1$d contacts": [
	"%1$d contact",
	"%1$d contacts"
],
	"\u0000%1$d contact selected\u0001%1$d contacts selected": [
	"%1$d contact selected",
	"%1$d contacts selected"
],
	"\u0000%1$d contacts deleted\u0001": [
	"%1$d contacts deleted"
],
	"\u0000%1$d contacts moved\u0001": [
	"%1$d contacts moved"
],
	"\u0000%1$d day\u0001%1$d days": [
	"%1$d day",
	"%1$d days"
],
	"\u0000%1$d emails archived\u0001": [
	"%1$d email messages archived"
],
	"\u0000%1$d emails copied to folder '%2$s'\u0001": [
	"%1$d email messages copied to folder '%2$s'"
],
	"\u0000%1$d emails deleted\u0001": [
	"%1$d email messages deleted"
],
	"\u0000%1$d emails moved to folder '%2$s'\u0001": [
	"%1$d email messages moved to folder '%2$s'"
],
	"\u0000%1$d entry\u0001%1$d entries": [
	"%1$d entry",
	"%1$d entries"
],
	"\u0000%1$d files have been changed recently\u0001": [
	"%1$d files have been changed recently"
],
	"\u0000%1$d hour\u0001%1$d hours": [
	"%1$d hour",
	"%1$d hours"
],
	"\u0000%1$d item\u0001%1$d items": [
	"%1$d item",
	"%1$d items"
],
	"\u0000%1$d item selected\u0001%1$d items selected": [
	"%1$d item selected",
	"%1$d items selected"
],
	"\u0000%1$d member\u0001%1$d members": [
	"%1$d member",
	"%1$d members"
],
	"\u0000%1$d message\u0001%1$d messages": [
	"%1$d message",
	"%1$d messages"
],
	"\u0000%1$d message selected\u0001%1$d messages selected": [
	"%1$d message selected",
	"%1$d messages selected"
],
	"\u0000%1$d minute\u0001%1$d minutes": [
	"%1$d minute",
	"%1$d minutes"
],
	"\u0000%1$d minutes\u0001": [
	"%1$d minutes"
],
	"\u0000%1$d month\u0001%1$d months": [
	"%1$d month",
	"%1$d months"
],
	"\u0000%1$d of %2$d used\u0001": [
	"%1$d of %2$d used"
],
	"\u0000%1$d of 10 points.\u0001": [
	"%1$d of 10 points."
],
	"\u0000%1$d of 5 stars\u0001": [
	"%1$d of 5 stars"
],
	"\u0000%1$d second\u0001%1$d seconds": [
	"%1$d second",
	"%1$d seconds"
],
	"\u0000%1$d selected\u0001": [
	"%1$d selected"
],
	"\u0000%1$d task\u0001%1$d tasks": [
	"%1$d task",
	"%1$d tasks"
],
	"\u0000%1$d total\u0001": [
	"%1$d total"
],
	"\u0000%1$d unread\u0001": [
	"%1$d unread"
],
	"\u0000%1$d version\u0001%1$d versions": [
	"%1$d version",
	"%1$d versions"
],
	"\u0000%1$d week\u0001%1$d weeks": [
	"%1$d week",
	"%1$d weeks"
],
	"\u0000%1$d year\u0001%1$d years": [
	"%1$d year",
	"%1$d years"
],
	"\u0000%1$d%% of mail count remaining\u0001": [
	"%1$d%% of email count remaining"
],
	"\u0000%1$n member\u0001%1$n members": [
	"%1$n member",
	"%1$n members"
],
	"\u0000%1$s\u0001": [
	"%1$s"
],
	"\u0000%1$s %\u0001": [
	"%1$s %"
],
	"mail address\u0000%1$s %2$s\u0001": [
	"%1$s %2$s"
],
	"\u0000%1$s %2$s - %3$s %4$s\u0001": [
	"%1$s %2$s - %3$s %4$s"
],
	"\u0000%1$s %2$s after end.\u0001": [
	"%1$s %2$s after end."
],
	"\u0000%1$s %2$s after start.\u0001": [
	"%1$s %2$s after start."
],
	"\u0000%1$s %2$s before end.\u0001": [
	"%1$s %2$s before end."
],
	"\u0000%1$s %2$s before start.\u0001": [
	"%1$s %2$s before start."
],
	"\u0000%1$s (%2$s)\u0001": [
	"%1$s (%2$s)"
],
	"\u0000%1$s - %2$s %3$s\u0001": [
	"%1$s - %2$s %3$s"
],
	"\u0000%1$s > %2$s\u0001": [
	"%1$s > %2$s"
],
	"\u0000%1$s Files left\u0001": [
	"%1$s Files left"
],
	"\u0000%1$s Help\u0001": [
	"%1$s Help"
],
	"\u0000%1$s appointments selected\u0001": [
	"%1$s appointments selected"
],
	"\u0000%1$s at %2$s.\u0001": [
	"%1$s at %2$s."
],
	"\u0000%1$s at end.\u0001": [
	"%1$s at end."
],
	"\u0000%1$s at start.\u0001": [
	"%1$s at start."
],
	"\u0000%1$s autocomplete token field. Use left and right arrow keys to navigate between the tokens\u0001": [
	"%1$s autocomplete token field. Use left and right arrow keys to navigate between the tokens"
],
	"\u0000%1$s completed\u0001": [
	"%1$s completed"
],
	"\u0000%1$s could not be added as the contact has no valid email field.\u0001": [
	"%1$s could not be added as the contact has no valid e-mail field."
],
	"\u0000%1$s for Windows\u0001": [
	"%1$s for Windows"
],
	"\u0000%1$s item selected\u0001%1$s items selected": [
	"%1$s item selected",
	"%1$s items selected"
],
	"\u0000%1$s more …\u0001": [
	"%1$s more …"
],
	"\u0000%1$s moved to position %2$s of %3$s\u0001": [
	"%1$s moved to position %2$s of %3$s"
],
	"\u0000%1$s must not be empty.\u0001": [
	"%1$s must not be empty."
],
	"\u0000%1$s of %2$s used\u0001": [
	"%1$s of %2$s used"
],
	"\u0000%1$s options\u0001": [
	"%1$s options"
],
	"\u0000%1$s shared a folder with you\u0001": [
	"%1$s shared a folder with you"
],
	"\u0000%1$s to %2$s\u0001": [
	"%1$s to %2$s"
],
	"\u0000%1$s toolbar. Use cursor keys to navigate.\u0001": [
	"%1$s tool bar. Use cursor keys to navigate."
],
	"\u0000%1$s, %2$s & %3$s\u0001": [
	"%1$s, %2$s & %3$s"
],
	"\u0000%1$s, dropped. Final position in list: %2$s of %3$s\u0001": [
	"%1$s, dropped. Final position in list: %2$s of %3$s"
],
	"\u0000%1$s, dropped. Re-order canceled.\u0001": [
	"%1$s, dropped. Re-order canceled."
],
	"\u0000%1$s, grabbed. Current position in list: %2$s of %3$s. Press up and down arrow to change position, Spacebar to drop, Escape to cancel.\u0001": [
	"%1$s, grabbed. Current position in list: %2$s of %3$s. Press up and down arrow to change position, Spacebar to drop, Escape to cancel."
],
	"\u0000%1$s. New position in list: %2$s of %3$s\u0001": [
	"%1$s. New position in list: %2$s of %3$s"
],
	"\u0000%1$s: %2$s\u0001": [
	"%1$s: %2$s"
],
	"\u0000%2$s, %1$s\u0001": [
	"%2$s, %1$s"
],
	"\u0000%3$s %2$s, %1$s\u0001": [
	"%3$s %2$s, %1$s"
],
	"\u0000%d day\u0001%d days": [
	"%d day",
	"%d days"
],
	"\u0000%s %s, create all-day appointment\u0001": [
	"%s %s, create all-day appointment"
],
	"\u0000%s Conference\u0001": [
	"%s Conference"
],
	"\u0000%s actions\u0001": [
	"%s actions"
],
	"\u0000%s conferences expire after 365 days. We recommend to limit the series to one year. Alternatively, you can update the series before the meeting expires.\u0001": [
	"%s conferences expire after 365 days. We recommend to limit the series to one year. Alternatively, you can update the series before the meeting expires."
],
	"\u0000%s is also available for other platforms:\u0001": [
	"%s is also available for other platforms:"
],
	"\u0000%s logged in on %s\u0001": [
	"%s logged in on %s"
],
	"\u0000%s meetings\u0001": [
	"%s meetings"
],
	"\u0000+\u0001": [
	"+"
],
	"\u0000+ %1$d other\u0001+ %1$d others": [
	"+ %1$d other",
	"+ %1$d others"
],
	"\u0000, \u0001": [
	", "
],
	"\u0000---------- Original Message ----------\u0001": [
	"---------- Original Message ----------"
],
	"\u000009.00 (24 hours)\u0001": [
	"09.00 (24 hours)"
],
	"\u000009:00 (24 hours)\u0001": [
	"09:00 (24 hours)"
],
	"\u000009:00 AM (12 hours)\u0001": [
	"09:00 AM (12 hours)"
],
	"\u00001 day\u0001": [
	"1 day"
],
	"\u00001 file has been changed recently\u0001": [
	"1 file has been changed recently"
],
	"\u00001 minute before the appointment starts\u0001": [
	"1 minute before the appointment starts"
],
	"\u00001 version\u0001": [
	"1 version"
],
	"\u00001 year\u0001": [
	"1 year"
],
	"\u000010 minutes\u0001": [
	"10 minutes"
],
	"\u000010 minutes before the appointment starts\u0001": [
	"10 minutes before the appointment starts"
],
	"\u000010 seconds\u0001": [
	"10 seconds"
],
	"\u000010 versions\u0001": [
	"10 versions"
],
	"\u0000100 versions\u0001": [
	"100 versions"
],
	"\u000015 minutes\u0001": [
	"15 minutes"
],
	"\u000015 minutes before the appointment starts\u0001": [
	"15 minutes before the appointment starts"
],
	"\u00002-Step Verification Options\u0001": [
	"2-Step Verification Options"
],
	"\u00002-step verification\u0001": [
	"2-step verification"
],
	"\u000020 versions\u0001": [
	"20 versions"
],
	"\u000030 days\u0001": [
	"30 days"
],
	"\u000030 minutes\u0001": [
	"30 minutes"
],
	"\u000030 minutes before the appointment starts\u0001": [
	"30 minutes before the appointment starts"
],
	"\u000030 versions\u0001": [
	"30 versions"
],
	"\u000040 versions\u0001": [
	"40 versions"
],
	"\u00005 minutes\u0001": [
	"5 minutes"
],
	"\u00005 minutes before the appointment starts\u0001": [
	"5 minutes before the appointment starts"
],
	"\u00005 seconds\u0001": [
	"5 seconds"
],
	"\u00005 versions\u0001": [
	"5 versions"
],
	"\u000050 versions\u0001": [
	"50 versions"
],
	"\u000060 days\u0001": [
	"60 days"
],
	"\u000060 seconds\u0001": [
	"60 seconds"
],
	"\u000060 versions\u0001": [
	"60 versions"
],
	"\u00007 days\u0001": [
	"7 days"
],
	"\u000070 versions\u0001": [
	"70 versions"
],
	"\u000080 versions\u0001": [
	"80 versions"
],
	"\u00009.00 (24 hours)\u0001": [
	"9.00 (24 hours)"
],
	"\u000090 days\u0001": [
	"90 days"
],
	"\u000090 versions\u0001": [
	"90 versions"
],
	"\u00009:00 (24 hours)\u0001": [
	"9:00 (24 hours)"
],
	"\u00009:00 AM (12 hours)\u0001": [
	"9:00 AM (12 hours)"
],
	"\u0000A folder cannot be moved into itself\u0001": [
	"A folder cannot be moved into itself"
],
	"\u0000A folder cannot be moved to one of its subfolders\u0001": [
	"A folder cannot be moved to one of its subfolders"
],
	"\u0000A new code was sent to your SMS device. Please enter the code.\u0001": [
	"A new code was sent to your SMS device. Please enter the code."
],
	"\u0000A new version for \"%1$s\" has been added.\u0001": [
	"A new version for \"%1$s\" has been added."
],
	"\u0000A password was created successfully.  Please use the following settings in the application:\u0001": [
	"A password was created successfully.  Please use the following settings in the application:"
],
	"\u0000A problem occurred while loading the Zoom meeting. Maybe the Zoom meeting has expired.\u0001": [
	"A problem occured while loading the Zoom meeting. Maybe the Zoom meeting has expired."
],
	"\u0000A public folder is used for content that is of common interest to all users. To allow other users to read or edit the contents, you have to set the respective permissions for the public folder.\u0001": [
	"A public folder is used for content that is of common interest to all users. To allow other users to read or edit the contents, you have to set the respective permissions for the public folder."
],
	"\u0000A read receipt has been sent\u0001": [
	"A read receipt has been sent"
],
	"\u0000A refresh takes some time, so please be patient, while the refresh runs in the background. Only one refresh per subscription and per session is allowed.\u0001": [
	"A refresh takes some time. Please be patient while the refresh runs in the background. Only one refresh per subscription and per session is allowed."
],
	"\u0000A resource calendar group is used to collect specific resources such as rooms, hardware or others that can be booked by other users.\u0001": [
	"A resource calendar group is used to collect specific resources such as rooms, hardware or others that can be booked by other users."
],
	"\u0000A resource group named \"%1$s\" already exists!\u0001": [
	"A resource group named \"%1$s\" already exists!"
],
	"\u0000A time saver if you live or work in more than one time zone\u0001": [
	"A time saver if you live or work in more than one time zone"
],
	"\u0000ADDED\u0001": [
	"ADDED"
],
	"\u0000About\u0001": [
	"About"
],
	"\u0000Accent colors\u0001": [
	"Accent colours"
],
	"\u0000Accept\u0001": [
	"Accept"
],
	"appointment participation status\u0000Accept\u0001": [
	"Accept"
],
	"\u0000Accept Proposal\u0001": [
	"Accept Proposal"
],
	"\u0000Accept changes\u0001": [
	"Accept changes"
],
	"\u0000Accepted\u0001": [
	"Accepted"
],
	"\u0000Accepted the new participant\u0001": [
	"Accepted the new participant"
],
	"\u0000Accepted: %d\u0001": [
	"Accepted: %d"
],
	"\u0000Access to your media devices has been denied. Please refer to your browser help pages for how to reset authorization.\u0001": [
	"Access to your media devices has been denied. Please refer to your browser help pages for how to reset authorization."
],
	"\u0000Accessing global address book is not permitted\u0001": [
	"Accessing global address book is not permitted"
],
	"\u0000Account\u0001": [
	"Account"
],
	"\u0000Account Name\u0001": [
	"Account Name"
],
	"\u0000Account added successfully\u0001": [
	"Account added successfully"
],
	"\u0000Account already exists\u0001": [
	"Account already exists"
],
	"\u0000Account could not be added\u0001": [
	"Account could not be added"
],
	"\u0000Account name\u0001": [
	"Account name"
],
	"\u0000Account settings\u0001": [
	"Account settings"
],
	"\u0000Account settings could not be saved. Please take a look at the annotations in the form. \u0001": [
	"Account settings could not be saved. Please take a look at the annotations in the form. "
],
	"\u0000Account updated\u0001": [
	"Account updated"
],
	"\u0000Account updated successfully\u0001": [
	"Account updated successfully"
],
	"\u0000Accounts\u0001": [
	"Accounts"
],
	"\u0000Actions\u0001": [
	"Actions"
],
	"\u0000Actions for %1$s\u0001": [
	"Actions for %1$s"
],
	"\u0000Actions of this rule are not allowed to be applied to existing emails.\u0001": [
	"Actions of this rule are not allowed to be applied to existing email messages."
],
	"\u0000Actions. Use cursor keys to navigate.\u0001": [
	"Actions. Use cursor keys to navigate."
],
	"\u0000Activate categories\u0001": [
	"Activate categories"
],
	"\u0000Activate next floating window\u0001": [
	"Activate next floating window"
],
	"\u0000Activate previous floating window\u0001": [
	"Activate previous floating window"
],
	"\u0000Active calendars\u0001": [
	"Active calendars"
],
	"\u0000Actual costs\u0001": [
	"Actual costs"
],
	"\u0000Actual duration in minutes\u0001": [
	"Actual duration in minutes"
],
	"\u0000Add\u0001": [
	"Add"
],
	"\u0000Add IMAP keyword\u0001": [
	"Add IMAP keyword"
],
	"\u0000Add Multifactor Device\u0001": [
	"Add Multi-factor Device"
],
	"\u0000Add Recovery Option\u0001": [
	"Add Recovery Option"
],
	"\u0000Add Verification Option\u0001": [
	"Add Verification Option"
],
	"\u0000Add a message to the invitation email for the new participants.\u0001": [
	"Add a message to the invitation email for the new participants."
],
	"\u0000Add a message to the notification email for the other participants.\u0001": [
	"Add a message to the notification e-mail for the other participants."
],
	"\u0000Add a message.\u0001": [
	"Add a message."
],
	"\u0000Add action\u0001": [
	"Add action"
],
	"\u0000Add additional info\u0001": [
	"Add additional info"
],
	"\u0000Add all attachments\u0001": [
	"Add all attachments"
],
	"\u0000Add an extra layer of security to your account\u0001": [
	"Add an extra layer of security to your account"
],
	"\u0000Add as public calendar\u0001": [
	"Add as public calendar"
],
	"\u0000Add as public folder\u0001": [
	"Add as public folder"
],
	"\u0000Add attachment\u0001": [
	"Add attachment"
],
	"\u0000Add attachments\u0001": [
	"Add attachments"
],
	"\u0000Add attachments from another email\u0001": [
	"Add attachments from another email"
],
	"\u0000Add business info\u0001": [
	"Add business info"
],
	"\u0000Add category\u0001": [
	"Add category"
],
	"\u0000Add comment\u0001": [
	"Add comment"
],
	"\u0000Add condition\u0001": [
	"Add condition"
],
	"\u0000Add contact\u0001": [
	"Add contact"
],
	"\u0000Add contact/resource\u0001": [
	"Add contact/resource"
],
	"\u0000Add delegates\u0001": [
	"Add delegates"
],
	"\u0000Add details to appointment description\u0001": [
	"Add details to appointment description"
],
	"\u0000Add email account\u0001": [
	"Add email account"
],
	"\u0000Add email and document encryption\u0001": [
	"Add email and document encryption"
],
	"\u0000Add email, phone, fax\u0001": [
	"Add e-mail, phone, fax"
],
	"\u0000Add file\u0001": [
	"Add file"
],
	"\u0000Add files\u0001": [
	"Add files"
],
	"\u0000Add folder\u0001": [
	"Add folder"
],
	"\u0000Add frequent parts as templates to save time\u0001": [
	"Add frequent parts as templates to save time"
],
	"\u0000Add from %1$s\u0001": [
	"Add from %1$s"
],
	"\u0000Add local file\u0001": [
	"Add local file"
],
	"\u0000Add login password\u0001": [
	"Add login password"
],
	"\u0000Add new address book\u0001": [
	"Add new address book"
],
	"\u0000Add new calendar\u0001": [
	"Add new calendar"
],
	"\u0000Add new folder\u0001": [
	"Add new folder"
],
	"\u0000Add new list\u0001": [
	"Add new list"
],
	"\u0000Add new password\u0001": [
	"Add new password"
],
	"\u0000Add new resource calendar\u0001": [
	"Add new resource calendar"
],
	"\u0000Add new resource calendar group\u0001": [
	"Add new resource calendar group"
],
	"\u0000Add new rule\u0001": [
	"Add new rule"
],
	"\u0000Add new signature\u0001": [
	"Add new signature"
],
	"\u0000Add new task list\u0001": [
	"Add new task list"
],
	"\u0000Add new template\u0001": [
	"Add new template"
],
	"\u0000Add new version\u0001": [
	"Add new version"
],
	"\u0000Add new version and show notification\u0001": [
	"Add new version and show notification"
],
	"\u0000Add other email account\u0001": [
	"Add other e-mail account"
],
	"\u0000Add participant\u0001": [
	"Add participant"
],
	"\u0000Add passwords\u0001": [
	"Add passwords"
],
	"\u0000Add people\u0001": [
	"Add people"
],
	"\u0000Add personal info\u0001": [
	"Add personal info"
],
	"\u0000Add postal address\u0001": [
	"Add postal address"
],
	"\u0000Add recovery option\u0001": [
	"Add recovery option"
],
	"\u0000Add reminder\u0001": [
	"Add reminder"
],
	"\u0000Add signature\u0001": [
	"Add signature"
],
	"\u0000Add signature above quoted text\u0001": [
	"Add signature above quoted text"
],
	"\u0000Add signature below quoted text\u0001": [
	"Add signature below quoted text"
],
	"\u0000Add storage account\u0001": [
	"Add storage account"
],
	"\u0000Add subject\u0001": [
	"Add subject"
],
	"\u0000Add template\u0001": [
	"Add template"
],
	"\u0000Add time zone\u0001": [
	"Add time zone"
],
	"\u0000Add to %1$s\u0001": [
	"Add to %1$s"
],
	"\u0000Add to Calendar\u0001": [
	"Add to Calendar"
],
	"\u0000Add to address book\u0001": [
	"Add to address book"
],
	"\u0000Add to calendar\u0001": [
	"Add to calendar"
],
	"\u0000Add to favorites\u0001": [
	"Add to favourites"
],
	"\u0000Add to portal\u0001": [
	"Add to portal"
],
	"\u0000Add user fields\u0001": [
	"Add user fields"
],
	"\u0000Add verification option\u0001": [
	"Add verification option"
],
	"\u0000Add widget\u0001": [
	"Add widget"
],
	"\u0000Add your %1$s account\u0001": [
	"Add your %1$s account"
],
	"\u0000Add your contact details and important information automatically\u0001": [
	"Add your contact details and important information automatically"
],
	"\u0000Add, remove, and reorder your portal widgets\u0001": [
	"Add, remove, and reorder your portal widgets"
],
	"\u0000Added %1$s, %2$s.\u0001": [
	"Added %1$s, %2$s."
],
	"\u0000Added %1$s.\u0001": [
	"Added %1$s."
],
	"\u0000Added %s to attachments.\u0001": [
	"Added %s to attachments."
],
	"\u0000Added distribution list %s with %s member. The only member of the distribution list is %s.\u0001": [
	"Added distribution list %s with %s member. The only member of the distribution list is %s."
],
	"\u0000Added distribution list %s with %s members. Members of the distribution list are %s.\u0001": [
	"Added distribution list %s with %s members. Members of the distribution list are %s."
],
	"\u0000Added group %s with %s member. The only member of the group is %s.\u0001": [
	"Added group %s with %s member. The only member of the group is %s."
],
	"\u0000Added group %s with %s members. Members of the group are %s.\u0001": [
	"Added group %s with %s members. Members of the group are %s."
],
	"\u0000Adding files\u0001": [
	"Adding files"
],
	"\u0000Additional options\u0001": [
	"Additional options"
],
	"\u0000Additional time zones\u0001": [
	"Additional time zones"
],
	"\u0000Additional time zones allow you to effortlessly keep track of multiple time zones in day, workweek, and week view, eliminating the need for manual time zone calculations and simplifying time management across different regions.\u0001": [
	"Additional time zones allow you to effortlessly keep track of multiple time zones in day, work week, and week view, eliminating the need for manual time zone calculations and simplifying time management across different regions."
],
	"\u0000Address\u0001": [
	"Address"
],
	"\u0000Address Book\u0001": [
	"Address Book"
],
	"app\u0000Address Book\u0001": [
	"Address Book"
],
	"app\u0000Address Book (CardDav)\u0001": [
	"Address Book (CardDav)"
],
	"\u0000Address Business\u0001": [
	"Address Business"
],
	"\u0000Address Home\u0001": [
	"Address Home"
],
	"\u0000Address Other\u0001": [
	"Address Other"
],
	"\u0000Address book\u0001": [
	"Address book"
],
	"\u0000Address book name\u0001": [
	"Address book name"
],
	"\u0000Address directory\u0001": [
	"Address directory"
],
	"\u0000Address list\u0001": [
	"Address list"
],
	"\u0000Addresses can be separated by space, comma, or line breaks, e.g. \"example.org, alice@example.com\"\u0001": [
	"Addresses can be separated by space, comma, or line breaks, e.g. \"example.org, alice@example.com\""
],
	"\u0000Adjust\u0001": [
	"Adjust"
],
	"\u0000Adjust how you read your emails\u0001": [
	"Adjust how you read your email messages"
],
	"\u0000Adjust start and length if your workweek differs from the standard five-day week.\u0001": [
	"Adjust start and length if your workweek differs from the standard five-day week."
],
	"\u0000Adjust start date\u0001": [
	"Adjust start date"
],
	"\u0000Administrative role\u0001": [
	"Administrative role"
],
	"\u0000Administrator\u0001": [
	"Administrator"
],
	"\u0000Advanced settings\u0001": [
	"Advanced settings"
],
	"\u0000Africa\u0001": [
	"Africa"
],
	"\u0000After\u0001": [
	"After"
],
	"\u0000After %1$d seconds\u0001": [
	"After %1$d seconds"
],
	"\u0000After a number of occurrences\u0001": [
	"After a number of occurrences"
],
	"\u0000Age\u0001": [
	"Age"
],
	"\u0000Age: %1$d\u0001": [
	"Age: %1$d"
],
	"\u0000Alarm\u0001": [
	"Alarm"
],
	"\u0000All\u0001": [
	"All"
],
	"\u0000All Applications\u0001": [
	"All Applications"
],
	"\u0000All address books\u0001": [
	"All address books"
],
	"\u0000All attachments\u0001": [
	"All attachments"
],
	"\u0000All day\u0001": [
	"All day"
],
	"\u0000All distribution lists\u0001": [
	"All distribution lists"
],
	"\u0000All files\u0001": [
	"All files"
],
	"\u0000All files have been deleted\u0001": [
	"All files have been deleted"
],
	"\u0000All folders\u0001": [
	"All folders"
],
	"\u0000All future messages from the sender will be moved to the selected folder.\u0001": [
	"All future messages from the sender will be moved to the selected folder."
],
	"\u0000All future messages from the senders of the selected mails will be moved to the selected folder.\u0001": [
	"All future messages from the senders of the selected mails will be moved to the selected folder."
],
	"\u0000All groups\u0001": [
	"All groups"
],
	"\u0000All lists\u0001": [
	"All lists"
],
	"\u0000All messages have been deleted\u0001": [
	"All messages have been deleted"
],
	"\u0000All messages in this folder\u0001": [
	"All messages in this folder"
],
	"\u0000All messages older than %1$d days will be moved to the archive folder\u0001": [
	"All messages older than %1$d days will be moved to the archive folder"
],
	"\u0000All my public appointments\u0001": [
	"All my public appointments"
],
	"\u0000All resources\u0001": [
	"All resources"
],
	"\u0000All settings\u0001": [
	"All settings"
],
	"\u0000All types\u0001": [
	"All types"
],
	"\u0000All unseen messages\u0001": [
	"All unseen messages"
],
	"\u0000Allow connections with untrusted certificates\u0001": [
	"Allow connections with untrusted certificates"
],
	"\u0000Allow displaying HTML formatted emails\u0001": [
	"Allow displaying HTML formatted email messages"
],
	"\u0000Allowed to send emails on your behalf\u0001": [
	"Allowed to send email messages on your behalf"
],
	"\u0000Alt\u0001": [
	"Alt"
],
	"\u0000Alternatively you can download the file.\u0001": [
	"Alternatively you can download the file."
],
	"\u0000Always\u0001": [
	"Always"
],
	"\u0000Always add a random meeting password\u0001": [
	"Always add a random meeting password"
],
	"\u0000Always add to BCC\u0001": [
	"Always add to BCC"
],
	"\u0000Always attach my detailed contact data as vCard\u0001": [
	"Always attach my detailed contact data as a vCard"
],
	"\u0000Always mark \"Participants can edit appointments\" when creating or editing appointments\u0001": [
	"Always mark \"Participants can edit appointments\" when creating or editing appointments"
],
	"\u0000Always show external images (excluding spam and untrustworthy senders)\u0001": [
	"Always show external images (excluding spam and untrustworthy senders)"
],
	"\u0000Always show external images for the following senders\u0001": [
	"Always show external images for the following senders"
],
	"\u0000Always show full date and time\u0001": [
	"Always show full date and time"
],
	"\u0000Always show images from %s\u0001": [
	"Always show images from %s"
],
	"\u0000America\u0001": [
	"America"
],
	"\u0000An email is currently being sent. If you sign out now, mails might not be sent.\u0001": [
	"An email is currently being sent. If you sign out now, email messages might not be sent."
],
	"\u0000An error occurred loading the document so it cannot be displayed.\u0001": [
	"An error occurred loading the document so it cannot be displayed."
],
	"\u0000An error occurred while converting the document so it cannot be displayed.\u0001": [
	"An error occurred while converting the document so it cannot be displayed."
],
	"\u0000An error occurred while loading the document so it cannot be displayed.\u0001": [
	"An error occurred while loading the document so it cannot be displayed."
],
	"\u0000An error occurred.\u0001": [
	"An error occurred."
],
	"\u0000An error occurred. Please refresh the page and try again.\u0001": [
	"An error occurred. Please refresh the page and try again."
],
	"\u0000An error occurred. Please try again.\u0001": [
	"An error occurred. Please try again."
],
	"\u0000An error occurred. There is no valid token available.\u0001": [
	"An error occurred. There is no valid token available."
],
	"\u0000An unexpected error occurred while rendering the PDF file.\u0001": [
	"An unexpected error occurred while rendering the PDF file."
],
	"\u0000An unknown error occurred\u0001": [
	"An unknown error occurred"
],
	"\u0000Android\u0001": [
	"Android"
],
	"\u0000Android phone or tablet\u0001": [
	"Android phone or tablet"
],
	"\u0000Anniversary\u0001": [
	"Anniversary"
],
	"\u0000Antarctica\u0001": [
	"Antarctica"
],
	"\u0000Anti-virus warning\u0001": [
	"Anti-virus warning"
],
	"\u0000Any recipient\u0001": [
	"Any recipient"
],
	"\u0000Anyone on the internet with the link can view the calendar.\u0001": [
	"Anyone on the Internet with the link can view the calendar."
],
	"\u0000Anyone on the internet with the link can view the file.\u0001": [
	"Anyone on the internet with the link can view the file."
],
	"\u0000Anyone on the internet with the link can view the folder.\u0001": [
	"Anyone on the Internet with the link can view the folder."
],
	"\u0000Anyone with the public link and invited people\u0001": [
	"Anyone with the public link and invited people"
],
	"\u0000Anyone with the public link and listed people\u0001": [
	"Anyone with the public link and listed people"
],
	"\u0000App\u0001": [
	"App"
],
	"\u0000App Launcher\u0001": [
	"App Launcher"
],
	"\u0000App Store\u0001": [
	"App Store"
],
	"\u0000Apple Mail\u0001": [
	"Apple Mail"
],
	"\u0000Apple Maps\u0001": [
	"Apple Maps"
],
	"\u0000Application\u0001": [
	"Application"
],
	"\u0000Application Passwords\u0001": [
	"Application Passwords"
],
	"\u0000Application may not work as expected until this problem is solved.\u0001": [
	"Application may not work as expected until this problem is solved."
],
	"\u0000Apply\u0001": [
	"Apply"
],
	"\u0000Apply changes\u0001": [
	"Apply changes"
],
	"\u0000Apply filter\u0001": [
	"Apply filter"
],
	"\u0000Apply rule\u0001": [
	"Apply rule"
],
	"\u0000Apply rule if all conditions are met\u0001": [
	"Apply rule if all conditions are met"
],
	"\u0000Apply rule if any condition is met\u0001": [
	"Apply rule if any condition is met"
],
	"\u0000Apply to all subfolders\u0001": [
	"Apply to all subfolders"
],
	"\u0000Appointment\u0001": [
	"Appointment"
],
	"\u0000Appointment Details\u0001": [
	"Appointment Details"
],
	"\u0000Appointment color\u0001": [
	"Appointment colour"
],
	"\u0000Appointment details now have an indicator when the appointment is about to begin\u0001": [
	"Appointment details now have an indicator when the appointment is about to begin"
],
	"\u0000Appointment has attachments\u0001": [
	"Appointment has attachments"
],
	"\u0000Appointment has participants\u0001": [
	"Appointment has participants"
],
	"\u0000Appointment has resources\u0001": [
	"Appointment has resources"
],
	"\u0000Appointment invitation\u0001": [
	"Appointment invitation"
],
	"\u0000Appointment invitations, changes or deletions\u0001": [
	"Appointment invitations, changes or deletions"
],
	"\u0000Appointment is confidential\u0001": [
	"Appointment is confidential"
],
	"\u0000Appointment is declined\u0001": [
	"Appointment is declined"
],
	"\u0000Appointment is part of a series\u0001": [
	"Appointment is part of a series"
],
	"\u0000Appointment is private\u0001": [
	"Appointment is private"
],
	"\u0000Appointment options\u0001": [
	"Appointment options"
],
	"\u0000Appointment participants are now sorted by their confirmation status\u0001": [
	"Appointment participants are now sorted by their confirmation status"
],
	"\u0000Appointment reminder\u0001": [
	"Appointment reminder"
],
	"\u0000Appointment reminders\u0001": [
	"Appointment reminders"
],
	"\u0000Appointment title\u0001": [
	"Appointment title"
],
	"\u0000Appointment types\u0001": [
	"Appointment types"
],
	"\u0000Appointment was changed in the meantime and was updated accordingly.\u0001": [
	"Appointment was changed in the meantime and was updated accordingly."
],
	"\u0000Appointments\u0001": [
	"Appointments"
],
	"\u0000Appointments in public calendars\u0001": [
	"Appointments in public calendars"
],
	"\u0000Appointments in shared calendars\u0001": [
	"Appointments in shared calendars"
],
	"\u0000Approved: %1$s\u0001": [
	"Approved: %1$s"
],
	"\u0000Apps\u0001": [
	"Apps"
],
	"folder\u0000Archive\u0001": [
	"Archive"
],
	"verb\u0000Archive\u0001": [
	"Archive"
],
	"\u0000Archive email\u0001": [
	"Archive email"
],
	"\u0000Archive messages\u0001": [
	"Archive messages"
],
	"\u0000Archive old messages\u0001": [
	"Archive old messages"
],
	"\u0000Archives\u0001": [
	"Archives"
],
	"\u0000Archives larger than the selected size will be split into multiple files.\u0001": [
	"Archives larger than the selected size will be split into multiple files."
],
	"\u0000Archiving messages…\u0001": [
	"Archiving messages…"
],
	"\u0000Are you sure you want to sign out from all related browser tabs?\u0001": [
	"Are you sure you want to sign out from all related browser tabs?"
],
	"\u0000Are you sure?\u0001": [
	"Are you sure?"
],
	"\u0000As incoming mail server\u0001": [
	"As incoming e-mail server"
],
	"\u0000Ascending\u0001": [
	"Ascending"
],
	"\u0000Asia\u0001": [
	"Asia"
],
	"\u0000Ask before replying to a mailing list\u0001": [
	"Ask before replying to a mailing list"
],
	"\u0000Ask before showing external images\u0001": [
	"Ask before showing external images"
],
	"\u0000Ask for mailto link registration\u0001": [
	"Ask for mailto link registration"
],
	"\u0000Assistant\u0001": [
	"Assistant"
],
	"\u0000Atlantic\u0001": [
	"Atlantic"
],
	"\u0000Attach Vcard\u0001": [
	"Attach vCard"
],
	"\u0000Attached file\u0001": [
	"Attached file"
],
	"\u0000Attachment\u0001": [
	"Attachment"
],
	"\u0000Attachment file size too large. You have to use %1$s or reduce the attachment file size.\u0001": [
	"Attachment file size too large. You have to use %1$s or reduce the attachment file size."
],
	"\u0000Attachment has been saved\u0001": [
	"Attachment has been saved"
],
	"\u0000Attachment name\u0001": [
	"Attachment name"
],
	"\u0000Attachments\u0001": [
	"Attachments"
],
	"\u0000Attachments have been saved\u0001": [
	"Attachments have been saved"
],
	"\u0000Audio\u0001": [
	"Audio"
],
	"\u0000Audio files\u0001": [
	"Audio files"
],
	"\u0000Australia\u0001": [
	"Australia"
],
	"\u0000Authentication\u0001": [
	"Authentication"
],
	"\u0000Authentication Code\u0001": [
	"Authentication Code"
],
	"\u0000Authentication code\u0001": [
	"Authentication code"
],
	"\u0000Authentication details\u0001": [
	"Authentication details"
],
	"\u0000Authentication failure. Please try reloading the page.\u0001": [
	"Authentication failure. Please try reloading the page."
],
	"\u0000Authenticator Registration\u0001": [
	"Authenticator Registration"
],
	"\u0000Author\u0001": [
	"Author"
],
	"\u0000Author (create/edit/delete appointments)\u0001": [
	"Author (create/edit/delete appointments)"
],
	"\u0000Author (create/edit/delete emails)\u0001": [
	"Author (create/edit/delete email messages)"
],
	"\u0000Auto dark mode\u0001": [
	"Auto dark mode"
],
	"\u0000Auto forward\u0001": [
	"Auto forward"
],
	"\u0000Auto forwarding is active\u0001": [
	"Auto forwarding is active"
],
	"\u0000Auto-configuration failed. Do you want to configure your account manually?\u0001": [
	"Auto-configuration failed. Do you want to configure your account manually?"
],
	"\u0000Automatic Configuration\u0001": [
	"Automatic Configuration"
],
	"\u0000Automatic Configuration (via SMS)\u0001": [
	"Automatic Configuration (via SMS)"
],
	"\u0000Automatic configuration\u0001": [
	"Automatic configuration"
],
	"\u0000Automatic email address collection\u0001": [
	"Automatic email address collection"
],
	"\u0000Automatic sign out\u0001": [
	"Automatic sign out"
],
	"\u0000Automatically apply appointment changes received via email to your calendar\u0001": [
	"Automatically apply appointment changes received via email to your calendar"
],
	"\u0000Automatically copy comprehensive dial-in information to the appointment description field\u0001": [
	"Automatically copy comprehensive dial-in information to the appointment description field"
],
	"\u0000Automatically copy the meeting join link to the appointment location field\u0001": [
	"Automatically copy the meeting join link to the appointment location field"
],
	"\u0000Automatically creates a \"Collected addresses\" folder for email addresses you interact with.\u0001": [
	"Automatically creates a \"Collected addresses\" folder for email addresses you interact with."
],
	"\u0000Automatically delete the invitation email after the appointment has been accepted or declined\u0001": [
	"Automatically delete the invitation e-mail after the appointment has been accepted or declined"
],
	"\u0000Automatically mark all day appointments as \"free\" when creating or editing appointments\u0001": [
	"Automatically mark all day appointments as \"free\" when creating or editing appointments"
],
	"\u0000Automatically open the notification area for new reminders\u0001": [
	"Automatically open the notification area for new reminders"
],
	"\u0000Automatically switch to dark mode if this computer uses dark mode\u0001": [
	"Automatically switch to dark mode if this computer uses dark mode"
],
	"\u0000B\u0001": [
	"B"
],
	"\u0000BCC\u0001": [
	"BCC"
],
	"\u0000Back\u0001": [
	"Back"
],
	"\u0000Back to list\u0001": [
	"Back to list"
],
	"\u0000Back to sign in\u0001": [
	"Back to sign in"
],
	"\u0000Backgrounds\u0001": [
	"Backgrounds"
],
	"\u0000Backup code to access your account.\u0001": [
	"Backup code to access your account."
],
	"\u0000Bad input or server error. Please try again.\u0001": [
	"Bad input or server error. Please try again."
],
	"\u0000Bad parameters for authenticating with this key. Possibly wrong URL domain for this key.\u0001": [
	"Bad parameters for authenticating with this key. Possibly wrong URL domain for this key."
],
	"\u0000Bad verification code. Please try again\u0001": [
	"Bad verification code. Please try again"
],
	"\u0000Bcc\u0001": [
	"Bcc"
],
	"\u0000Be careful with this message. It might be spam or a phishing mail.\u0001": [
	"Be careful with this message. It might be spam or a phishing e-mail."
],
	"\u0000Beach\u0001": [
	"Beach"
],
	"\u0000Before\u0001": [
	"Before"
],
	"\u0000Before you can continue using the product, you have to enter some basic information. It will take less than a minute.\u0001": [
	"Before you can continue using the product, you have to enter some basic information. It will take less than a minute."
],
	"\u0000Behavior\u0001": [
	"Behaviour"
],
	"\u0000Bell\u0001": [
	"Bell"
],
	"\u0000Big mobile UI makeover\u0001": [
	"Big mobile UI makeover"
],
	"\u0000Big settings makeover\u0001": [
	"Big settings makeover"
],
	"\u0000Billing information\u0001": [
	"Billing information"
],
	"\u0000Birthday\u0001": [
	"Birthday"
],
	"\u0000Birthdays\u0001": [
	"Birthdays"
],
	"\u0000Black\u0001": [
	"Black"
],
	"\u0000Blind copy\u0001": [
	"Blind copy"
],
	"BCC\u0000Blind copy\u0001": [
	"Blind copy"
],
	"\u0000Blocked time frame\u0001": [
	"Blocked time frame"
],
	"\u0000Blue\u0001": [
	"Blue"
],
	"\u0000Body\u0001": [
	"Body"
],
	"\u0000Bold\u0001": [
	"Bold"
],
	"\u0000Booking behavior\u0001": [
	"Booking behaviour"
],
	"\u0000Booking requests are automatically accepted if the resource is free.\u0001": [
	"Booking requests are automatically accepted if the resource is free."
],
	"\u0000Booking requests for this resource need manual approval. Notifications will be sent automatically to resource delegates who will then take care of booking requests.\u0001": [
	"Booking requests for this resource need manual approval. Notifications will be sent automatically to resource delegates who will then take care of booking requests."
],
	"\u0000Branches\u0001": [
	"Branches"
],
	"\u0000Brown\u0001": [
	"Brown"
],
	"\u0000Browse categories\u0001": [
	"Browse categories"
],
	"\u0000Browse in categories: In our latest update, we're excited to unveil the new category browser. This innovative feature allows users to effortlessly search and navigate through items tagged under any category in a single place, regardless of their type - be it emails, contacts, appointments, or tasks.\u0001": [
	"Browse in categories: In our latest update, we are excited to unveil the new category browser. This innovative feature allows users to effortlessly search and navigate through items tagged under any category in a single place, regardless of their type - be it email messages, contacts, appointments, or tasks."
],
	"\u0000Browser back/forward navigation\u0001": [
	"Browser back/forward navigation"
],
	"\u0000Business\u0001": [
	"Business"
],
	"\u0000Business (Company, Department, Position)\u0001": [
	"Business (Company, Department, Position)"
],
	"\u0000Business Address\u0001": [
	"Business Address"
],
	"\u0000Business address\u0001": [
	"Business address"
],
	"\u0000Business category\u0001": [
	"Business category"
],
	"\u0000CC\u0001": [
	"CC"
],
	"\u0000CSV\u0001": [
	"CSV"
],
	"\u0000CW\u0001": [
	"CW"
],
	"\u0000CW %1$d\u0001": [
	"CW %1$d"
],
	"\u0000CalDAV\u0001": [
	"CalDAV"
],
	"\u0000CalDAV URL\u0001": [
	"CalDAV URL"
],
	"\u0000Calendar\u0001": [
	"Calendar"
],
	"app\u0000Calendar\u0001": [
	"Calendar"
],
	"app\u0000Calendar (CalDav)\u0001": [
	"Calendar (CalDav)"
],
	"\u0000Calendar account error\u0001": [
	"Calendar account error"
],
	"\u0000Calendar name\u0001": [
	"Calendar name"
],
	"\u0000Calendar options\u0001": [
	"Calendar options"
],
	"\u0000Calendar view\u0001": [
	"Calendar view"
],
	"\u0000Calendar was not imported. Only .ics and .ical files are supported.\u0001": [
	"Calendar was not imported. Only .ics and .ical files are supported."
],
	"\u0000Calendars\u0001": [
	"Calendars"
],
	"\u0000Call\u0001": [
	"Call"
],
	"verb\u0000Call\u0001": [
	"Call"
],
	"\u0000Call via %s\u0001": [
	"Call via %s"
],
	"\u0000Call via Zoom\u0001": [
	"Call via Zoom"
],
	"\u0000Camera %1$s\u0001": [
	"Camera %1$s"
],
	"\u0000Cancel\u0001": [
	"Cancel"
],
	"\u0000Cancel download request\u0001": [
	"Cancel download request"
],
	"\u0000Cancel search\u0001": [
	"Cancel search"
],
	"\u0000Cancel send\u0001": [
	"Cancel send"
],
	"\u0000Canceled\u0001": [
	"Cancelled"
],
	"\u0000Cannot add contact with an invalid email address: %1$s\u0001": [
	"Cannot add contact with an invalid e-mail address: %1$s"
],
	"\u0000Cannot connect to server. Please check your connection.\u0001": [
	"Cannot connect to server. Please check your connection."
],
	"\u0000Cannot establish secure connection. Do you want to proceed anyway?\u0001": [
	"Cannot establish secure connection. Do you want to proceed anyway?"
],
	"\u0000Cannot find any messages this contact sent to you.\u0001": [
	"Cannot find any messages this contact sent to you."
],
	"\u0000Cannot find any messages you sent to this contact.\u0001": [
	"Cannot find any messages you sent to this contact."
],
	"\u0000Cannot find user with given name.\u0001": [
	"Cannot find user with given name."
],
	"\u0000Cannot print these items\u0001": [
	"Cannot print these items"
],
	"\u0000Cannot print this item\u0001": [
	"Cannot print this item"
],
	"\u0000Cannot require a view type for %1$s\u0001": [
	"Cannot require a view type for %1$s"
],
	"\u0000Capture\u0001": [
	"Capture"
],
	"\u0000CardDAV\u0001": [
	"CardDAV"
],
	"\u0000CardDAV URL\u0001": [
	"CardDAV URL"
],
	"\u0000Categories\u0001": [
	"Categories"
],
	"\u0000Categories for emails\u0001": [
	"Categories for email messages"
],
	"\u0000Category\u0001": [
	"Category"
],
	"\u0000Category browser\u0001": [
	"Category browser"
],
	"\u0000Category name\u0001": [
	"Category name"
],
	"\u0000Cc\u0001": [
	"Cc"
],
	"\u0000Cc: %1$s\u0001": [
	"CC: %1$s"
],
	"\u0000Cell phone\u0001": [
	"Cell phone"
],
	"\u0000Cell phone (alt)\u0001": [
	"Cell phone (alt)"
],
	"\u0000Certificate details\u0001": [
	"Certificate details"
],
	"\u0000Certificates\u0001": [
	"Certificates"
],
	"\u0000Change\u0001": [
	"Change"
],
	"\u0000Change IMAP subscriptions\u0001": [
	"Change IMAP subscriptions"
],
	"\u0000Change appointment\u0001": [
	"Change appointment"
],
	"\u0000Change appointment confirmation\u0001": [
	"Change appointment confirmation"
],
	"\u0000Change appointment reminders\u0001": [
	"Change appointment reminders"
],
	"\u0000Change confirmation\u0001": [
	"Change confirmation"
],
	"\u0000Change confirmation for resource %1$s\u0001": [
	"Change confirmation for resource %1$s"
],
	"\u0000Change contact photo\u0001": [
	"Change contact photo"
],
	"\u0000Change due date\u0001": [
	"Change due date"
],
	"\u0000Change login password\u0001": [
	"Change login password"
],
	"\u0000Change organizer\u0001": [
	"Change organiser"
],
	"\u0000Change participation\u0001": [
	"Change participation"
],
	"\u0000Change password\u0001": [
	"Change password"
],
	"\u0000Change password and sign out\u0001": [
	"Change password and sign out"
],
	"\u0000Change photo\u0001": [
	"Change photo"
],
	"\u0000Change quick launch bar\u0001": [
	"Change quick launch bar"
],
	"\u0000Change reminders\u0001": [
	"Change reminders"
],
	"\u0000Change series\u0001": [
	"Change series"
],
	"\u0000Change time zone\u0001": [
	"Change time zone"
],
	"\u0000Change user photo\u0001": [
	"Change user photo"
],
	"\u0000Change who has access?\u0001": [
	"Change who has access?"
],
	"\u0000Changed due date\u0001": [
	"Changed due date"
],
	"\u0000Changes have been saved\u0001": [
	"Changes have been saved"
],
	"\u0000Changing language or timezone requires a page reload or relogin to take effect.\u0001": [
	"Changing language or time zone requires a page reload or relogin to take effect."
],
	"\u0000Checkboxes\u0001": [
	"Checkboxes"
],
	"\u0000Children\u0001": [
	"Children"
],
	"\u0000Chimes\u0001": [
	"Chimes"
],
	"\u0000Choose a device\u0001": [
	"Choose a device"
],
	"\u0000Choose a sending date and time for your email.\u0001": [
	"Choose a sending date and time for your email."
],
	"\u0000Choose a theme\u0001": [
	"Choose a theme"
],
	"\u0000Choose an application\u0001": [
	"Choose an application"
],
	"\u0000Choose folder\u0001": [
	"Choose folder"
],
	"\u0000City\u0001": [
	"City"
],
	"\u0000Clean up\u0001": [
	"Clean up"
],
	"\u0000Cleaning up…\u0001": [
	"Cleaning up…"
],
	"\u0000Clear\u0001": [
	"Clear"
],
	"\u0000Clear selection\u0001": [
	"Clear selection"
],
	"\u0000Click <b>Install</b> in the popup.\u0001": [
	"Click <b>Install</b> in the popup."
],
	"\u0000Click on <b>Install</b> in the popup.\u0001": [
	"Click on <b>Install</b> in the popup."
],
	"\u0000Click on the application that you would like to use.\u0001": [
	"Click on the application that you would like to use."
],
	"\u0000Click on the install icon\u0001": [
	"Click on the install icon"
],
	"\u0000Click on the sharing icon\u0001": [
	"Click on the sharing icon"
],
	"\u0000Click the More button\u0001": [
	"Click the More button"
],
	"\u0000Click the install icon\u0001": [
	"Click the install icon"
],
	"\u0000Click to copy URL to clipboard\u0001": [
	"Click to copy URL to clipboard"
],
	"\u0000Click to merge all folders into one column\u0001": [
	"Click to merge all folders into one column"
],
	"\u0000Click to split all folders into separate columns\u0001": [
	"Click to split all folders into separate columns"
],
	"\u0000Client onboarding\u0001": [
	"Client onboarding"
],
	"\u0000Close\u0001": [
	"Close"
],
	"\u0000Close description panel\u0001": [
	"Close description panel"
],
	"\u0000Close folder view\u0001": [
	"Close folder view"
],
	"\u0000Close menu\u0001": [
	"Close menu"
],
	"\u0000Close settings\u0001": [
	"Close settings"
],
	"\u0000Close slideshow\u0001": [
	"Close slideshow"
],
	"\u0000Close this notification\u0001": [
	"Close this notification"
],
	"\u0000Close viewer\u0001": [
	"Close viewer"
],
	"\u0000Close window\u0001": [
	"Close window"
],
	"\u0000Code via text message\u0001": [
	"Code via text message"
],
	"\u0000Collapse form\u0001": [
	"Collapse form"
],
	"\u0000Color\u0001": [
	"Colour"
],
	"\u0000Color %1$s\u0001": [
	"Colour %1$s"
],
	"\u0000Comma is not allowed.\u0001": [
	"Comma is not allowed."
],
	"\u0000Comments and suggestions\u0001": [
	"Comments and suggestions"
],
	"\u0000Commercial Register\u0001": [
	"Commercial register"
],
	"\u0000Common name\u0001": [
	"Common name"
],
	"\u0000Compact\u0001": [
	"Compact"
],
	"\u0000Companies\u0001": [
	"Companies"
],
	"\u0000Company\u0001": [
	"Company"
],
	"\u0000Compose & Reply\u0001": [
	"Compose & Reply"
],
	"\u0000Compose & reply\u0001": [
	"Compose & reply"
],
	"\u0000Compose email with external images\u0001": [
	"Compose email with external images"
],
	"\u0000Compose email without external images\u0001": [
	"Compose mail without external images"
],
	"\u0000Conditions\u0001": [
	"Conditions"
],
	"\u0000Conference\u0001": [
	"Conference"
],
	"\u0000Configuration Email\u0001": [
	"Configuration E-mail"
],
	"\u0000Configuration not supported\u0001": [
	"Configuration not supported"
],
	"\u0000Configure %s\u0001": [
	"Configure %s"
],
	"\u0000Configure a specific device or application\u0001": [
	"Configure a specific device or application"
],
	"\u0000Configure categories\u0001": [
	"Configure categories"
],
	"\u0000Configure inbox categories\u0001": [
	"Configure inbox categories"
],
	"\u0000Configure manually\u0001": [
	"Configure manually"
],
	"\u0000Configure quick launch bar\u0001": [
	"Configure quick launch bar"
],
	"\u0000Configure the notification area\u0001": [
	"Configure the notification area"
],
	"\u0000Configure your keyboard shortcut profile\u0001": [
	"Configure your keyboard shortcut profile"
],
	"\u0000Confirm Code\u0001": [
	"Confirm Code"
],
	"\u0000Confirm new password\u0001": [
	"Confirm new password"
],
	"\u0000Confirm recipient(s)\u0001": [
	"Confirm recipient(s)"
],
	"\u0000Confirmation\u0001": [
	"Confirmation"
],
	"\u0000Conflicts\u0001": [
	"Conflicts"
],
	"\u0000Conflicts detected\u0001": [
	"Conflicts detected"
],
	"\u0000Conflicts with resources cannot be ignored\u0001": [
	"Conflicts with resources cannot be ignored"
],
	"\u0000Conflicts:\u0001": [
	"Conflicts:"
],
	"\u0000Connect\u0001": [
	"Connect"
],
	"\u0000Connect this device\u0001": [
	"Connect this device"
],
	"\u0000Connect with Zoom\u0001": [
	"Connect with Zoom"
],
	"\u0000Connect your device\u0001": [
	"Connect your device"
],
	"\u0000Connect your device to your account in seconds\u0001": [
	"Connect your device to your account in seconds"
],
	"\u0000Connecting to Zoom…\u0001": [
	"Connecting to Zoom…"
],
	"\u0000Connection\u0001": [
	"Connection"
],
	"\u0000Connection error\u0001": [
	"Connection error"
],
	"\u0000Connection security\u0001": [
	"Connection security"
],
	"\u0000Connection timed out. Please try reloading the page.\u0001": [
	"Connection timed out. Please try reloading the page."
],
	"\u0000Contact\u0001": [
	"Contact"
],
	"\u0000Contact \"%1$s\" deleted\u0001": [
	"Contact \"%1$s\" deleted"
],
	"\u0000Contact \"%1$s\" moved\u0001": [
	"Contact \"%1$s\" moved"
],
	"\u0000Contact Details\u0001": [
	"Contact Details"
],
	"\u0000Contact has been copied\u0001": [
	"Contact has been copied"
],
	"\u0000Contact has been moved\u0001": [
	"Contact has been moved"
],
	"\u0000Contact list\u0001": [
	"Contact list"
],
	"\u0000Contact list. Select a contact to view details.\u0001": [
	"Contact list. Select a contact to view details."
],
	"\u0000Contact pictures\u0001": [
	"Contact pictures"
],
	"\u0000Contacts\u0001": [
	"Contacts"
],
	"\u0000Contacts account error\u0001": [
	"Contacts account error"
],
	"\u0000Contacts have been copied\u0001": [
	"Contacts have been copied"
],
	"\u0000Contacts have been moved\u0001": [
	"Contacts have been moved"
],
	"\u0000Contacts in address books\u0001": [
	"Contacts in address books"
],
	"\u0000Contacts in public address books\u0001": [
	"Contacts in public address books"
],
	"\u0000Contacts in shared address books\u0001": [
	"Contacts in shared address books"
],
	"\u0000Contacts toolbar\u0001": [
	"Contacts tool bar"
],
	"\u0000Contains\u0001": [
	"Contains"
],
	"\u0000Contains not\u0001": [
	"Does not contain"
],
	"\u0000Contains words\u0001": [
	"Contains words"
],
	"\u0000Content\u0001": [
	"Content"
],
	"\u0000Continue\u0001": [
	"Continue"
],
	"\u0000Continue sign out\u0001": [
	"Continue sign out"
],
	"\u0000Continuous improvements\u0001": [
	"Continuous improvements"
],
	"\u0000Conversation\u0001": [
	"Conversation"
],
	"\u0000Conversations\u0001": [
	"Conversations"
],
	"\u0000Copied to clipboard\u0001": [
	"Copied to clipboard"
],
	"\u0000Copy\u0001": [
	"Copy"
],
	"CC\u0000Copy\u0001": [
	"Copy"
],
	"\u0000Copy dial-in information to description\u0001": [
	"Copy dial-in information to description"
],
	"\u0000Copy into\u0001": [
	"Copy into"
],
	"\u0000Copy link\u0001": [
	"Copy link"
],
	"\u0000Copy link to clipboard\u0001": [
	"Copy link to clipboard"
],
	"\u0000Copy link to location\u0001": [
	"Copy link to location"
],
	"\u0000Copy to clipboard\u0001": [
	"Copy to clipboard"
],
	"\u0000Copy to location field\u0001": [
	"Copy to location field"
],
	"\u0000Costs must be between -%1$d and %1$d.\u0001": [
	"Costs must be between -%1$d and %1$d."
],
	"\u0000Costs must only have two decimal places.\u0001": [
	"Costs must only have two decimal places."
],
	"\u0000Could not create PDF file.\u0001": [
	"Could not create PDF file."
],
	"\u0000Could not create deputy.\u0001": [
	"Could not create deputy."
],
	"\u0000Could not delete folder. This can be due to insufficient permissions in your trash folder or this might be a special folder that cannot be deleted.\u0001": [
	"Could not delete folder. This can be due to insufficient permissions in your trash folder or this might be a special folder that cannot be deleted."
],
	"\u0000Could not find the requested appointment\u0001": [
	"Could not find the requested appointment"
],
	"\u0000Could not get a default folder for this application.\u0001": [
	"Could not get a default folder for this application."
],
	"\u0000Could not get appointment information\u0001": [
	"Could not get appointment information"
],
	"\u0000Could not load address book.\u0001": [
	"Could not load address book."
],
	"\u0000Could not load attachments for this contact.\u0001": [
	"Could not load attachments for this contact."
],
	"\u0000Could not load attachments for this task.\u0001": [
	"Could not load attachments for this task."
],
	"\u0000Could not load contacts\u0001": [
	"Could not load contacts"
],
	"\u0000Could not load data\u0001": [
	"Could not load data"
],
	"\u0000Could not load deputy data.\u0001": [
	"Could not load deputy data."
],
	"\u0000Could not load this list\u0001": [
	"Could not load this list"
],
	"\u0000Could not remove deputy.\u0001": [
	"Could not remove deputy."
],
	"\u0000Could not save settings\u0001": [
	"Could not save settings"
],
	"\u0000Could not save settings.\u0001": [
	"Could not save settings."
],
	"\u0000Could not save settings. There has to be at least one user with administration rights.\u0001": [
	"Could not save settings. There has to be at least one user with administration rights."
],
	"\u0000Could not update deputy permissions.\u0001": [
	"Could not update deputy permissions."
],
	"\u0000Couldn't load appointment data.\u0001": [
	"Could not load appointment data."
],
	"\u0000Couldn't load contact data.\u0001": [
	"Could not load contact data."
],
	"\u0000Couldn't load editor\u0001": [
	"Could not load editor"
],
	"\u0000Couldn't load that task.\u0001": [
	"Could not load that task."
],
	"\u0000Couldn't load your mail rules.\u0001": [
	"Could not load your email rules."
],
	"\u0000Countdown\u0001": [
	"Countdown"
],
	"\u0000Country\u0001": [
	"Country"
],
	"\u0000Create\u0001": [
	"Create"
],
	"\u0000Create Flickr photo stream\u0001": [
	"Create Flickr photo stream"
],
	"\u0000Create additional passwords with limited access\u0001": [
	"Create additional passwords with limited access"
],
	"\u0000Create all-day appointment\u0001": [
	"Create all-day appointment"
],
	"\u0000Create appointment\u0001": [
	"Create appointment"
],
	"\u0000Create category\u0001": [
	"Create category"
],
	"\u0000Create distribution list\u0001": [
	"Create distribution list"
],
	"\u0000Create folder\u0001": [
	"Create folder"
],
	"\u0000Create in public calendar\u0001": [
	"Create in public calendar"
],
	"\u0000Create list\u0001": [
	"Create list"
],
	"\u0000Create new Zoom meeting\u0001": [
	"Create new Zoom meeting"
],
	"\u0000Create new group\u0001": [
	"Create new group"
],
	"\u0000Create new resource\u0001": [
	"Create new resource"
],
	"\u0000Create new rule\u0001": [
	"Create new rule"
],
	"\u0000Create objects\u0001": [
	"Create objects"
],
	"\u0000Create objects and subfolders\u0001": [
	"Create objects and subfolders"
],
	"\u0000Create reminder\u0001": [
	"Create reminder"
],
	"\u0000Create sharing link\u0001": [
	"Create sharing link"
],
	"\u0000Create task\u0001": [
	"Create task"
],
	"\u0000Created\u0001": [
	"Created"
],
	"\u0000Created by: %1$s\u0001": [
	"Created by: %1$s"
],
	"\u0000Creating %s conference…\u0001": [
	"Creating %s conference…"
],
	"\u0000Ctrl\u0001": [
	"Ctrl"
],
	"\u0000Currency\u0001": [
	"Currency"
],
	"\u0000Current date\u0001": [
	"Current date"
],
	"\u0000Current folder\u0001": [
	"Current folder"
],
	"\u0000Current list\u0001": [
	"Current list"
],
	"\u0000Current organizer\u0001": [
	"Current organiser"
],
	"\u0000Current page\u0001": [
	"Current page"
],
	"\u0000Current role\u0001": [
	"Current role"
],
	"\u0000Currently refreshing\u0001": [
	"Currently refreshing"
],
	"\u0000Currently there are no compatible webcams available on your device.\u0001": [
	"Currently there are no compatible webcams available on your device."
],
	"\u0000Custom font size when reading unformatted mails\u0001": [
	"Custom font size when reading unformatted email messages"
],
	"\u0000Custom name\u0001": [
	"Custom name"
],
	"\u0000Customize date and time formats\u0001": [
	"Customise date and time formats"
],
	"\u0000Customize the font, size and color styles of emails you compose.\u0001": [
	"Customise the font, size and colour styles of email messages you compose."
],
	"\u0000Customized\u0001": [
	"Customised"
],
	"\u0000Cyan\u0001": [
	"Cyan"
],
	"\u0000Daily\u0001": [
	"Daily"
],
	"\u0000Daily on workdays\u0001": [
	"Daily on workdays"
],
	"\u0000Dark\u0001": [
	"Dark"
],
	"\u0000Dark Blue\u0001": [
	"Dark Blue"
],
	"\u0000Dark Gray\u0001": [
	"Dark Gray"
],
	"\u0000Dark Purple\u0001": [
	"Dark Purple"
],
	"\u0000Dark Red\u0001": [
	"Dark Red"
],
	"\u0000Dark Turquoise\u0001": [
	"Dark Turquoise"
],
	"\u0000Dark mode\u0001": [
	"Dark mode"
],
	"\u0000Dark mode is now also available on mobile devices\u0001": [
	"Dark mode is now also available on mobile devices"
],
	"\u0000Dark theme\u0001": [
	"Dark theme"
],
	"\u0000Data imported successfully\u0001": [
	"Data imported successfully"
],
	"\u0000Data only partially imported (%1$s of %2$s records)\u0001": [
	"Data only partially imported (%1$s of %2$s records)"
],
	"\u0000Date\u0001": [
	"Date"
],
	"\u0000Date completed\u0001": [
	"Date completed"
],
	"\u0000Date format\u0001": [
	"Date format"
],
	"\u0000Date must be in the future.\u0001": [
	"Date must be in the future."
],
	"\u0000Date of birth\u0001": [
	"Date of birth"
],
	"\u0000Date range\u0001": [
	"Date range"
],
	"\u0000Date: %1$s\u0001": [
	"Date: %1$s"
],
	"\u0000Day\u0001": [
	"Day"
],
	"\u0000Day view\u0001": [
	"Day view"
],
	"\u0000Days between notices to the same sender\u0001": [
	"Days between notices to the same sender"
],
	"\u0000Decline\u0001": [
	"Decline"
],
	"appointment participation status\u0000Decline\u0001": [
	"Decline"
],
	"\u0000Declined\u0001": [
	"Declined"
],
	"\u0000Declined the new participant\u0001": [
	"Declined the new participant"
],
	"\u0000Declined: %d\u0001": [
	"Declined: %d"
],
	"\u0000Default\u0001": [
	"Default"
],
	"\u0000Default address\u0001": [
	"Default address"
],
	"\u0000Default calendar\u0001": [
	"Default calendar"
],
	"\u0000Default reminder\u0001": [
	"Default reminder"
],
	"\u0000Default reminder for all day appointments\u0001": [
	"Default reminder for all day appointments"
],
	"\u0000Default reminder for all-day appointments\u0001": [
	"Default reminder for all-day appointments"
],
	"\u0000Default reminder for appointments in birthday calendar\u0001": [
	"Default reminder for appointments in birthday calendar"
],
	"\u0000Default reminder for birthdays\u0001": [
	"Default reminder for birthdays"
],
	"\u0000Default sender\u0001": [
	"Default sender"
],
	"\u0000Default sender address\u0001": [
	"Default sender address"
],
	"\u0000Default signature\u0001": [
	"Default signature"
],
	"\u0000Default signature for new mails\u0001": [
	"Default signature for new email messages"
],
	"\u0000Default signature on reply or forward\u0001": [
	"Default signature on reply or forward"
],
	"\u0000Default text style\u0001": [
	"Default text style"
],
	"\u0000Deferred\u0001": [
	"Deferred"
],
	"\u0000Define message format, default text style, undo send\u0001": [
	"Define message format, default text style, undo send"
],
	"\u0000Define name format and map service\u0001": [
	"Define name format and map service"
],
	"\u0000Define rules for handling incoming emails\u0001": [
	"Define rules for handling incoming email messages"
],
	"\u0000Define the calendar time scale\u0001": [
	"Define the calendar time scale"
],
	"\u0000Define your favorite apps\u0001": [
	"Define your favourite apps"
],
	"\u0000Delete\u0001": [
	"Delete"
],
	"\u0000Delete %1$s\u0001": [
	"Delete %1$s"
],
	"\u0000Delete Multifactor Device\u0001": [
	"Delete Multi-factor Device"
],
	"\u0000Delete account\u0001": [
	"Delete account"
],
	"\u0000Delete all appointments\u0001": [
	"Delete all appointments"
],
	"\u0000Delete all future appointments\u0001": [
	"Delete all future appointments"
],
	"\u0000Delete all messages\u0001": [
	"Delete all messages"
],
	"\u0000Delete all objects\u0001": [
	"Delete all objects"
],
	"\u0000Delete all previous versions\u0001": [
	"Delete all previous versions"
],
	"\u0000Delete appointment\u0001": [
	"Delete appointment"
],
	"\u0000Delete calendar\u0001": [
	"Delete calendar"
],
	"\u0000Delete category\u0001": [
	"Delete category"
],
	"\u0000Delete category %1$s\u0001": [
	"Delete category %1$s"
],
	"\u0000Delete contact\u0001": [
	"Delete contact"
],
	"\u0000Delete contacts\u0001": [
	"Delete contacts"
],
	"\u0000Delete distribution list\u0001": [
	"Delete distribution list"
],
	"\u0000Delete draft\u0001": [
	"Delete draft"
],
	"\u0000Delete email\u0001": [
	"Delete e-mail"
],
	"\u0000Delete files after expiration\u0001": [
	"Delete files after expiration"
],
	"\u0000Delete folder\u0001": [
	"Delete folder"
],
	"\u0000Delete forever\u0001": [
	"Delete forever"
],
	"\u0000Delete group\u0001": [
	"Delete group"
],
	"\u0000Delete item\u0001": [
	"Delete item"
],
	"\u0000Delete items\u0001": [
	"Delete items"
],
	"\u0000Delete own objects\u0001": [
	"Delete own objects"
],
	"\u0000Delete password\u0001": [
	"Delete password"
],
	"\u0000Delete permissions\u0001": [
	"Delete permissions"
],
	"\u0000Delete previous versions\u0001": [
	"Delete previous versions"
],
	"\u0000Delete resource\u0001": [
	"Delete resource"
],
	"\u0000Delete resource calendar\u0001": [
	"Delete resource calendar"
],
	"\u0000Delete resource calendar group\u0001": [
	"Delete resource calendar group"
],
	"\u0000Delete resource group\u0001": [
	"Delete resource group"
],
	"\u0000Delete rule\u0001": [
	"Delete rule"
],
	"\u0000Delete signature\u0001": [
	"Delete signature"
],
	"\u0000Delete task\u0001": [
	"Delete task"
],
	"tooltip\u0000Delete task\u0001": [
	"Delete task"
],
	"\u0000Delete tasks\u0001": [
	"Delete tasks"
],
	"\u0000Delete template\u0001": [
	"Delete template"
],
	"\u0000Delete this appointment\u0001": [
	"Delete this appointment"
],
	"\u0000Delete version\u0001": [
	"Delete version"
],
	"\u0000Delete widget\u0001": [
	"Delete widget"
],
	"\u0000Deleted a Contact? Restore It!\u0001": [
	"Deleted a Contact? Restore It!"
],
	"folder\u0000Deleted messages\u0001": [
	"Deleted messages"
],
	"\u0000Deleting messages on local storage also deletes them on server\u0001": [
	"Deleting messages on local storage also deletes them on the server"
],
	"\u0000Deletion in progress…\u0001": [
	"Deletion in progress…"
],
	"\u0000Department\u0001": [
	"Department"
],
	"\u0000Departments\u0001": [
	"Departments"
],
	"\u0000Deputies can get access to your Inbox and Calendar.\u0001": [
	"Deputies can get access to your Inbox and Calendar."
],
	"\u0000Deputy\u0001": [
	"Deputy"
],
	"\u0000Deputy can send emails on your behalf\u0001": [
	"Deputy can send email messages on your behalf"
],
	"\u0000Deputy: %1$s\u0001": [
	"Deputy: %1$s"
],
	"\u0000Descending\u0001": [
	"Descending"
],
	"\u0000Description\u0001": [
	"Description"
],
	"\u0000Description (optional)\u0001": [
	"Description (optional)"
],
	"\u0000Description has been copied\u0001": [
	"Description has been copied"
],
	"\u0000Description text\u0001": [
	"Description text"
],
	"\u0000Deselect all\u0001": [
	"Deselect all"
],
	"\u0000Desktop notifications\u0001": [
	"Desktop notifications"
],
	"\u0000Desktop notifications are a convenient feature as they can still notify you even if you have multiple tabs open in your browser. You don't necessarily have to keep %1$s as the active tab or constantly check it to stay updated.\u0001": [
	"Desktop notifications are a convenient feature as they can still notify you even if you have multiple tabs open in your browser. You do not necessarily have to keep %1$s as the active tab or constantly check it to stay updated."
],
	"\u0000Desktop only\u0001": [
	"Desktop only"
],
	"\u0000Detail\u0001": [
	"Detail"
],
	"\u0000Detailed\u0001": [
	"Detailed"
],
	"\u0000Detailed access rights\u0001": [
	"Detailed access rights"
],
	"\u0000Details\u0001": [
	"Details"
],
	"contact-print-dialog\u0000Details\u0001": [
	"Details"
],
	"\u0000Determine when and if an email is marked as read upon opening.\u0001": [
	"Determine when and if an email is marked as read upon opening."
],
	"\u0000Determine which folders are shown\u0001": [
	"Determine which folders are shown"
],
	"\u0000Device\u0001": [
	"Device"
],
	"\u0000Device is already registered\u0001": [
	"Device is already registered"
],
	"\u0000Device: %s\u0001": [
	"Device: %s"
],
	"\u0000Dial by your location\u0001": [
	"Dial by your location"
],
	"\u0000Dial-in numbers\u0001": [
	"Dial-in numbers"
],
	"\u0000Dial-in passcode: %1$d\u0001": [
	"Dial-in passcode: %1$d"
],
	"\u0000Did you know that you can take %1$s with you? Just click this icon and choose 'Connect your device' from the menu.\u0001": [
	"Did you know that you can take %1$s with you? Just click this icon and choose 'Connect your device' from the menu."
],
	"\u0000Did you know?\u0001": [
	"Did you know?"
],
	"\u0000Direct link\u0001": [
	"Direct link"
],
	"\u0000Disable\u0001": [
	"Disable"
],
	"\u0000Disable %1$s\u0001": [
	"Disable %1$s"
],
	"\u0000Disable categories\u0001": [
	"Disable categories"
],
	"\u0000Disable keyboard shortcuts\u0001": [
	"Disable keyboard shortcuts"
],
	"\u0000Disable widget\u0001": [
	"Disable widget"
],
	"\u0000Disabled\u0001": [
	"Disabled"
],
	"\u0000Discard\u0001": [
	"Discard"
],
	"\u0000Discard changes\u0001": [
	"Discard changes"
],
	"dialog\u0000Discard changes\u0001": [
	"Discard changes"
],
	"\u0000Discard mails from %1$s\u0001": [
	"Discard e-mail messages from %1$s"
],
	"\u0000Discard mails to %1$s\u0001": [
	"Discard e-mail messages to %1$s"
],
	"\u0000Discard mails with subject %1$s\u0001": [
	"Discard e-mail messages with subject %1$s"
],
	"\u0000Display name\u0001": [
	"Display name"
],
	"\u0000Displaying file: %1$s\u0001": [
	"Displaying file: %1$s"
],
	"\u0000Distance\u0001": [
	"Distance"
],
	"\u0000Distribution List\u0001": [
	"Distribution List"
],
	"\u0000Distribution List Details\u0001": [
	"Distribution List Details"
],
	"\u0000Distribution list\u0001": [
	"Distribution list"
],
	"\u0000Distribution list has been saved\u0001": [
	"Distribution list has been saved"
],
	"\u0000Distribution list with %1$d entry\u0001Distribution list with %1$d entries": [
	"Distribution list with %1$d entry",
	"Distribution list with %1$d entries"
],
	"\u0000Do not show\u0001": [
	"Do not show"
],
	"\u0000Do not show again.\u0001": [
	"Do not show again."
],
	"\u0000Do you really want to cancel the current download request?\u0001": [
	"Do you really want to cancel the current download request?"
],
	"\u0000Do you really want to change the file extension from  \".%1$s\" to \".%2$s\" ?\u0001": [
	"Do you really want to change the file extension from  \".%1$s\" to \".%2$s\"?"
],
	"\u0000Do you really want to create an appointment <b>on behalf of the folder owner</b> or do you want to create an appointment <b>with the folder owner</b> in your own calendar?\u0001": [
	"Do you really want to create an appointment <b>on behalf of the folder owner</b> or do you want to create an appointment <b>with the folder owner</b> in your own calendar?"
],
	"\u0000Do you really want to delete all previous versions except the current version?\u0001": [
	"Do you really want to delete all previous versions except the current version?"
],
	"\u0000Do you really want to delete calendar \"%s\"?\u0001": [
	"Do you really want to delete calendar \"%s\"?"
],
	"\u0000Do you really want to delete folder \"%s\"?\u0001": [
	"Do you really want to delete folder \"%s\"?"
],
	"\u0000Do you really want to delete resource calendar group \"%s\"?\u0001": [
	"Do you really want to delete resource calendar group \"%s\"?"
],
	"\u0000Do you really want to delete the category \"%s\"?\u0001": [
	"Do you really want to delete the category \"%s\"?"
],
	"\u0000Do you really want to delete the group \"%1$s\"? This action cannot be undone!\u0001": [
	"Do you really want to delete the group \"%1$s\"? This action cannot be undone!"
],
	"\u0000Do you really want to delete the resource \"%1$s\"? This action cannot be undone!\u0001": [
	"Do you really want to delete the resource \"%1$s\"? This action cannot be undone!"
],
	"\u0000Do you really want to delete the signature \"%1$s\"?\u0001": [
	"Do you really want to delete the signature \"%1$s\"?"
],
	"\u0000Do you really want to delete the template \"%1$s\"?\u0001": [
	"Do you really want to delete the template \"%1$s\"?"
],
	"\u0000Do you really want to delete these contacts?\u0001": [
	"Do you really want to delete these contacts?"
],
	"\u0000Do you really want to delete these items?\u0001": [
	"Do you really want to delete these items?"
],
	"\u0000Do you really want to delete these tasks?\u0001": [
	"Do you really want to delete these tasks?"
],
	"\u0000Do you really want to delete this account?\u0001": [
	"Do you really want to delete this account?"
],
	"\u0000Do you really want to delete this appointment?\u0001": [
	"Do you really want to delete this appointment?"
],
	"\u0000Do you really want to delete this contact?\u0001": [
	"Do you really want to delete this contact?"
],
	"\u0000Do you really want to delete this distribution list?\u0001": [
	"Do you really want to delete this distribution list?"
],
	"\u0000Do you really want to delete this item?\u0001": [
	"Do you really want to delete this item?"
],
	"\u0000Do you really want to delete this password?\u0001": [
	"Do you really want to delete this password?"
],
	"\u0000Do you really want to delete this rule?\u0001": [
	"Do you really want to delete this rule?"
],
	"\u0000Do you really want to delete this task?\u0001": [
	"Do you really want to delete this task?"
],
	"One file only\u0000Do you really want to delete this version?\u0001": [
	"Do you really want to delete this version?"
],
	"\u0000Do you really want to delete this widget?\u0001": [
	"Do you really want to delete this widget?"
],
	"\u0000Do you really want to delete this widget? If you disable it, you can enable it again in the settings.\u0001": [
	"Do you really want to delete this widget? If you disable it, you can enable it again in the settings."
],
	"\u0000Do you really want to discard all changes?\u0001": [
	"Do you really want to discard all changes?"
],
	"\u0000Do you really want to discard your changes?\u0001": [
	"Do you really want to discard your changes?"
],
	"\u0000Do you really want to empty folder \"%s\"?\u0001": [
	"Do you really want to empty folder \"%s\"?"
],
	"\u0000Do you really want to remove all shares?\u0001": [
	"Do you really want to remove all shares?"
],
	"\u0000Do you really want to remove the extension \".%1$s\" from your filename?\u0001": [
	"Do you really want to remove the extension \".%1$s\" from your filename?"
],
	"\u0000Do you really want to remove this certificate?\u0001": [
	"Do you really want to remove this certificate?"
],
	"\u0000Do you really want to sign out from all clients except the current one?\u0001": [
	"Do you really want to sign out from all clients except the current one?"
],
	"\u0000Do you really want to sign out from all devices except the current one?\u0001": [
	"Do you really want to sign out from all devices except the current one?"
],
	"\u0000Do you really want to sign out from that device?\u0001": [
	"Do you really want to sign out from that device?"
],
	"\u0000Do you want the appointments printed in detail or as a compact list?\u0001": [
	"Do you want the appointments printed in detail or as a compact list?"
],
	"\u0000Do you want to edit the whole series or just this appointment within the series?\u0001": [
	"Do you want to edit the whole series or just this appointment within the series?"
],
	"\u0000Do you want to edit this and all future appointments or just this appointment within the series?\u0001": [
	"Do you want to edit this and all future appointments or just this appointment within the series?"
],
	"\u0000Do you want to edit this and all future appointments or the whole series?\u0001": [
	"Do you want to edit this and all future appointments or the whole series?"
],
	"\u0000Do you want to forward for the whole series or just this appointment within the series?\u0001": [
	"Do you want to forward for the whole series or just this appointment within the series?"
],
	"\u0000Do you want to move all messages from %1$s to that category?\u0001": [
	"Do you want to move all messages from %1$s to that category?"
],
	"\u0000Do you want to move all messages from selected senders to that category?\u0001": [
	"Do you want to move all messages from selected senders to that category?"
],
	"\u0000Do you want to permanently delete these mails?\u0001": [
	"Do you want to permanently delete these e-mail messages?"
],
	"\u0000Do you want to permanently delete this email?\u0001": [
	"Do you want to permanently delete this e-mail?"
],
	"\u0000Do you want to remove %1$s from your deputy list?\u0001": [
	"Do you want to remove %1$s from your deputy list?"
],
	"\u0000Do you want to reply all or just %1$s?\u0001": [
	"Do you want to reply all or just %1$s?"
],
	"\u0000Do you want to revoke the access of this application?\u0001": [
	"Do you want to revoke the access of this application?"
],
	"\u0000Document\u0001": [
	"Document"
],
	"\u0000Does not exist\u0001": [
	"Does not exist"
],
	"\u0000Domain\u0001": [
	"Domain"
],
	"\u0000Don't process subsequent rules of %1$s\u0001": [
	"Do not process subsequent rules of %1$s"
],
	"\u0000Don't remind me again\u0001": [
	"Do not remind me again"
],
	"\u0000Done\u0001": [
	"Done"
],
	"\u0000Download\u0001": [
	"Download"
],
	"\u0000Download %1$s\u0001": [
	"Download %1$s"
],
	"\u0000Download %1$s for %2$s now\u0001": [
	"Download %1$s for %2$s now"
],
	"\u0000Download %1$s for Windows\u0001": [
	"Download %1$s for Windows"
],
	"\u0000Download %1$s.\u0001": [
	"Download %1$s."
],
	"\u0000Download %s\u0001": [
	"Download %s"
],
	"\u0000Download and Install\u0001": [
	"Download and Install"
],
	"\u0000Download configuration\u0001": [
	"Download configuration"
],
	"\u0000Download entire folder\u0001": [
	"Download entire folder"
],
	"\u0000Download infected file\u0001": [
	"Download infected file"
],
	"\u0000Download personal data\u0001": [
	"Download personal data"
],
	"\u0000Download profile\u0001": [
	"Download profile"
],
	"\u0000Download requested\u0001": [
	"Download requested"
],
	"\u0000Download the %1$s client for %2$s\u0001": [
	"Download the %1$s client for %2$s"
],
	"\u0000Download the application.\u0001": [
	"Download the application."
],
	"\u0000Download unscanned file\u0001": [
	"Download unscanned file"
],
	"\u0000Download your personal data\u0001": [
	"Download your personal data"
],
	"\u0000Drafts\u0001": [
	"Drafts"
],
	"folder\u0000Drafts\u0001": [
	"Drafts"
],
	"\u0000Drag to reorder items\u0001": [
	"Drag to reorder items"
],
	"\u0000Drag to reorder rules\u0001": [
	"Drag to reorder rules"
],
	"\u0000Drag to reorder widget\u0001": [
	"Drag to reorder widget"
],
	"app\u0000Drive\u0001": [
	"Drive"
],
	"\u0000Drive Client\u0001": [
	"Drive Client"
],
	"\u0000Drop EML file here for import\u0001": [
	"Drop EML file here for import"
],
	"\u0000Drop ICS or ICAL files here to import\u0001": [
	"Drop ICS or iCal files here to import"
],
	"\u0000Drop attachments here\u0001": [
	"Drop attachments here"
],
	"\u0000Drop files or folders here to upload\u0001": [
	"Drop files or folders here to upload"
],
	"\u0000Drop here\u0001": [
	"Drop here"
],
	"\u0000Drop here to import this email\u0001": [
	"Drop here to import this e-mail"
],
	"\u0000Drop here to upload a <b class=\"dndignore\">new attachment</b>\u0001": [
	"Drop here to upload a <b class=\"dndignore\">new attachment</b>"
],
	"\u0000Drop here to upload a <b class=\"dndignore\">new file</b>\u0001": [
	"Drop here to upload a <b class=\"dndignore\">new file</b>"
],
	"\u0000Drop here to upload a <b class=\"dndignore\">new version</b>\u0001": [
	"Drop here to upload a <b class=\"dndignore\">new version</b>"
],
	"\u0000Drop here to upload a <b class=\"dndignore\">new version</b> of \"%1$s\"\u0001": [
	"Drop here to upload a <b class=\"dndignore\">new version</b> of \"%1$s\""
],
	"\u0000Drop inline images here\u0001": [
	"Drop inline images here"
],
	"\u0000Drop new version of \"%1$s\" here\u0001": [
	"Drop new version of \"%1$s\" here"
],
	"\u0000Drop only a single file as new version.\u0001": [
	"Drop only a single file as new version."
],
	"\u0000Due\u0001": [
	"Due"
],
	"\u0000Due Date | %1$s\u0001": [
	"Due Date | %1$s"
],
	"\u0000Due date\u0001": [
	"Due date"
],
	"\u0000Due on %1$s\u0001": [
	"Due on %1$s"
],
	"\u0000Duration per image\u0001": [
	"Duration per image"
],
	"\u0000E-Mails will appear in a new window. These windows can be maximized, minimized and closed.\u0001": [
	"E-mail messages will appear in a new window. These windows can be maximized, minimized and closed."
],
	"\u0000EAS\u0001": [
	"EAS"
],
	"\u0000EB\u0001": [
	"EB"
],
	"\u0000Easily undo actions like delete, archive, move or copy with a single click – no stress, no hassle, just instant control.\u0001": [
	"Easily undo actions like delete, archive, move or copy with a single click – no stress, no hassle, just instant control."
],
	"\u0000Edit\u0001": [
	"Edit"
],
	"\u0000Edit %1$s\u0001": [
	"Edit %1$s"
],
	"\u0000Edit Appointment\u0001": [
	"Edit Appointment"
],
	"\u0000Edit Contact\u0001": [
	"Edit Contact"
],
	"\u0000Edit Flickr photo stream\u0001": [
	"Edit Flickr photo stream"
],
	"\u0000Edit Multifactor Device\u0001": [
	"Edit Multi-factor Device"
],
	"\u0000Edit accounts\u0001": [
	"Edit e-mail account"
],
	"\u0000Edit all future appointments\u0001": [
	"Edit all future appointments"
],
	"\u0000Edit all objects\u0001": [
	"Edit all objects"
],
	"\u0000Edit all reminders for calendar: %1$s\u0001": [
	"Edit all reminders for calendar: %1$s"
],
	"\u0000Edit appointment\u0001": [
	"Edit appointment"
],
	"\u0000Edit category\u0001": [
	"Edit category"
],
	"\u0000Edit category %1$s\u0001": [
	"Edit category %1$s"
],
	"\u0000Edit contact\u0001": [
	"Edit contact"
],
	"\u0000Edit copy\u0001": [
	"Edit copy"
],
	"\u0000Edit description\u0001": [
	"Edit description"
],
	"\u0000Edit distribution list\u0001": [
	"Edit distribution list"
],
	"\u0000Edit draft\u0001": [
	"Edit draft"
],
	"\u0000Edit email account\u0001": [
	"Edit e-mail account"
],
	"\u0000Edit group\u0001": [
	"Edit group"
],
	"\u0000Edit names\u0001": [
	"Edit names"
],
	"\u0000Edit own objects\u0001": [
	"Edit own objects"
],
	"\u0000Edit personal data\u0001": [
	"Edit personal data"
],
	"\u0000Edit real names\u0001": [
	"Edit real names"
],
	"\u0000Edit recurrence\u0001": [
	"Edit recurrence"
],
	"\u0000Edit reminders\u0001": [
	"Edit reminders"
],
	"\u0000Edit resource\u0001": [
	"Edit resource"
],
	"\u0000Edit rule\u0001": [
	"Edit rule"
],
	"\u0000Edit series\u0001": [
	"Edit series"
],
	"\u0000Edit share\u0001": [
	"Edit share"
],
	"\u0000Edit signature\u0001": [
	"Edit signature"
],
	"\u0000Edit signatures\u0001": [
	"Edit signatures"
],
	"\u0000Edit subscription\u0001": [
	"Edit subscription"
],
	"\u0000Edit task\u0001": [
	"Edit task"
],
	"\u0000Edit template\u0001": [
	"Edit template"
],
	"\u0000Edit templates\u0001": [
	"Edit templates"
],
	"\u0000Edit this appointment\u0001": [
	"Edit this appointment"
],
	"\u0000Edit to set a name.\u0001": [
	"Edit to set a name."
],
	"\u0000Editing this email will discard the sending schedule.\u0001": [
	"Editing this email will discard the sending schedule."
],
	"\u0000Editor\u0001": [
	"Editor"
],
	"\u0000Editor (create/edit appointments)\u0001": [
	"Editor (create/edit appointments)"
],
	"\u0000Editor (create/edit emails)\u0001": [
	"Editor (create/edit email messages)"
],
	"\u0000Email\u0001": [
	"Email"
],
	"\u0000Email %1$n of %2$n has been imported\u0001": [
	"Email %1$n of %2$n has been imported"
],
	"\u0000Email '%1$s' archived\u0001": [
	"Email '%1$s' archived"
],
	"\u0000Email '%1$s' deleted\u0001": [
	"Email '%1$s' deleted"
],
	"\u0000Email 1\u0001": [
	"Email 1"
],
	"\u0000Email 2\u0001": [
	"Email 2"
],
	"\u0000Email 3\u0001": [
	"Email 3"
],
	"\u0000Email account\u0001": [
	"E-mail account"
],
	"\u0000Email actions\u0001": [
	"Email actions"
],
	"\u0000Email address\u0001": [
	"E-mail address"
],
	"\u0000Email aliases\u0001": [
	"Email aliases"
],
	"\u0000Email contains external images\u0001": [
	"Email contains external images"
],
	"\u0000Email content\u0001": [
	"E-mail content"
],
	"\u0000Email copied to folder '%1$s'\u0001": [
	"Email copied to folder '%1$s'"
],
	"\u0000Email display name\u0001": [
	"Email display name"
],
	"\u0000Email from %1$s: %2$s\u0001": [
	"E-mail from %1$s: %2$s"
],
	"\u0000Email has an attachment\u0001": [
	"Email has an attachment"
],
	"\u0000Email has been copied\u0001": [
	"E-mail has been copied"
],
	"\u0000Email has been forwarded\u0001": [
	"Email has been forwarded"
],
	"\u0000Email has been imported\u0001": [
	"E-mail has been imported"
],
	"\u0000Email has been moved\u0001": [
	"E-mail has been moved"
],
	"\u0000Email has been replied\u0001": [
	"Email has been replied to"
],
	"\u0000Email has no recipient.\u0001": [
	"E-mail has no recipient."
],
	"\u0000Email list and reading pane arrangement\u0001": [
	"Email list and reading pane arrangement"
],
	"\u0000Email list item\u0001": [
	"Email list item"
],
	"\u0000Email may contain external images\u0001": [
	"Mail may contain external images"
],
	"\u0000Email moved to folder '%1$s'\u0001": [
	"Email moved to folder '%1$s'"
],
	"\u0000Email notifications\u0001": [
	"E-mail notifications"
],
	"\u0000Email reminder\u0001": [
	"E-mail reminder"
],
	"\u0000Email reminder for\u0001": [
	"E-mail reminder for"
],
	"\u0000Email size: %1$s\u0001": [
	"E-mail size: %1$s"
],
	"\u0000Email source\u0001": [
	"E-mail source"
],
	"\u0000Email subject\u0001": [
	"Email subject"
],
	"\u0000Email was not imported. Only .eml files are supported.\u0001": [
	"E-mail was not imported. Only .eml files are supported."
],
	"\u0000Email with %1$s\u0001": [
	"E-mail with %1$s"
],
	"\u0000Email with Android Mail\u0001": [
	"E-mail with Android Mail"
],
	"\u0000Emails\u0001": [
	"Email messages"
],
	"\u0000Emails (%1$s)\u0001": [
	"Email messages (%1$s)"
],
	"\u0000Emails cannot be put into trash folder while your mail quota is exceeded.\u0001": [
	"Email messages cannot be put into the trash folder while you have exceeded your mail quota."
],
	"\u0000Emails have been copied\u0001": [
	"E-mail messages have been copied"
],
	"\u0000Emails have been moved\u0001": [
	"E-mail messages have been moved"
],
	"\u0000Emoticons\u0001": [
	"Emoticons"
],
	"\u0000Employee ID\u0001": [
	"Employee ID"
],
	"\u0000Employee type\u0001": [
	"Employee type"
],
	"\u0000Empty\u0001": [
	"Empty"
],
	"vgrid\u0000Empty\u0001": [
	"Empty"
],
	"\u0000Empty file attachment\u0001": [
	"Empty file attachment"
],
	"\u0000Empty folder\u0001": [
	"Empty folder"
],
	"\u0000Empty name and description found.\u0001": [
	"Empty name and description found."
],
	"\u0000Empty subject\u0001": [
	"Empty subject"
],
	"\u0000Empty trash\u0001": [
	"Empty trash"
],
	"\u0000Enable\u0001": [
	"Enable"
],
	"\u0000Enable %1$s\u0001": [
	"Enable %1$s"
],
	"\u0000Enable Links\u0001": [
	"Enable Links"
],
	"\u0000Enable or disable auto forward\u0001": [
	"Enable or disable auto forward"
],
	"\u0000Enable or disable vacation notice\u0001": [
	"Enable or disable vacation notice"
],
	"\u0000Enable this feature\u0001": [
	"Enable this feature"
],
	"\u0000Encrypt the email\u0001": [
	"Encrypt the e-mail"
],
	"\u0000Encrypted\u0001": [
	"Encrypted"
],
	"\u0000End\u0001": [
	"End"
],
	"\u0000End date time zone\u0001": [
	"End date time zone"
],
	"\u0000End time\u0001": [
	"End time"
],
	"\u0000Ends\u0001": [
	"Ends"
],
	"\u0000Ends not with\u0001": [
	"Does not end with"
],
	"\u0000Ends on\u0001": [
	"Ends on"
],
	"\u0000Ends with\u0001": [
	"Ends with"
],
	"\u0000Enhance your email reading experience. %1$s now allows you to set custom font sizes for most emails, giving you more control and comfort.\u0001": [
	"Enhance your email reading experience. %1$s now allows you to set custom font sizes for most email messages, giving you more control and comfort."
],
	"\u0000Enter Password\u0001": [
	"Enter Password"
],
	"\u0000Enter document title here\u0001": [
	"Enter document title here"
],
	"\u0000Envelope\u0001": [
	"Envelope"
],
	"\u0000Error\u0001": [
	"Error"
],
	"\u0000Error authenticating. Please reload browser and try again.\u0001": [
	"Error authenticating. Please reload browser and try again."
],
	"\u0000Error creating meeting\u0001": [
	"Error creating meeting"
],
	"\u0000Error while playing the audio file. Either your browser does not support the format or you have connection problems.\u0001": [
	"Error while playing the audio file. Either your browser does not support the format or you have connection problems."
],
	"\u0000Error while playing the video. Either your browser does not support the format or you have connection problems.\u0001": [
	"Error while playing the video. Either your browser does not support the format or you have connection problems."
],
	"\u0000Error while resolving email addresses. Please try again.\u0001": [
	"Error while resolving e-mail addresses. Please try again."
],
	"\u0000Error while uploading your image\u0001": [
	"Error while uploading your image"
],
	"\u0000Error:\u0001": [
	"Error:"
],
	"\u0000Error: Failed to load appointments\u0001": [
	"Error: Failed to load appointments"
],
	"\u0000Error: Failed to load files\u0001": [
	"Error: Failed to load files"
],
	"\u0000Error: Failed to load message content\u0001": [
	"Error: Failed to load message content"
],
	"\u0000Error: Failed to load messages\u0001": [
	"Error: Failed to load messages"
],
	"\u0000Especially when organizing larger meetings, it is helpful to be able to designate certain participants as optional, as not everyone's attendance might be required.\u0001": [
	"Especially when organising larger meetings, it is helpful to be able to designate certain participants as optional, as not everyone's attendance might be required."
],
	"\u0000Estimated costs\u0001": [
	"Estimated costs"
],
	"\u0000Estimated duration in minutes\u0001": [
	"Estimated duration in minutes"
],
	"\u0000Europe\u0001": [
	"Europe"
],
	"daily\u0000Every %1$d day.\u0001Every %1$d days.": [
	"Every %1$d day.",
	"Every %1$d days."
],
	"monthly\u0000Every %1$d month on day %2$d.\u0001Every %1$d months on day %2$d.": [
	"Every %1$d month on day %2$d.",
	"Every %1$d months on day %2$d."
],
	"monthly\u0000Every %1$d month on the %2$s %3$s.\u0001Every %1$d months on the %2$s %3$s.": [
	"Every %1$d month on the %2$s %3$s.",
	"Every %1$d months on the %2$s %3$s."
],
	"weekly\u0000Every %1$d week on %2$s.\u0001Every %1$d weeks on %2$s.": [
	"Every %1$d week on %2$s.",
	"Every %1$d weeks on %2$s."
],
	"weekly\u0000Every %1$d week on all days.\u0001Every %1$d weeks on all days.": [
	"Every %1$d week on all days.",
	"Every %1$d weeks on all days."
],
	"weekly\u0000Every %1$d week on weekends.\u0001Every %1$d weeks on weekends.": [
	"Every %1$d week on weekends.",
	"Every %1$d weeks on weekends."
],
	"weekly\u0000Every %1$d week on workdays.\u0001Every %1$d weeks on workdays.": [
	"Every %1$d week on workdays.",
	"Every %1$d weeks on workdays."
],
	"weekly\u0000Every %1$s.\u0001": [
	"Every %1$s."
],
	"daily\u0000Every day.\u0001": [
	"Every day."
],
	"monthly\u0000Every month on day %1$d.\u0001": [
	"Every month on day %1$d."
],
	"monthly\u0000Every month on the %1$s %2$s.\u0001": [
	"Every month on the %1$s %2$s."
],
	"weekly\u0000Every weekend.\u0001": [
	"Every weekend."
],
	"\u0000Every year in %1$s on day %2$d.\u0001": [
	"Every year in %1$s on day %2$d."
],
	"\u0000Every year on the %1$s %2$s in %3$d.\u0001": [
	"Every year on the %1$s %2$s in %3$d."
],
	"\u0000Everybody\u0001": [
	"Everybody"
],
	"\u0000Exchange Active Sync\u0001": [
	"Exchange Active Sync"
],
	"\u0000Exchange Active Sync (EAS)\u0001": [
	"Exchange Active Sync (EAS)"
],
	"\u0000Existing passwords\u0001": [
	"Existing passwords"
],
	"\u0000Exists\u0001": [
	"Exists"
],
	"\u0000Expand form\u0001": [
	"Expand form"
],
	"\u0000Expanded mobile feature set\u0001": [
	"Expanded mobile feature set"
],
	"\u0000Expiration\u0001": [
	"Expiration"
],
	"\u0000Expired\u0001": [
	"Expired"
],
	"\u0000Expires on\u0001": [
	"Expires on"
],
	"\u0000Export\u0001": [
	"Export"
],
	"\u0000Export folder\u0001": [
	"Export folder"
],
	"\u0000Export selected\u0001": [
	"Export selected"
],
	"\u0000External Apps\u0001": [
	"External Apps"
],
	"\u0000External contact\u0001": [
	"External contact"
],
	"\u0000External email accounts are read-only\u0001": [
	"External email accounts are read-only"
],
	"\u0000External images are not shown to avoid potential tracking\u0001": [
	"External images are not shown to avoid potential tracking"
],
	"\u0000External images in emails\u0001": [
	"External images in email messages"
],
	"\u0000External images in this email use an insecure connection. Those images were automatically adjusted to enforce a secure connection (https). Some images might not be shown.\u0001": [
	"External images in this email use an insecure connection. Those images were automatically adjusted to enforce a secure connection (https). Some images might not be shown."
],
	"\u0000External participants\u0001": [
	"External participants"
],
	"\u0000Failed to add. Maybe the vCard attachment is invalid.\u0001": [
	"Failed to add. The vCard attachment may be invalid."
],
	"\u0000Failed to automatically save current stage of work. Please save your work to avoid data loss in case the browser closes unexpectedly.\u0001": [
	"Failed to automatically save current stage of work. Please save your work to avoid data loss in case the browser closes unexpectedly."
],
	"\u0000Failed to connect.\u0001": [
	"Failed to connect."
],
	"\u0000Failed to import any data\u0001": [
	"Failed to import any data"
],
	"\u0000Failed to recover accounts\u0001": [
	"Failed to recover accounts"
],
	"\u0000Failed to register device\u0001": [
	"Failed to register device"
],
	"\u0000Failed to register device.\u0001": [
	"Failed to register device."
],
	"\u0000Failed to save distribution list.\u0001": [
	"Failed to save distribution list."
],
	"\u0000Failed to sign in\u0001": [
	"Failed to sign in"
],
	"\u0000Failed to start application. Maybe you have connection problems. Please try again.\u0001": [
	"Failed to start application. Maybe you have connection problems. Please try again."
],
	"\u0000Failed to update confirmation status; most probably the appointment has been deleted.\u0001": [
	"Failed to update confirmation status; most likely the appointment has been deleted."
],
	"\u0000Failed to update confirmation status; most probably the task has been deleted.\u0001": [
	"Failed to update confirmation status; most likely the task has been deleted."
],
	"\u0000Failure reason\u0001": [
	"Failure reason"
],
	"\u0000Favorite\u0001": [
	"Favourite"
],
	"\u0000Favorites\u0001": [
	"Favourites"
],
	"\u0000Fax\u0001": [
	"Fax"
],
	"\u0000Fax (Home)\u0001": [
	"Fax (Home)"
],
	"\u0000Fax (alt)\u0001": [
	"Fax (alt)"
],
	"\u0000Feedback\u0001": [
	"Feedback"
],
	"\u0000Feedback could not be sent\u0001": [
	"Feedback could not be sent"
],
	"\u0000File\u0001": [
	"File"
],
	"\u0000File %1$d of %2$d\u0001": [
	"File %1$d of %2$d"
],
	"\u0000File Details\u0001": [
	"File Details"
],
	"\u0000File description can only be %1$d characters long.\u0001": [
	"File description can only be %1$d characters long."
],
	"\u0000File details\u0001": [
	"File details"
],
	"\u0000File has been copied\u0001": [
	"File has been copied"
],
	"\u0000File has been moved\u0001": [
	"File has been moved"
],
	"\u0000File into\u0001": [
	"File into"
],
	"\u0000File names must not be empty\u0001": [
	"File names must not be empty"
],
	"\u0000File names must not contain colons\u0001": [
	"File names must not contain colons"
],
	"\u0000File names must not contain slashes\u0001": [
	"File names must not contain slashes"
],
	"\u0000File or folder name\u0001": [
	"File or folder name"
],
	"\u0000File storage\u0001": [
	"File storage"
],
	"\u0000File version history\u0001": [
	"File version history"
],
	"\u0000File version limit\u0001": [
	"File version limit"
],
	"\u0000File version table, the first row represents the current version.\u0001": [
	"File version table, the first row represents the current version."
],
	"\u0000Files\u0001": [
	"Files"
],
	"\u0000Files can not be uploaded, because upload limit of %1$s is exceeded.\u0001": [
	"Files cannot be uploaded, because upload limit of %1$s has been exceeded."
],
	"\u0000Files from selected email\u0001": [
	"Files from selected email"
],
	"\u0000Files have been copied\u0001": [
	"Files have been copied"
],
	"\u0000Files have been moved\u0001": [
	"Files have been moved"
],
	"\u0000Files options\u0001": [
	"Files options"
],
	"verb\u0000Filter\u0001": [
	"Filter"
],
	"\u0000Filter address lists\u0001": [
	"Filter address lists"
],
	"\u0000Find a free time\u0001": [
	"Find a free time period"
],
	"\u0000Fingerprint\u0001": [
	"Fingerprint"
],
	"tour\u0000Finish\u0001": [
	"Finish"
],
	"\u0000Finished moving\u0001": [
	"Finished moving"
],
	"\u0000First category color is used for this appointment.\u0001": [
	"First category colour is used for this appointment."
],
	"\u0000First day\u0001": [
	"First day"
],
	"\u0000First day of the week\u0001": [
	"First day of the week"
],
	"\u0000First name\u0001": [
	"First name"
],
	"\u0000First name Last name\u0001": [
	"First name Last name"
],
	"\u0000First name must not be empty for internal users\u0001": [
	"First name must not be empty for internal users"
],
	"\u0000First start wizard\u0001": [
	"First start wizard"
],
	"\u0000First week of the year\u0001": [
	"First week of the year"
],
	"\u0000Fit to screen size\u0001": [
	"Fit to screen size"
],
	"\u0000Fit to screen width\u0001": [
	"Fit to screen width"
],
	"\u0000Flag\u0001": [
	"Flag"
],
	"verb\u0000Flag\u0001": [
	"Flag"
],
	"\u0000Flag mails from %1$s with a color\u0001": [
	"Flag e-mail messages from %1$s with a colour"
],
	"\u0000Flag mails to %1$s with a color\u0001": [
	"Flag e-mail messages to %1$s with a colour"
],
	"\u0000Flag mails with subject %1$s with a color\u0001": [
	"Flag e-mail messages with subject %1$s with a colour"
],
	"\u0000Flagged\u0001": [
	"Flagged"
],
	"\u0000Flagged folder that contains flagged emails\u0001": [
	"Flagged folder that contains flagged email messages"
],
	"\u0000Flagged messages\u0001": [
	"Flagged messages"
],
	"\u0000Flickr\u0001": [
	"Flickr"
],
	"\u0000Flowers\u0001": [
	"Flowers"
],
	"\u0000Focus search\u0001": [
	"Focus search"
],
	"\u0000Folder\u0001": [
	"Folder"
],
	"\u0000Folder has been moved\u0001": [
	"Folder has been moved"
],
	"\u0000Folder name\u0001": [
	"Folder name"
],
	"\u0000Folder names must not be empty\u0001": [
	"Folder names must not be empty"
],
	"\u0000Folder names must not contain colons\u0001": [
	"Folder names must not contain colons"
],
	"\u0000Folder names must not contain slashes\u0001": [
	"Folder names must not contain slashes"
],
	"\u0000Folder options\u0001": [
	"Folder options"
],
	"\u0000Folder view\u0001": [
	"Folder view"
],
	"\u0000Folder with name \"%1$s\" will be hidden. Enable setting \"Show hidden files and folders\" to access this folder again.\u0001": [
	"Folder with name \"%1$s\" will be hidden. Enable setting \"Show hidden files and folders\" to access this folder again."
],
	"\u0000Folder-specific actions\u0001": [
	"Folder-specific actions"
],
	"\u0000Folders\u0001": [
	"Folders"
],
	"\u0000Folders have been moved\u0001": [
	"Folders have been moved"
],
	"\u0000Follow-up\u0001": [
	"Follow-up"
],
	"\u0000Font\u0001": [
	"Font"
],
	"\u0000Font size\u0001": [
	"Font size"
],
	"\u0000Font size can be configured in %1$s\u0001": [
	"Font size can be configured in %1$s"
],
	"\u0000For best results we recommend using Google Chrome for Android.\u0001": [
	"For best results we recommend using Google Chrome for Android."
],
	"\u0000For new messages\u0001": [
	"For new messages"
],
	"\u0000For security reasons, you will be signed out from all devices after enabling multifactor.\u0001": [
	"For security reasons, you will be signed out from all devices after enabling multifactor."
],
	"\u0000Force sign-out\u0001": [
	"Force sign-out"
],
	"\u0000Forcing sign-out may cause data loss.\u0001": [
	"Forcing sign-out may cause data loss."
],
	"\u0000Forgot attachment?\u0001": [
	"Forgot attachment?"
],
	"\u0000Forgot your password?\u0001": [
	"Forgot your password?"
],
	"\u0000Format\u0001": [
	"Format"
],
	"\u0000Format: %1$s\u0001": [
	"Format: %1$s"
],
	"\u0000Formatting mails\u0001": [
	"Formatting email messages"
],
	"\u0000Forward\u0001": [
	"Forward"
],
	"\u0000Forward all incoming emails to this address\u0001": [
	"Forward all incoming email messages to this address"
],
	"\u0000Forward appointment\u0001": [
	"Forward appointment"
],
	"\u0000Forward email\u0001": [
	"Forward email"
],
	"\u0000Forward emails as\u0001": [
	"Forward email messages as"
],
	"\u0000Forward meeting invitations\u0001": [
	"Forward meeting invitations"
],
	"\u0000Free\u0001": [
	"Free"
],
	"superessive\u0000Friday\u0001": [
	"Friday"
],
	"\u0000From\u0001": [
	"From"
],
	"\u0000From:\u0001": [
	"From:"
],
	"\u0000From: %1$s\u0001": [
	"From: %1$s"
],
	"\u0000Furigana for company\u0001": [
	"Furigana for company"
],
	"\u0000Furigana for first name\u0001": [
	"Furigana for first name"
],
	"\u0000Furigana for last name\u0001": [
	"Furigana for last name"
],
	"\u0000GB\u0001": [
	"GB"
],
	"\u0000GPT/AI integration\u0001": [
	"GPT/AI integration"
],
	"\u0000General\u0001": [
	"General"
],
	"\u0000General shortcuts\u0001": [
	"General shortcuts"
],
	"\u0000Get %s\u0001": [
	"Get %s"
],
	"\u0000Get started\u0001": [
	"Get started"
],
	"\u0000Get started here\u0001": [
	"Get started here"
],
	"\u0000Get the App from %1$s\u0001": [
	"Get the App from %1$s"
],
	"\u0000Get the App from %1$s.\u0001": [
	"Get the App from %1$s."
],
	"\u0000Get the latest version from the \u0001": [
	"Get the latest version from the "
],
	"\u0000Get your device configured by email.\u0001": [
	"Get your device configured by e-mail."
],
	"\u0000Give feedback\u0001": [
	"Give feedback"
],
	"\u0000Global address list\u0001": [
	"Global address list"
],
	"\u0000Gmail\u0001": [
	"Gmail"
],
	"\u0000Go to next decade\u0001": [
	"Go to next decade"
],
	"\u0000Go to next month\u0001": [
	"Go to next month"
],
	"\u0000Go to next year\u0001": [
	"Go to next year"
],
	"\u0000Go to previous decade\u0001": [
	"Go to previous decade"
],
	"\u0000Go to previous month\u0001": [
	"Go to previous month"
],
	"\u0000Go to previous year\u0001": [
	"Go to previous year"
],
	"\u0000Good evening, %s\u0001": [
	"Good evening, %s"
],
	"\u0000Good morning, %s\u0001": [
	"Good morning, %s"
],
	"\u0000Google Authenticator\u0001": [
	"Google Authenticator"
],
	"\u0000Google Authenticator or compatible\u0001": [
	"Google Authenticator or compatible"
],
	"\u0000Google Maps\u0001": [
	"Google Maps"
],
	"\u0000Google Play\u0001": [
	"Google Play"
],
	"\u0000Google subscription\u0001": [
	"Google subscription"
],
	"\u0000Gray\u0001": [
	"Grey"
],
	"\u0000Greater\u0001": [
	"Greater"
],
	"\u0000Greater equals\u0001": [
	"Greater equals"
],
	"\u0000Green\u0001": [
	"Green"
],
	"\u0000Group\u0001": [
	"Group"
],
	"\u0000Group by\u0001": [
	"Group by"
],
	"\u0000Group members\u0001": [
	"Group members"
],
	"\u0000Group name\u0001": [
	"Group name"
],
	"\u0000Group: %1$s\u0001": [
	"Group: %1$s"
],
	"\u0000Groups\u0001": [
	"Groups"
],
	"\u0000Guest\u0001": [
	"Guest"
],
	"\u0000Guests are only allowed to have viewer rights.\u0001": [
	"Guests are only allowed to have viewer rights."
],
	"\u0000Guided tour for this app\u0001": [
	"Guided tour for this app"
],
	"\u0000Guides new users through the initial setup, ensuring a seamless onboarding experience.\u0001": [
	"Guides new users through the initial setup, ensuring a seamless onboarding experience."
],
	"\u0000HTML\u0001": [
	"HTML"
],
	"\u0000HTML and plain text\u0001": [
	"HTML and plain text"
],
	"\u0000HTML formatted emails, like newsletters, will keep their original font size.\u0001": [
	"HTML formatted email messages, like newsletters, will keep their original font size."
],
	"\u0000Has attachments\u0001": [
	"Has attachments"
],
	"\u0000Has color flag\u0001": [
	"Has colour flag"
],
	"\u0000Have you heard about ChatGPT? With our brand-new AI integration, you can now take advantage of its exceptional abilities to read and respond to emails faster, more efficiently, and with more finesse. Say goodbye to the hassle of drafting emails, and let GPT make your life easier.\u0001": [
	"Have you heard about ChatGPT? With our brand-new AI integration, you can now take advantage of its exceptional abilities to read and respond to email messages faster, more efficiently, and with more finesse. Say goodbye to the hassle of drafting email messages, and let GPT make your life easier."
],
	"\u0000Header\u0001": [
	"Header"
],
	"\u0000Hello %s\u0001": [
	"Hello %s"
],
	"\u0000Hello World\u0001": [
	"Hello World"
],
	"\u0000Help\u0001": [
	"Help"
],
	"\u0000Hidden\u0001": [
	"Hidden"
],
	"\u0000Hidden address books\u0001": [
	"Hidden address books"
],
	"\u0000Hidden calendars\u0001": [
	"Hidden calendars"
],
	"\u0000Hidden lists\u0001": [
	"Hidden lists"
],
	"\u0000Hidden tasks folders\u0001": [
	"Hidden tasks folders"
],
	"\u0000Hide\u0001": [
	"Hide"
],
	"\u0000Hide blind carbon copy input field\u0001": [
	"Hide blind carbon copy input field"
],
	"\u0000Hide carbon copy input field\u0001": [
	"Hide carbon copy input field"
],
	"\u0000Hide details\u0001": [
	"Hide details"
],
	"\u0000Hide editor toolbar\u0001": [
	"Hide editor tool bar"
],
	"\u0000Hide folder\u0001": [
	"Hide folder"
],
	"\u0000Hide non-working time\u0001": [
	"Hide non-working time"
],
	"\u0000Hide reply-to input field\u0001": [
	"Hide reply-to input field"
],
	"\u0000Hide toolbar\u0001": [
	"Hide tool bar"
],
	"\u0000High\u0001": [
	"High"
],
	"E-Mail priority\u0000High\u0001": [
	"High"
],
	"Tasks priority\u0000High\u0001": [
	"High"
],
	"\u0000High Priority\u0001": [
	"High Priority"
],
	"E-Mail\u0000High priority\u0001": [
	"High priority"
],
	"\u0000Home\u0001": [
	"Home"
],
	"\u0000Home Address\u0001": [
	"Home Address"
],
	"\u0000Home address\u0001": [
	"Home address"
],
	"\u0000Horizontal\u0001": [
	"Horizontal"
],
	"\u0000Hostname\u0001": [
	"Hostname"
],
	"\u0000How can we improve your experience?\u0001": [
	"How can we improve your experience?"
],
	"\u0000How likely are you to recommend %1$s to a friend or colleague?\u0001": [
	"How likely are you to recommend %1$s to a friend or colleague?"
],
	"\u0000How to resolve name conflicts\u0001": [
	"How to resolve name conflicts"
],
	"rating\u0000I don't like it\u0001": [
	"I don't like it"
],
	"rating\u0000I like it\u0001": [
	"I like it"
],
	"\u0000I lost my device\u0001": [
	"I lost my device"
],
	"\u0000IMAP\u0001": [
	"IMAP"
],
	"\u0000IP phone\u0001": [
	"IP phone"
],
	"\u0000IP: %s\u0001": [
	"IP: %s"
],
	"\u0000Icon\u0001": [
	"Icon"
],
	"\u0000Icons\u0001": [
	"Icons"
],
	"\u0000If a device is unfamiliar to you or you cannot explain where a session comes from, it is recommended to stop that session by clicking on \"Sign out\" in the corresponding row.\u0001": [
	"If a device is unfamiliar to you or you cannot explain where a session comes from, it is recommended that you stop that session by clicking on \"Sign out\" in the corresponding row."
],
	"\u0000If an automatic configuration is not possible, please use manual configuration to set up your email account:\u0001": [
	"If an automatic configuration is not possible, please use manual configuration to set up your email account:"
],
	"\u0000If scanning does not work, you may be able to enter the following setup code.\u0001": [
	"If scanning does not work, you may be able to enter the following setup code."
],
	"\u0000If you change the password, you will be signed out. Please ensure that everything is closed and saved.\u0001": [
	"If you change the password, you will be signed out. Please ensure that everything is closed and saved."
],
	"\u0000If you do not wish to keep an item, please click on the trash icon.\u0001": [
	"If you do not wish to keep an item, please click on the trash icon."
],
	"\u0000If you do not wish to keep the item, please click on the trash icon.\u0001": [
	"If you do not wish to keep the item, please click on the trash icon."
],
	"\u0000If you have a busy day with many meetings, it is easy to overlook a meeting. To help you stay on top of your schedule, we have added a countdown that reminds you of your upcoming meetings with color, sound, and desktop notifications.\u0001": [
	"If you have a busy day with many meetings, it is easy to overlook a meeting. To help you stay on top of your schedule, we have added a countdown that reminds you of your upcoming meetings with colour, sound, and desktop notifications."
],
	"\u0000If you have a professional Zoom account, Zoom offers dial-in numbers per country and lets you choose which countries appear in meeting invitations.\u0001": [
	"If you have a professional Zoom account, Zoom offers dial-in numbers by country and lets you choose which countries appear in meeting invitations."
],
	"\u0000If you use multiple email accounts, you can now assign individual signatures to each account.\u0001": [
	"If you use multiple email accounts, you can now assign individual signatures to each account."
],
	"\u0000Ignore\u0001": [
	"Ignore"
],
	"\u0000Ignore Warnings\u0001": [
	"Ignore Warnings"
],
	"\u0000Ignore conflicts\u0001": [
	"Ignore conflicts"
],
	"\u0000Ignore existing appointments\u0001": [
	"Ignore existing appointments"
],
	"\u0000Ignore existing events\u0001": [
	"Ignore existing events"
],
	"\u0000Ignoring existing appointments is helpful to import public holiday calendars, for example.\u0001": [
	"Ignoring existing appointments is helpful for importing public holiday calendars, for example."
],
	"\u0000Image 1\u0001": [
	"Image 1"
],
	"\u0000Image size\u0001": [
	"Image size"
],
	"\u0000Image upload denied. Its resolution exceeds maximum allowed value of %1$s megapixels.\u0001": [
	"Image upload denied. Its resolution exceeds maximum allowed value of %1$s megapixels."
],
	"\u0000Image was reset to previous image.\u0001": [
	"Image was reset to previous image."
],
	"\u0000Images\u0001": [
	"Images"
],
	"\u0000Immediately\u0001": [
	"Immediately"
],
	"\u0000Import\u0001": [
	"Import"
],
	"\u0000Import file\u0001": [
	"Import file"
],
	"\u0000Import from URL (iCal)\u0001": [
	"Import from URL (iCal)"
],
	"\u0000Import from file\u0001": [
	"Import from file"
],
	"\u0000Important\u0001": [
	"Important"
],
	"\u0000Imported calendar\u0001": [
	"Imported calendar"
],
	"\u0000Imprint\u0001": [
	"Imprint"
],
	"\u0000In %1$d minutes\u0001": [
	"In %1$d minutes"
],
	"\u0000In one hour\u0001": [
	"In one hour"
],
	"\u0000In progress\u0001": [
	"In progress"
],
	"\u0000In the event you lose or are unable to use your authentication device, your account will be locked out unless you set up a recovery method. We strongly recommend that you do so now.\u0001": [
	"In the event you lose or are unable to use your authentication device, your account will be locked out unless you set up a recovery method. We strongly recommend that you do so now."
],
	"\u0000In the next few days\u0001": [
	"In the next few days"
],
	"\u0000In the upcoming weeks\u0001": [
	"In the upcoming weeks"
],
	"\u0000Inbox\u0001": [
	"Inbox"
],
	"\u0000Inbox categories\u0001": [
	"Inbox categories"
],
	"\u0000Inbox categories now have a cleaner appearance\u0001": [
	"Inbox categories now have a cleaner appearance"
],
	"\u0000Include all file versions\u0001": [
	"Include all file versions"
],
	"\u0000Include distribution lists\u0001": [
	"Include distribution lists"
],
	"\u0000Included address books\u0001": [
	"Included address books"
],
	"\u0000Included calendars\u0001": [
	"Included calendars"
],
	"\u0000Included folders\u0001": [
	"Included folders"
],
	"\u0000Includes all appointments from your calendars as ical files.\u0001": [
	"Includes all appointments from your calendars as iCal files."
],
	"\u0000Includes all contact data from your address books as vcard files.\u0001": [
	"Includes all contact data from your address books as vCard files."
],
	"\u0000Includes all emails from your primary mail account as eml files.\u0001": [
	"Includes all e-mail messages from your primary e-mail account as EML files."
],
	"\u0000Includes all files from %1$s.\u0001": [
	"Includes all files from %1$s."
],
	"\u0000Includes all tasks as ical files.\u0001": [
	"Includes all tasks as iCal files."
],
	"\u0000Incoming Server Settings (IMAP)\u0001": [
	"Incoming Server Settings (IMAP)"
],
	"\u0000Incoming calls\u0001": [
	"Incoming calls"
],
	"\u0000Incoming server\u0001": [
	"Incoming server"
],
	"\u0000Incomplete configuration.\u0001": [
	"Incomplete configuration."
],
	"\u0000Inconsistent dates\u0001": [
	"Inconsistent dates"
],
	"\u0000Indian Ocean\u0001": [
	"Indian Ocean"
],
	"\u0000Indigo\u0001": [
	"Indigo"
],
	"\u0000Info\u0001": [
	"Info"
],
	"\u0000Inline\u0001": [
	"Inline"
],
	"\u0000Insert\u0001": [
	"Insert"
],
	"\u0000Insert image\u0001": [
	"Insert image"
],
	"\u0000Insert inline image\u0001": [
	"Insert inline image"
],
	"\u0000Insert link\u0001": [
	"Insert link"
],
	"\u0000Insert the original email text to a reply\u0001": [
	"Insert the original email text into a reply"
],
	"\u0000Inspect certificate\u0001": [
	"Inspect certificate"
],
	"\u0000Install\u0001": [
	"Install"
],
	"\u0000Install %1$s\u0001": [
	"Install %1$s"
],
	"\u0000Install %1$s like an app\u0001": [
	"Install %1$s like an app"
],
	"\u0000Installation\u0001": [
	"Installation"
],
	"\u0000Instant Messenger 1\u0001": [
	"Instant Messenger 1"
],
	"\u0000Instant Messenger 2\u0001": [
	"Instant Messenger 2"
],
	"\u0000Instructions for installing %1$s like an app\u0001": [
	"Instructions for installing %1$s like an app"
],
	"\u0000Internal user\u0001": [
	"Internal user"
],
	"\u0000Internal users only\u0001": [
	"Internal users only"
],
	"\u0000Interval\u0001": [
	"Interval"
],
	"\u0000Introducing keyboard shortcuts for a more efficient experience. With selectable presets, easily switch between Gmail and Outlook styles, streamlining your navigation and actions.\u0001": [
	"Introducing keyboard shortcuts for a more efficient experience. With selectable presets, easily switch between Gmail and Outlook styles, streamlining your navigation and actions."
],
	"\u0000Invitation for: %1$s\u0001": [
	"Invitation for: %1$s"
],
	"\u0000Invitation message (optional)\u0001": [
	"Invitation message (optional)"
],
	"\u0000Invitations\u0001": [
	"Invitations"
],
	"\u0000Invitations sent.\u0001": [
	"Invitations sent."
],
	"\u0000Invite\u0001": [
	"Invite"
],
	"\u0000Invite as: \u0001": [
	"Invite as: "
],
	"\u0000Invite options\u0001": [
	"Invite options"
],
	"\u0000Invite owner\u0001": [
	"Invite owner"
],
	"\u0000Invite participant\u0001": [
	"Invite participant"
],
	"\u0000Invite people\u0001": [
	"Invite people"
],
	"\u0000Invite to appointment\u0001": [
	"Invite to appointment"
],
	"\u0000Invite to new appointment\u0001": [
	"Invite to new appointment"
],
	"\u0000Invite to series?\u0001": [
	"Invite to series?"
],
	"\u0000Invited people only\u0001": [
	"Invited people only"
],
	"\u0000Is bigger than\u0001": [
	"Is bigger than"
],
	"\u0000Is exactly\u0001": [
	"Is exactly"
],
	"\u0000Is not exactly\u0001": [
	"Is not exactly"
],
	"\u0000Is smaller than\u0001": [
	"Is smaller than"
],
	"\u0000Issued by\u0001": [
	"Issued by"
],
	"\u0000Issued on\u0001": [
	"Issued on"
],
	"\u0000It appears as if you forgot to attach a file.\u0001": [
	"It appears as if you forgot to attach a file."
],
	"\u0000It is now possible to set how quickly an email will be marked as read. You can choose to have it marked as read immediately, after 5 seconds, after 20 seconds, or never.\u0001": [
	"It is now possible to set how quickly an email will be marked as read. You can choose to have it marked as read immediately, after 5 seconds, after 20 seconds, or never."
],
	"\u0000It looks like your current browser doesn't support the features needed to install %1$s. To use %1$s like an app, please switch to a supported browser.\u0001": [
	"It looks like your current browser does not support the features needed to install %1$s. To use %1$s like an app, please switch to a supported browser."
],
	"\u0000It may take some time until mails are assigned to the default categories.\u0001": [
	"It may take some time until e-mail messages are assigned to the default categories."
],
	"rating\u0000It's OK\u0001": [
	"It's OK"
],
	"rating\u0000It's awesome\u0001": [
	"It's awesome"
],
	"rating\u0000It's really bad\u0001": [
	"It's really bad"
],
	"\u0000Italic\u0001": [
	"Italic"
],
	"\u0000Item list\u0001": [
	"Item list"
],
	"\u0000Item list options\u0001": [
	"Item list options"
],
	"\u0000Items without a file can not be downloaded.\u0001": [
	"Items without a file can not be downloaded."
],
	"\u0000Join %s conference\u0001": [
	"Join %s conference"
],
	"\u0000Join Skype meeting\u0001": [
	"Join Skype meeting"
],
	"\u0000Join Teams Meeting\u0001": [
	"Join Teams Meeting"
],
	"\u0000Join Zoom meeting\u0001": [
	"Join Zoom meeting"
],
	"\u0000Join conference call\u0001": [
	"Join conference call"
],
	"\u0000Join with Apple Facetime\u0001": [
	"Join with Apple Facetime"
],
	"\u0000Join with Google Meet\u0001": [
	"Join with Google Meet"
],
	"\u0000Just disable widget\u0001": [
	"Disable widget"
],
	"\u0000Keep\u0001": [
	"Keep"
],
	"\u0000Keep a copy of the message\u0001": [
	"Keep a copy of the message"
],
	"\u0000Keep mails from %1$s\u0001": [
	"Keep e-mail messages from %1$s"
],
	"\u0000Keep mails to %1$s\u0001": [
	"Keep e-mail messages to %1$s"
],
	"\u0000Keep mails with subject %1$s\u0001": [
	"Keep e-mail messages with subject %1$s"
],
	"\u0000Keyboard Shortcuts\u0001": [
	"Keyboard Shortcuts"
],
	"\u0000Keyboard shortcuts\u0001": [
	"Keyboard shortcuts"
],
	"\u0000Landscape\u0001": [
	"Landscape"
],
	"\u0000Language\u0001": [
	"Language"
],
	"\u0000Language & Time zone\u0001": [
	"Language & Time zone"
],
	"\u0000Language, regional formats and time zone\u0001": [
	"Language, regional formats and time zone"
],
	"\u0000Language-specific default (%s)\u0001": [
	"Language-specific default (%s)"
],
	"\u0000Language:\u0001": [
	"Language:"
],
	"\u0000Languages\u0001": [
	"Languages"
],
	"\u0000Large\u0001": [
	"Large"
],
	"\u0000Large (%1$s px)\u0001": [
	"Large (%1$s px)"
],
	"\u0000Last Login: %s\u0001": [
	"Last Login: %s"
],
	"\u0000Last chosen date\u0001": [
	"Last chosen date"
],
	"\u0000Last name\u0001": [
	"Last name"
],
	"\u0000Last name must not be empty for internal users\u0001": [
	"Last name must not be empty for internal users"
],
	"\u0000Last name, First name\u0001": [
	"Last name, First name"
],
	"\u0000Last searched for\u0001": [
	"Last searched for"
],
	"\u0000Last updated\u0001": [
	"Last updated"
],
	"\u0000Late in the evening\u0001": [
	"Late in the evening"
],
	"\u0000Later today\u0001": [
	"Later today"
],
	"\u0000Layout\u0001": [
	"Layout"
],
	"\u0000Learn more\u0001": [
	"Learn more"
],
	"\u0000Learning\u0001": [
	"Learning"
],
	"\u0000Leave a comment for other participants\u0001": [
	"Leave a comment for other participants"
],
	"\u0000Length\u0001": [
	"Length"
],
	"\u0000Let reminders help you not to miss appointments\u0001": [
	"Let reminders help you to not miss appointments"
],
	"\u0000Let there be darkness! You can now select Dark Mode which uses bright text on a dark background as opposed to the usual black text on a bright white screen. Apart from personal preference, Dark Mode has significant benefits. A device or application using Dark Mode emits less light which improves readability in low light environments thus reducing eye strain.\u0001": [
	"Let there be darkness! You can now select Dark Mode which uses bright text on a dark background as opposed to the usual black text on a bright white screen. Apart from personal preference, Dark Mode has significant benefits. A device or application using Dark Mode emits less light which improves readability in low light environments thus reducing eye strain."
],
	"\u0000Light\u0001": [
	"Light"
],
	"\u0000Light Blue\u0001": [
	"Light Blue"
],
	"\u0000Light Gray\u0001": [
	"Light Gray"
],
	"\u0000Light Green\u0001": [
	"Light Green"
],
	"\u0000Light Purple\u0001": [
	"Light Purple"
],
	"\u0000Light Red\u0001": [
	"Light Red"
],
	"\u0000Light Yellow\u0001": [
	"Light Yellow"
],
	"\u0000Light blue\u0001": [
	"Light blue"
],
	"\u0000Light green\u0001": [
	"Light green"
],
	"\u0000Light theme\u0001": [
	"Light theme"
],
	"\u0000Link\u0001": [
	"Link"
],
	"\u0000Link expired\u0001": [
	"Link expired"
],
	"\u0000Link postal addresses with map service\u0001": [
	"Link postal addresses with map service"
],
	"\u0000Link will be sent to %1$s\u0001": [
	"Link will be sent to %1$s"
],
	"\u0000Link:\u0001": [
	"Link:"
],
	"\u0000Link: \u0001": [
	"Link: "
],
	"\u0000Links\u0001": [
	"Links"
],
	"\u0000Links have been disabled to protect you against potential spam\u0001": [
	"Links have been disabled to protect you against potential spam"
],
	"\u0000List\u0001": [
	"List"
],
	"\u0000List name\u0001": [
	"List name"
],
	"\u0000List of Groups\u0001": [
	"List of Groups"
],
	"\u0000List options\u0001": [
	"List options"
],
	"\u0000List view\u0001": [
	"List view"
],
	"\u0000Listed people only\u0001": [
	"Listed people only"
],
	"\u0000Load appointments until %1$s\u0001": [
	"Load appointments until %1$s"
],
	"\u0000Loading…\u0001": [
	"Loading…"
],
	"\u0000Local system timezone\u0001": [
	"Local system timezone"
],
	"\u0000Local-part\u0001": [
	"Local-part"
],
	"\u0000Location\u0001": [
	"Location"
],
	"\u0000Location: %s\u0001": [
	"Location: %s"
],
	"\u0000Lock\u0001": [
	"Lock"
],
	"\u0000Locked\u0001": [
	"Locked"
],
	"\u0000Login\u0001": [
	"Login"
],
	"\u0000Logout failed.\u0001": [
	"Logout failed."
],
	"\u0000Look for new data every\u0001": [
	"Look for new data every"
],
	"\u0000Low\u0001": [
	"Low"
],
	"E-Mail priority\u0000Low\u0001": [
	"Low"
],
	"Tasks priority\u0000Low\u0001": [
	"Low"
],
	"\u0000Low Priority\u0001": [
	"Low Priority"
],
	"E-Mail\u0000Low priority\u0001": [
	"Low priority"
],
	"\u0000Lower\u0001": [
	"Lower"
],
	"\u0000Lower equals\u0001": [
	"Lower equals"
],
	"\u0000MB\u0001": [
	"MB"
],
	"\u0000Mac App Store\u0001": [
	"Mac App Store"
],
	"\u0000Magenta\u0001": [
	"Magenta"
],
	"\u0000Mail\u0001": [
	"E-mail"
],
	"app\u0000Mail\u0001": [
	"E-mail"
],
	"\u0000Mail compose actions\u0001": [
	"Email compose actions"
],
	"\u0000Mail count quota\u0001": [
	"Mail count quota"
],
	"\u0000Mail layout\u0001": [
	"Email layout"
],
	"\u0000Mail quota\u0001": [
	"Mail quota"
],
	"\u0000Mail quota exceeded\u0001": [
	"Mail quota exceeded"
],
	"\u0000Mail quota limit reached. You have to use %1$s or reduce the mail size in some other way.\u0001": [
	"Email quota limit reached. You have to use %1$s or reduce the email size in some other way."
],
	"\u0000Mail storage\u0001": [
	"Mail storage"
],
	"\u0000Mail subject\u0001": [
	"Email subject"
],
	"\u0000Mailing list\u0001": [
	"Mailing list"
],
	"\u0000Mails per hour (%)\u0001": [
	"E-mail messages per hour (%)"
],
	"\u0000Mails per week-day (%)\u0001": [
	"E-mail messages per weekday (%)"
],
	"\u0000Make this the current version\u0001": [
	"Make this the current version"
],
	"\u0000Malicious file detected\u0001": [
	"Malicious file detected"
],
	"\u0000Manage Shares\u0001": [
	"Manage Shares"
],
	"\u0000Manage additional passwords for use with other devices.\u0001": [
	"Manage additional passwords for use with other devices."
],
	"\u0000Manage applications that can access your data\u0001": [
	"Manage applications that can access your data"
],
	"\u0000Manage browser permissions now\u0001": [
	"Manage browser permissions now"
],
	"\u0000Manage categories\u0001": [
	"Manage categories"
],
	"\u0000Manage deputies\u0001": [
	"Manage deputies"
],
	"\u0000Manage favorites\u0001": [
	"Manage favourites"
],
	"\u0000Manage signatures\u0001": [
	"Manage signatures"
],
	"\u0000Manage subscriptions of external data\u0001": [
	"Manage subscriptions to external data"
],
	"\u0000Manage your accounts\u0001": [
	"Manage your accounts"
],
	"\u0000Managed Resources\u0001": [
	"Managed Resources"
],
	"\u0000Managed resources is a feature that allows organizations to efficiently manage and schedule shared resources such as conference rooms and equipment. This feature helps ensure that resources are utilized effectively and efficiently, improving productivity and reducing scheduling conflicts.\u0001": [
	"Managed resources is a feature that allows organisations to efficiently manage and schedule shared resources such as conference rooms and equipment. This feature helps ensure that resources are utilised effectively and efficiently, improving productivity and reducing scheduling conflicts."
],
	"\u0000Manager\u0001": [
	"Manager"
],
	"\u0000Manual input\u0001": [
	"Manual input"
],
	"\u0000Marimba\u0001": [
	"Marimba"
],
	"\u0000Marital status\u0001": [
	"Marital status"
],
	"\u0000Mark all messages as read\u0001": [
	"Mark all messages as read"
],
	"\u0000Mark as distribution list\u0001": [
	"Mark as distribution list"
],
	"\u0000Mark as done\u0001": [
	"Mark as done"
],
	"\u0000Mark as optional\u0001": [
	"Mark as optional"
],
	"\u0000Mark as read\u0001": [
	"Mark as read"
],
	"\u0000Mark as required\u0001": [
	"Mark as required"
],
	"\u0000Mark as spam\u0001": [
	"Mark as spam"
],
	"\u0000Mark as undone\u0001": [
	"Mark as undone"
],
	"\u0000Mark as unread\u0001": [
	"Mark as unread"
],
	"\u0000Mark email as\u0001": [
	"Mark email as"
],
	"\u0000Mark email as not spam\u0001": [
	"Mark email as not spam"
],
	"\u0000Mark email as spam\u0001": [
	"Mark email as spam"
],
	"\u0000Mark mails from %1$s as deleted\u0001": [
	"Mark e-mail messages from %1$s as deleted"
],
	"\u0000Mark mails from %1$s as seen\u0001": [
	"Mark e-mail messages from %1$s as seen"
],
	"\u0000Mark mails to %1$s as deleted\u0001": [
	"Mark e-mail messages to %1$s as deleted"
],
	"\u0000Mark mails to %1$s as seen\u0001": [
	"Mark e-mail messages to %1$s as seen"
],
	"\u0000Mark mails with subject %1$s as deleted\u0001": [
	"Mark e-mail messages with subject %1$s as deleted"
],
	"\u0000Mark mails with subject %1$s as seen\u0001": [
	"Mark e-mail messages with subject %1$s as seen"
],
	"\u0000Mark participants as optional\u0001": [
	"Mark participants as optional"
],
	"\u0000Mark read\u0001": [
	"Mark read"
],
	"\u0000Mark unread\u0001": [
	"Mark unread"
],
	"\u0000Marked as favorite\u0001": [
	"Marked as favourite"
],
	"\u0000Marked as read\u0001": [
	"Marked as read"
],
	"\u0000Marked as unread\u0001": [
	"Marked as unread"
],
	"\u0000Matches\u0001": [
	"Matches"
],
	"\u0000Matches not\u0001": [
	"Does not match"
],
	"\u0000Maximize\u0001": [
	"Maximise"
],
	"\u0000Maximum file size\u0001": [
	"Maximum file size"
],
	"\u0000Maximum version count\u0001": [
	"Maximum version count"
],
	"\u0000Maybe\u0001": [
	"Maybe"
],
	"appointment participation status\u0000Maybe\u0001": [
	"Maybe"
],
	"\u0000Maybe: %d\u0001": [
	"Maybe: %d"
],
	"\u0000Medium\u0001": [
	"Medium"
],
	"Tasks priority\u0000Medium\u0001": [
	"Medium"
],
	"\u0000Medium (%1$s px)\u0001": [
	"Medium (%1$s px)"
],
	"\u0000Medium Gray\u0001": [
	"Medium Grey"
],
	"\u0000Medium Priority\u0001": [
	"Medium Priority"
],
	"\u0000Meeting\u0001": [
	"Meeting"
],
	"\u0000Meeting password: %1$s\u0001": [
	"Meeting password: %1$s"
],
	"\u0000Meeting starts now\u0001": [
	"Meeting starts now"
],
	"\u0000Meeting-ID: %1$s\u0001": [
	"Meeting-ID: %1$s"
],
	"\u0000Members\u0001": [
	"Members"
],
	"\u0000Members (%1$d)\u0001": [
	"Members (%1$d)"
],
	"\u0000Menu\u0001": [
	"Menu"
],
	"\u0000Merge\u0001": [
	"Merge"
],
	"\u0000Message\u0001": [
	"Message"
],
	"\u0000Message format\u0001": [
	"Message format"
],
	"\u0000Message moved to category \"%1$s\".\u0001": [
	"Message moved to category \"%1$s\"."
],
	"\u0000Message will be sent to all newly invited people\u0001": [
	"Message will be sent to all newly invited people"
],
	"\u0000Messages\u0001": [
	"Messages"
],
	"\u0000Messages moved to category \"%1$s\".\u0001": [
	"Messages moved to category \"%1$s\"."
],
	"\u0000Messages options\u0001": [
	"Messages options"
],
	"\u0000Messenger\u0001": [
	"Messenger"
],
	"\u0000Microphone %1$s\u0001": [
	"Microphone %1$s"
],
	"\u0000Middle name\u0001": [
	"Middle name"
],
	"\u0000Middleware version\u0001": [
	"Middleware version"
],
	"\u0000Minimize\u0001": [
	"Minimise"
],
	"\u0000Minimized windows\u0001": [
	"Minimised windows"
],
	"\u0000Minimum password length is %1$d.\u0001": [
	"Minimum password length is %1$d."
],
	"\u0000Minus\u0001": [
	"Minus"
],
	"\u0000Mobile\u0001": [
	"Mobile"
],
	"\u0000Mobile Mail\u0001": [
	"Mobile Mail"
],
	"\u0000Mobile calendar redesign\u0001": [
	"Mobile calendar redesign"
],
	"\u0000Model is incomplete.\u0001": [
	"Model is incomplete."
],
	"\u0000Modified\u0001": [
	"Modified"
],
	"superessive\u0000Monday\u0001": [
	"Monday"
],
	"\u0000Monday in %1$d weeks\u0001": [
	"Monday in %1$d weeks"
],
	"\u0000Month\u0001": [
	"Month"
],
	"\u0000Month view\u0001": [
	"Month view"
],
	"\u0000Monthly\u0001": [
	"Monthly"
],
	"\u0000More actions\u0001": [
	"More actions"
],
	"\u0000More colors! You like purple? Prefer orange? You now have the choice! We added a set of themes that covers the most common color preferences. And you can combine different background and accent colors.\u0001": [
	"More colours! You like purple? Prefer orange? You now have the choice! We added a set of themes that covers the most common colour preferences. And you can combine different background and accent colours."
],
	"\u0000More contact options\u0001": [
	"More contact options"
],
	"\u0000More message options\u0001": [
	"More message options"
],
	"\u0000More options\u0001": [
	"More options"
],
	"\u0000More search options\u0001": [
	"More search options"
],
	"\u0000Most recent attachments\u0001": [
	"Most recent attachments"
],
	"\u0000Most recent mails (%1$d)\u0001": [
	"Most recent email messages (%1$d)"
],
	"\u0000Mountains\u0001": [
	"Mountains"
],
	"\u0000Move\u0001": [
	"Move"
],
	"\u0000Move all\u0001": [
	"Move all"
],
	"\u0000Move all messages\u0001": [
	"Move all messages"
],
	"\u0000Move folder\u0001": [
	"Move folder"
],
	"\u0000Move mails from %1$s into folder %2$s\u0001": [
	"Move e-mail messages from %1$s into folder %2$s"
],
	"\u0000Move mails to %1$s into folder %2$s\u0001": [
	"Move e-mail messages to %1$s into folder %2$s"
],
	"\u0000Move mails with subject %1$s into folder %2$s\u0001": [
	"Move e-mail messages with subject %1$s into folder %2$s"
],
	"\u0000Move operation takes longer to finish\u0001": [
	"Move operation takes longer to finish"
],
	"\u0000Move to category\u0001": [
	"Move to category"
],
	"\u0000Move to folder\u0001": [
	"Move to folder"
],
	"\u0000Multiselect\u0001": [
	"Multiselect"
],
	"\u0000Music\u0001": [
	"Music"
],
	"\u0000My %1$s\u0001": [
	"My %1$s"
],
	"\u0000My %1$s account\u0001": [
	"My %1$s account"
],
	"\u0000My %1$s account (%2$d)\u0001": [
	"My %1$s account (%2$d)"
],
	"\u0000My %1$s calendar\u0001": [
	"My %1$s calendar"
],
	"\u0000My %1$s contacts\u0001": [
	"My %1$s contacts"
],
	"\u0000My Google Calendar\u0001": [
	"My Google Calendar"
],
	"\u0000My Phone\u0001": [
	"My Phone"
],
	"\u0000My account\u0001": [
	"My account"
],
	"\u0000My address books\u0001": [
	"My address books"
],
	"\u0000My address lists\u0001": [
	"My address lists"
],
	"\u0000My calendars\u0001": [
	"My calendars"
],
	"\u0000My contact data\u0001": [
	"My contact data"
],
	"\u0000My files\u0001": [
	"My files"
],
	"\u0000My folders\u0001": [
	"My folders"
],
	"\u0000My latest files\u0001": [
	"My latest files"
],
	"\u0000My lists\u0001": [
	"My lists"
],
	"\u0000My password\u0001": [
	"My password"
],
	"\u0000My shares\u0001": [
	"My shares"
],
	"\u0000My tasks\u0001": [
	"My tasks"
],
	"\u0000Name\u0001": [
	"Name"
],
	"\u0000Name Lastname\u0001": [
	"Name Lastname"
],
	"\u0000Name is already taken.\u0001": [
	"Name is already taken."
],
	"\u0000Name or email address\u0001": [
	"Name or e-mail address"
],
	"\u0000Names\u0001": [
	"Names"
],
	"\u0000Names & Addresses\u0001": [
	"Names & Addresses"
],
	"\u0000Nature\u0001": [
	"Nature"
],
	"\u0000Navigate to:\u0001": [
	"Navigate to:"
],
	"\u0000Navigation\u0001": [
	"Navigation"
],
	"\u0000Navy Blue\u0001": [
	"Navy Blue"
],
	"\u0000Need more space?\u0001": [
	"Need more space?"
],
	"\u0000Nested condition\u0001": [
	"Nested condition"
],
	"\u0000Never\u0001": [
	"Never"
],
	"\u0000Never miss a meeting\u0001": [
	"Never miss a meeting"
],
	"\u0000Never show again\u0001": [
	"Never show again"
],
	"\u0000Never used\u0001": [
	"Never used"
],
	"\u0000New\u0001": [
	"New"
],
	"\u0000New Folder\u0001": [
	"New Folder"
],
	"\u0000New Windows\u0001": [
	"New Windows"
],
	"\u0000New address book\u0001": [
	"New address book"
],
	"\u0000New appointment\u0001": [
	"New appointment"
],
	"\u0000New calendar\u0001": [
	"New calendar"
],
	"\u0000New calendar name\u0001": [
	"New calendar name"
],
	"\u0000New category\u0001": [
	"New category"
],
	"\u0000New contact\u0001": [
	"New contact"
],
	"\u0000New design\u0001": [
	"New design"
],
	"\u0000New distribution list\u0001": [
	"New distribution list"
],
	"\u0000New email\u0001": [
	"New email"
],
	"\u0000New email with attachment\u0001": [
	"New email with attachment"
],
	"\u0000New emails\u0001": [
	"New email"
],
	"\u0000New folder\u0001": [
	"New folder"
],
	"\u0000New list\u0001": [
	"New list"
],
	"\u0000New meeting\u0001": [
	"New meeting"
],
	"\u0000New note\u0001": [
	"New note"
],
	"\u0000New notification center\u0001": [
	"New notification center"
],
	"\u0000New organizer\u0001": [
	"New organiser"
],
	"\u0000New password\u0001": [
	"New password"
],
	"\u0000New resource group\u0001": [
	"New resource group"
],
	"\u0000New rule\u0001": [
	"New rule"
],
	"\u0000New search\u0001": [
	"New search"
],
	"\u0000New task\u0001": [
	"New task"
],
	"\u0000Next\u0001": [
	"Next"
],
	"\u0000Next day\u0001": [
	"Next day"
],
	"\u0000Next file\u0001": [
	"Next file"
],
	"\u0000Next message\u0001": [
	"Next message"
],
	"\u0000Next month\u0001": [
	"Next month"
],
	"\u0000Next page\u0001": [
	"Next page"
],
	"\u0000Next week\u0001": [
	"Next week"
],
	"\u0000Next year\u0001": [
	"Next year"
],
	"\u0000Nickname\u0001": [
	"Nickname"
],
	"\u0000No 2-step verification options configured yet.\u0001": [
	"No 2-step verification options configured yet."
],
	"\u0000No Priority\u0001": [
	"No Priority"
],
	"\u0000No RSS feeds found.\u0001": [
	"No RSS feeds found."
],
	"\u0000No appointment selected\u0001": [
	"No appointment selected"
],
	"\u0000No appointments\u0001": [
	"No appointments"
],
	"\u0000No appointments found until %s\u0001": [
	"No appointments found until %s"
],
	"\u0000No autocomplete entries found\u0001": [
	"No auto-complete entries found"
],
	"\u0000No birthdays within the next %1$d weeks\u0001": [
	"No birthdays within the next %1$d weeks"
],
	"\u0000No category selected\u0001": [
	"No category selected"
],
	"\u0000No color\u0001": [
	"No colour"
],
	"\u0000No connection to server. Please check your internet connection and retry.\u0001": [
	"No connection to server. Please check your internet connection and retry."
],
	"\u0000No contacts found.\u0001": [
	"No contacts found."
],
	"\u0000No elements selected\u0001": [
	"No elements selected"
],
	"\u0000No export format available\u0001": [
	"No export format available"
],
	"\u0000No files have been changed recently\u0001": [
	"No files have been changed recently"
],
	"\u0000No icon\u0001": [
	"No icon"
],
	"\u0000No items with this category found\u0001No items with these categories found": [
	"No items with this category found",
	"No items with these categories found"
],
	"\u0000No link\u0001": [
	"No link"
],
	"\u0000No location\u0001": [
	"No location"
],
	"\u0000No mails in your inbox\u0001": [
	"No email messages in your inbox"
],
	"\u0000No matching items found.\u0001": [
	"No matching items found."
],
	"\u0000No member\u0001": [
	"No member"
],
	"\u0000No members\u0001": [
	"No members"
],
	"\u0000No message selected\u0001": [
	"No message selected"
],
	"\u0000No notifications\u0001": [
	"No notifications"
],
	"\u0000No providers available\u0001": [
	"No providers available"
],
	"\u0000No recipients\u0001": [
	"No recipients"
],
	"\u0000No reminder\u0001": [
	"No reminder"
],
	"\u0000No search results\u0001": [
	"No search results"
],
	"\u0000No signature\u0001": [
	"No signature"
],
	"\u0000No subject\u0001": [
	"No subject"
],
	"\u0000No subscription services available for this module\u0001": [
	"No subscription services available for this module"
],
	"\u0000No thanks\u0001": [
	"No thanks"
],
	"\u0000Nobody\u0001": [
	"Nobody"
],
	"\u0000Non-blocking time frame\u0001": [
	"Non-blocking time frame"
],
	"\u0000None\u0001": [
	"None"
],
	"Tasks priority\u0000None\u0001": [
	"None"
],
	"\u0000None of the uploaded files matches the requested file type.\u0001": [
	"None of the uploaded files match the requested file type."
],
	"E-Mail priority\u0000Normal\u0001": [
	"Normal"
],
	"\u0000Not Regex\u0001": [
	"Not Regex"
],
	"\u0000Not flagged\u0001": [
	"Not flagged"
],
	"\u0000Not likely at all\u0001": [
	"Not likely at all"
],
	"\u0000Not spam\u0001": [
	"Not spam"
],
	"\u0000Not started\u0001": [
	"Not started"
],
	"\u0000Note\u0001": [
	"Note"
],
	"contact\u0000Note\u0001": [
	"Note"
],
	"\u0000Note on CSV files\u0001": [
	"Note on CSV files"
],
	"\u0000Note:\u0001": [
	"Note:"
],
	"\u0000Note: %1$d contact is not shown due to missing phone numbers\u0001Note: %1$d contacts are not shown due to missing phone numbers": [
	"Note: %1$d contact is not shown due to missing phone numbers",
	"Note: %1$d contacts are not shown due to missing phone numbers"
],
	"\u0000Note: Refreshing this subscription will replace the calendar content with the external content. Changes you have made inside %1$s will be overwritten.\u0001": [
	"Note: Refreshing this subscription will replace the calendar content with the external content. Changes you have made inside %1$s will be overwritten."
],
	"\u0000Notification\u0001": [
	"Notification"
],
	"\u0000Notification area\u0001": [
	"Notification area"
],
	"\u0000Notifications\u0001": [
	"Notifications"
],
	"\u0000Notifications for incoming calls\u0001": [
	"Notifications for incoming calls"
],
	"\u0000Notifications related to appointments\u0001": [
	"Notifications related to appointments"
],
	"\u0000Notifications related to emails\u0001": [
	"Notifications related to email messages"
],
	"\u0000Notifications related to tasks\u0001": [
	"Notifications related to tasks"
],
	"\u0000Notify %1$s after end.\u0001": [
	"Notify %1$s after end."
],
	"\u0000Notify %1$s after start.\u0001": [
	"Notify %1$s after start."
],
	"\u0000Notify %1$s before end.\u0001": [
	"Notify %1$s before end."
],
	"\u0000Notify %1$s before start.\u0001": [
	"Notify %1$s before start."
],
	"\u0000Notify at %1$s.\u0001": [
	"Notify at %1$s."
],
	"\u0000Notify at end.\u0001": [
	"Notify at end."
],
	"\u0000Notify at start.\u0001": [
	"Notify at start."
],
	"\u0000Now active\u0001": [
	"Now active"
],
	"\u0000Number format\u0001": [
	"Number format"
],
	"\u0000OK\u0001": [
	"OK"
],
	"native app\u0000OX Drive\u0001": [
	"OX Drive"
],
	"native app\u0000OX Mail\u0001": [
	"OX Mail"
],
	"\u0000OX Sync App\u0001": [
	"OX Sync App"
],
	"\u0000Objects\u0001": [
	"Objects"
],
	"\u0000Occurrences\u0001": [
	"Occurrences"
],
	"\u0000Ocean\u0001": [
	"Ocean"
],
	"\u0000Offline\u0001": [
	"Offline"
],
	"\u0000Ok\u0001": [
	"OK"
],
	"\u0000On %1$s %2$s wrote:\u0001": [
	"On %1$s %2$s wrote:"
],
	"\u0000On behalf of\u0001": [
	"On behalf of"
],
	"\u0000On behalf of the owner\u0001": [
	"On behalf of the owner"
],
	"\u0000On replies or forwardings\u0001": [
	"On replies or forwards"
],
	"\u0000On specific date\u0001": [
	"On specific date"
],
	"weekly\u0000On workdays.\u0001": [
	"On workdays."
],
	"\u0000Once complete, please enter an authentication code to verify everything is configured properly.\u0001": [
	"Once complete, please enter an authentication code to verify everything is configured properly."
],
	"\u0000One day\u0001": [
	"One day"
],
	"\u0000One month\u0001": [
	"One month"
],
	"\u0000One of the embedded images could not be used.\u0001": [
	"One of the embedded images could not be used."
],
	"\u0000One tap mobile (%1$s): %2$s\u0001": [
	"One tap mobile (%1$s): %2$s"
],
	"\u0000One week\u0001": [
	"One week"
],
	"\u0000One year\u0001": [
	"One year"
],
	"\u0000Online help\u0001": [
	"Online help"
],
	"\u0000Online help: %1$s\u0001": [
	"Online help: %1$s"
],
	"\u0000Only from known senders\u0001": [
	"Only from known senders"
],
	"\u0000Only numbers allowed\u0001": [
	"Only numbers allowed"
],
	"\u0000Open %1$s\u0001": [
	"Open %1$s"
],
	"\u0000Open %1$s in %2$s\u0001": [
	"Open %1$s in %2$s"
],
	"\u0000Open Drafts\u0001": [
	"Open Drafts"
],
	"\u0000Open Inbox\u0001": [
	"Open Inbox"
],
	"\u0000Open Sent\u0001": [
	"Open Sent"
],
	"\u0000Open Street Map\u0001": [
	"Open Street Map"
],
	"\u0000Open Zoom profile\u0001": [
	"Open Zoom profile"
],
	"\u0000Open attachment\u0001": [
	"Open attachment"
],
	"\u0000Open description panel\u0001": [
	"Open description panel"
],
	"\u0000Open file\u0001": [
	"Open file"
],
	"\u0000Open file. Drag to your desktop to download.\u0001": [
	"Open file. Drag to your desktop to download."
],
	"\u0000Open folder view\u0001": [
	"Open folder view"
],
	"\u0000Open in %1$s\u0001": [
	"Open in %1$s"
],
	"\u0000Open in calendar\u0001": [
	"Open in calendar"
],
	"\u0000Open in pop out viewer\u0001": [
	"Open in pop-out viewer"
],
	"\u0000Open installation instructions\u0001": [
	"Open installation instructions"
],
	"\u0000Open online help\u0001": [
	"Open online help"
],
	"\u0000Open original email in new browser tab.\u0001": [
	"Open original email in new browser tab."
],
	"\u0000Open parental control settings\u0001": [
	"Open parental control settings"
],
	"\u0000Open settings\u0001": [
	"Open settings"
],
	"\u0000Open sharing dialog\u0001": [
	"Open sharing dialogue"
],
	"\u0000Open the app on your device and enter the following information.\u0001": [
	"Open the app on your device and enter the following information."
],
	"\u0000Optional\u0001": [
	"Optional"
],
	"\u0000Optional 01\u0001": [
	"Optional 01"
],
	"\u0000Optional 02\u0001": [
	"Optional 02"
],
	"\u0000Optional 03\u0001": [
	"Optional 03"
],
	"\u0000Optional 04\u0001": [
	"Optional 04"
],
	"\u0000Optional 05\u0001": [
	"Optional 05"
],
	"\u0000Optional 06\u0001": [
	"Optional 06"
],
	"\u0000Optional 07\u0001": [
	"Optional 07"
],
	"\u0000Optional 08\u0001": [
	"Optional 08"
],
	"\u0000Optional 09\u0001": [
	"Optional 09"
],
	"\u0000Optional 10\u0001": [
	"Optional 10"
],
	"\u0000Optional 11\u0001": [
	"Optional 11"
],
	"\u0000Optional 12\u0001": [
	"Optional 12"
],
	"\u0000Optional 13\u0001": [
	"Optional 13"
],
	"\u0000Optional 14\u0001": [
	"Optional 14"
],
	"\u0000Optional 15\u0001": [
	"Optional 15"
],
	"\u0000Optional 16\u0001": [
	"Optional 16"
],
	"\u0000Optional 17\u0001": [
	"Optional 17"
],
	"\u0000Optional 18\u0001": [
	"Optional 18"
],
	"\u0000Optional 19\u0001": [
	"Optional 19"
],
	"\u0000Optional 20\u0001": [
	"Optional 20"
],
	"\u0000Options\u0001": [
	"Options"
],
	"\u0000Orange\u0001": [
	"Orange"
],
	"\u0000Organizer\u0001": [
	"Organiser"
],
	"\u0000Organizer changed\u0001": [
	"Organiser changed"
],
	"\u0000Original\u0001": [
	"Original"
],
	"\u0000Original email\u0001": [
	"Original e-mail"
],
	"\u0000Other\u0001": [
	"Other"
],
	"\u0000Other Address\u0001": [
	"Other Address"
],
	"\u0000Other address\u0001": [
	"Other address"
],
	"\u0000Our mobile feature set just got an upgrade! Now, you can enjoy even more features on your mobile device that were once exclusive to desktops. Say hello to customizable mail signatures, email formatting, reminders, move and archive functions, and even printing - all available right at your fingertips.\u0001": [
	"Our mobile feature set just got an upgrade! Now, you can enjoy even more features on your mobile device that were once exclusive to desktops. Say hello to customisable email signatures, email formatting, reminders, move and archive functions, and even printing - all available right at your fingertips."
],
	"\u0000Our newly designed notification center keeps you always up to date. Find all your appointments, reminders and birthdays at a glance.\u0001": [
	"Our newly designed notification center always keeps you up to date. Find all your appointments, reminders and birthdays at a glance."
],
	"\u0000Outgoing Server Settings (SMTP)\u0001": [
	"Outgoing Server Settings (SMTP)"
],
	"\u0000Outgoing server (SMTP)\u0001": [
	"Outgoing server (SMTP)"
],
	"\u0000Outlook.com\u0001": [
	"Outlook.com"
],
	"\u0000Overdue\u0001": [
	"Overdue"
],
	"\u0000Overdue Tasks\u0001": [
	"Overdue Tasks"
],
	"\u0000Overdue task\u0001": [
	"Overdue task"
],
	"\u0000Owner\u0001": [
	"Owner"
],
	"\u0000PB\u0001": [
	"PB"
],
	"\u0000PDF file is being created. This might take a while.\u0001": [
	"PDF file is being created. This might take a while."
],
	"\u0000PDF file was created successfully.\u0001": [
	"PDF file was created successfully."
],
	"\u0000PDFs\u0001": [
	"PDFs"
],
	"\u0000PGP signature\u0001": [
	"PGP signature"
],
	"\u0000Pacific\u0001": [
	"Pacific"
],
	"\u0000Page %1$d of %2$d\u0001": [
	"Page %1$d of %2$d"
],
	"\u0000Page %1$s\u0001": [
	"Page %1$s"
],
	"\u0000Page number\u0001": [
	"Page number"
],
	"\u0000Pager\u0001": [
	"Pager"
],
	"\u0000Part\u0001": [
	"Part"
],
	"\u0000Participant\u0001": [
	"Participant"
],
	"\u0000Participant related actions\u0001": [
	"Participant related actions"
],
	"\u0000Participants\u0001": [
	"Participants"
],
	"\u0000Participants (%1$d)\u0001": [
	"Participants (%1$d)"
],
	"\u0000Participants accept or decline appointments\u0001": [
	"Participants accept or decline appointments"
],
	"\u0000Participants accept or decline tasks\u0001": [
	"Participants accept or decline tasks"
],
	"\u0000Participants accept or decline your invitation\u0001": [
	"Participants accept or decline your invitation"
],
	"\u0000Participants and resources\u0001": [
	"Participants and resources"
],
	"\u0000Participants can make changes\u0001": [
	"Participants can make changes"
],
	"\u0000Participation\u0001": [
	"Participation"
],
	"\u0000Participation is optional\u0001": [
	"Participation is optional"
],
	"\u0000Password\u0001": [
	"Password"
],
	"\u0000Password (optional)\u0001": [
	"Password (optional)"
],
	"\u0000Password Created\u0001": [
	"Password Created"
],
	"\u0000Password length must be between %1$d and %2$d characters.\u0001": [
	"Password length must be between %1$d and %2$d characters."
],
	"\u0000Password name\u0001": [
	"Password name"
],
	"\u0000Password strength: Good\u0001": [
	"Password strength: Good"
],
	"\u0000Password strength: Legendary!\u0001": [
	"Password strength: Legendary!"
],
	"\u0000Password strength: Strong\u0001": [
	"Password strength: Strong"
],
	"\u0000Password strength: Too short\u0001": [
	"Password strength: Too short"
],
	"\u0000Password strength: Very strong\u0001": [
	"Password strength: Very strong"
],
	"\u0000Password strength: Very weak\u0001": [
	"Password strength: Very weak"
],
	"\u0000Password strength: Weak\u0001": [
	"Password strength: Weak"
],
	"\u0000Password strength: Wrong length\u0001": [
	"Password strength: Wrong length"
],
	"\u0000Password: %s\u0001": [
	"Password: %s"
],
	"\u0000Pasting images is not supported by your browser!\u0001": [
	"Pasting images is not supported by your browser!"
],
	"\u0000People\u0001": [
	"People"
],
	"\u0000Performance is slowed down by the large size of this email’s content.\u0001": [
	"Performance is slowed down by the large size of this email’s content."
],
	"\u0000Permanently remove deleted emails\u0001": [
	"Permanently remove deleted email messages"
],
	"\u0000Permissions\u0001": [
	"Permissions"
],
	"\u0000Permissions for %1$s \"%2$s\"\u0001": [
	"Permissions for %1$s \"%2$s\""
],
	"\u0000Permissions: %1$s\u0001": [
	"Permissions: %1$s"
],
	"\u0000Personal Meeting ID:\u0001": [
	"Personal Meeting ID:"
],
	"\u0000Personal information\u0001": [
	"Personal information"
],
	"\u0000Personalize the general appearance\u0001": [
	"Personalise the general appearance"
],
	"\u0000Petrol\u0001": [
	"Petrol"
],
	"\u0000Phone\u0001": [
	"Phone"
],
	"\u0000Phone (assistant)\u0001": [
	"Phone (assistant)"
],
	"\u0000Phone (business alt)\u0001": [
	"Phone (business alt)"
],
	"\u0000Phone (business)\u0001": [
	"Phone (business)"
],
	"\u0000Phone (car)\u0001": [
	"Phone (car)"
],
	"\u0000Phone (company)\u0001": [
	"Phone (company)"
],
	"\u0000Phone (home alt)\u0001": [
	"Phone (home alt)"
],
	"\u0000Phone (home)\u0001": [
	"Phone (home)"
],
	"\u0000Phone (other)\u0001": [
	"Phone (other)"
],
	"\u0000Phone list\u0001": [
	"Phone list"
],
	"\u0000Phone number\u0001": [
	"Phone number"
],
	"\u0000Photos and images\u0001": [
	"Photos and images"
],
	"\u0000Pick a date and time\u0001": [
	"Pick a date and time"
],
	"\u0000Pink\u0001": [
	"Pink"
],
	"\u0000Places\u0001": [
	"Places"
],
	"\u0000Plain Text\u0001": [
	"Plain Text"
],
	"\u0000Plain text\u0001": [
	"Plain text"
],
	"\u0000Play audio\u0001": [
	"Play audio"
],
	"\u0000Play ringtone\u0001": [
	"Play ringtone"
],
	"\u0000Play sound %1$s after end.\u0001": [
	"Play sound %1$s after end."
],
	"\u0000Play sound %1$s after start.\u0001": [
	"Play sound %1$s after start."
],
	"\u0000Play sound %1$s before end.\u0001": [
	"Play sound %1$s before end."
],
	"\u0000Play sound %1$s before start.\u0001": [
	"Play sound %1$s before start."
],
	"\u0000Play sound at %1$s.\u0001": [
	"Play sound at %1$s."
],
	"\u0000Play sound at end.\u0001": [
	"Play sound at end."
],
	"\u0000Play sound at start.\u0001": [
	"Play sound at start."
],
	"\u0000Play sound on incoming email\u0001": [
	"Play sound on incoming e-mail"
],
	"\u0000Please check your browser settings and enable desktop notifications for this domain\u0001": [
	"Please check your browser settings and enable desktop notifications for this domain"
],
	"\u0000Please choose your email account provider.\u0001": [
	"Please choose your e-mail account provider."
],
	"\u0000Please click \"Continue\" if you'd like to continue editing.\u0001": [
	"Please click \"Continue\" if you would like to continue editing."
],
	"\u0000Please comment your confirmation status.\u0001": [
	"Please comment on your confirmation status."
],
	"\u0000Please confirm\u0001": [
	"Please confirm"
],
	"\u0000Please define at least one action.\u0001": [
	"Please define at least one action."
],
	"\u0000Please download the configuration to automatically set up your account.\u0001": [
	"Please download the configuration to automatically set up your account."
],
	"\u0000Please download the file using the button below.\u0001": [
	"Please download the file using the button below."
],
	"\u0000Please enter a date in the past\u0001": [
	"Please enter a date in the past"
],
	"\u0000Please enter a description\u0001": [
	"Please enter a description"
],
	"\u0000Please enter a feed URL.\u0001": [
	"Please enter a feed URL."
],
	"\u0000Please enter a name.\u0001": [
	"Please enter a name."
],
	"\u0000Please enter a positive whole number\u0001": [
	"Please enter a positive whole number"
],
	"\u0000Please enter a search query\u0001": [
	"Please enter a search query"
],
	"\u0000Please enter a valid date\u0001": [
	"Please enter a valid date"
],
	"\u0000Please enter a valid email address\u0001": [
	"Please enter a valid email address"
],
	"\u0000Please enter a valid name\u0001": [
	"Please enter a valid name"
],
	"\u0000Please enter a valid number\u0001": [
	"Please enter a valid number"
],
	"\u0000Please enter a valid object\u0001": [
	"Please enter a valid object"
],
	"\u0000Please enter a valid phone number. Allowed characters are: %1$s\u0001": [
	"Please enter a valid phone number. Allowed characters are: %1$s"
],
	"\u0000Please enter a value\u0001": [
	"Please enter a value"
],
	"\u0000Please enter correct password\u0001": [
	"Please enter the correct password"
],
	"\u0000Please enter password.\u0001": [
	"Please enter password."
],
	"\u0000Please enter the following data: %1$s\u0001": [
	"Please enter the following data: %1$s"
],
	"\u0000Please enter the password.\u0001": [
	"Please enter the password."
],
	"\u0000Please enter the phone number for the device.\u0001": [
	"Please enter the phone number for the device."
],
	"\u0000Please enter the recovery code\u0001": [
	"Please enter the recovery code"
],
	"\u0000Please enter the same password.\u0001": [
	"Please enter the same password."
],
	"\u0000Please enter the validation code we just sent to your device.\u0001": [
	"Please enter the validation code we just sent to your device."
],
	"\u0000Please enter value between 0 and 100.\u0001": [
	"Please enter value between 0 and 100."
],
	"\u0000Please enter your credentials.\u0001": [
	"Please enter your credentials."
],
	"\u0000Please enter your email address associated with %1$s. You will receive an email that contains a link to reset your password.\u0001": [
	"Please enter your e-mail address associated with %1$s. You will receive an e-mail that contains a link to reset your password."
],
	"\u0000Please enter your mobile phone number, and we´ll send you a link to automatically configure your iOS device! It´s that simple!\u0001": [
	"Please enter your mobile phone number, and we will send you a link to automatically configure your iOS device! It´s that simple!"
],
	"\u0000Please enter your new password.\u0001": [
	"Please enter your new password."
],
	"\u0000Please enter your password.\u0001": [
	"Please enter your password."
],
	"\u0000Please grant access to your webcam first.\u0001": [
	"Please grant access to your webcam first."
],
	"\u0000Please insert a date after the start date\u0001": [
	"Please insert a date after the start date"
],
	"\u0000Please note that other participants are removed on calendar import.\u0001": [
	"Please note that other participants are removed on calendar import."
],
	"\u0000Please note that some categories are predefined and you might not be able to rename or disable them.\u0001": [
	"Please note that some categories are predefined and you might not be able to rename or disable them."
],
	"\u0000Please note that support requests cannot be handled via the feedback form. If you have questions or problems please contact our support directly.\u0001": [
	"Please note that support requests cannot be handled via the feedback form. If you have questions or problems please contact our support directly."
],
	"\u0000Please note, changing or removing the file extension will cause problems when viewing or editing.\u0001": [
	"Please note, changing or removing the file extension will cause problems when viewing or editing."
],
	"\u0000Please note: After downloading you will have to enable the profile in the Settings app to complete the installation.\u0001": [
	"Please note: After downloading you will have to enable the profile in the Settings app to complete the installation."
],
	"\u0000Please only drop images here. If you want to send other files, you can send them as attachments.\u0001": [
	"Please only drop images here. If you want to send other files, you can send them as attachments."
],
	"\u0000Please only use numeric characters for phone number\u0001": [
	"Please only use numeric characters for phone number"
],
	"\u0000Please rate the following application:\u0001": [
	"Please rate the following application:"
],
	"\u0000Please rate this product\u0001": [
	"Please rate this product"
],
	"\u0000Please scan this code with your phone's camera:\u0001": [
	"Please scan this code with your phone's camera:"
],
	"\u0000Please select a device to use for additional authentication\u0001": [
	"Please select a device to use for additional authentication"
],
	"\u0000Please select a file to import\u0001": [
	"Please select a file to import"
],
	"\u0000Please select a rating.\u0001": [
	"Please select a rating."
],
	"\u0000Please select a time for the appointment\u0001": [
	"Please select a time for the appointment"
],
	"\u0000Please select a valid iCal file to import\u0001": [
	"Please select a valid iCal file to import"
],
	"\u0000Please select a valid image file to insert\u0001": [
	"Please select a valid image file to insert"
],
	"\u0000Please select at least one day\u0001": [
	"Please select at least one day"
],
	"\u0000Please select the folder to apply the rule to\u0001": [
	"Please select the folder to apply the rule to"
],
	"\u0000Please select the platform of your device.\u0001": [
	"Please select the platform of your device."
],
	"\u0000Please set day and month properly\u0001": [
	"Please set day and month properly"
],
	"\u0000Please sign in again to continue\u0001": [
	"Please sign in again to continue"
],
	"\u0000Please touch/activate your device\u0001": [
	"Please touch/activate your device"
],
	"\u0000Please try to add your email address <b>%1$s</b> to your email client to check if it can be automatically configured.\u0001": [
	"Please try to add your email address <b>%1$s</b> to your email client to check if it can be automatically configured."
],
	"\u0000Please use the \"Connect your device\" wizard to download %s\u0001": [
	"Please use the \"Connect your device\" wizard to download %s"
],
	"\u0000Please wait for the previous operation to finish\u0001": [
	"Please wait for the previous operation to finish"
],
	"\u0000Plus\u0001": [
	"Plus"
],
	"\u0000Pop out standalone viewer\u0001": [
	"Pop out standalone viewer"
],
	"\u0000Port\u0001": [
	"Port"
],
	"\u0000Portal\u0001": [
	"Portal"
],
	"app\u0000Portal\u0001": [
	"Portal"
],
	"\u0000Portal Widgets\u0001": [
	"Portal Widgets"
],
	"\u0000Portal widgets\u0001": [
	"Portal widgets"
],
	"\u0000Position\u0001": [
	"Position"
],
	"\u0000Position %s\u0001": [
	"Position %s"
],
	"\u0000Postal addresses might appear in address book entries as well as in the appointment location field.\u0001": [
	"Postal addresses might appear in address book entries as well as in the appointment location field."
],
	"\u0000Postcode\u0001": [
	"Postcode"
],
	"\u0000PowerDNS parental control\u0001": [
	"PowerDNS parental control"
],
	"\u0000Premium\u0001": [
	"Premium"
],
	"\u0000Presentations\u0001": [
	"Presentations"
],
	"\u0000Press ENTER\u0001": [
	"Press ENTER"
],
	"\u0000Press [enter] to jump to %1$s\u0001": [
	"Press [Enter] to jump to %1$s"
],
	"\u0000Press [enter] to jump to the flicker stream.\u0001": [
	"Press [Enter] to jump to the Flickr stream."
],
	"\u0000Press [enter] to jump to the rss stream.\u0001": [
	"Press [Enter] to jump to the RSS stream."
],
	"\u0000Press enter to play\u0001": [
	"Press enter to play"
],
	"\u0000Press spacebar to grab and re-order. Press backspace to delete.\u0001": [
	"Press spacebar to grab and re-order. Press backspace to delete."
],
	"\u0000Press to open Details\u0001": [
	"Press to open Details"
],
	"\u0000Preview\u0001": [
	"Preview"
],
	"\u0000Preview generated. Downloading the file.\u0001": [
	"Preview generated. Downloading the file."
],
	"\u0000Previous\u0001": [
	"Previous"
],
	"\u0000Previous day\u0001": [
	"Previous day"
],
	"\u0000Previous file\u0001": [
	"Previous file"
],
	"\u0000Previous message\u0001": [
	"Previous message"
],
	"\u0000Previous month\u0001": [
	"Previous month"
],
	"\u0000Previous page\u0001": [
	"Previous page"
],
	"\u0000Previous week\u0001": [
	"Previous week"
],
	"\u0000Previous year\u0001": [
	"Previous year"
],
	"\u0000Previously exclusive to desktop, the year view is now also available when using your mobile device!\u0001": [
	"Previously exclusive to desktop, the year view is now also available when using your mobile device!"
],
	"\u0000Primary account\u0001": [
	"Primary account"
],
	"\u0000Print\u0001": [
	"Print"
],
	"\u0000Print as PDF\u0001": [
	"Print as PDF"
],
	"\u0000Print preview\u0001": [
	"Print preview"
],
	"\u0000Print tasks\u0001": [
	"Print tasks"
],
	"\u0000Printout\u0001": [
	"Printout"
],
	"\u0000Priority\u0001": [
	"Priority"
],
	"E-Mail\u0000Priority\u0001": [
	"Priority"
],
	"Tasks\u0000Priority\u0001": [
	"Priority"
],
	"\u0000Privacy Policy\u0001": [
	"Privacy Policy"
],
	"\u0000Private\u0001": [
	"Private"
],
	"\u0000Private contact\u0001": [
	"Private contact"
],
	"\u0000Private link: Only people who have access to the file/folder can use it. Use it to point to members of your organization to this file/folder.\u0001": [
	"Private link: Only people who have access to the file/folder can use it. Use it to point to members of your organisation to this file/folder."
],
	"\u0000Problem getting 2-step verification providers\u0001": [
	"Problem getting 2-step verification providers"
],
	"\u0000Problem registering device\u0001": [
	"Problem registering device"
],
	"\u0000Process subsequent rules\u0001": [
	"Process subsequent rules"
],
	"\u0000Process subsequent rules of %1$s\u0001": [
	"Process subsequent rules of %1$s"
],
	"\u0000Profession\u0001": [
	"Profession"
],
	"\u0000Progress\u0001": [
	"Progress"
],
	"\u0000Progress %1$s %\u0001": [
	"Progress %1$s %"
],
	"\u0000Progress in %\u0001": [
	"Progress in %"
],
	"\u0000Progress must be a valid number between 0 and 100\u0001": [
	"Progress must be a valid number between 0 and 100"
],
	"\u0000Properties\u0001": [
	"Properties"
],
	"\u0000Public\u0001": [
	"Public"
],
	"\u0000Public address books\u0001": [
	"Public address books"
],
	"\u0000Public address lists\u0001": [
	"Public address lists"
],
	"\u0000Public calendars\u0001": [
	"Public calendars"
],
	"\u0000Public folders\u0001": [
	"Public folders"
],
	"\u0000Public link\u0001": [
	"Public link"
],
	"\u0000Public link options\u0001": [
	"Public link options"
],
	"\u0000Public lists\u0001": [
	"Public lists"
],
	"\u0000Public photos by user\u0001": [
	"Public photos by user"
],
	"\u0000Public tasks folders\u0001": [
	"Public tasks folders"
],
	"\u0000Purple\u0001": [
	"Purple"
],
	"\u0000QR code expired\u0001": [
	"QR code expired"
],
	"\u0000QR code will expire in %1$ds\u0001": [
	"QR code will expire in %1$ds"
],
	"\u0000Quick launch bar\u0001": [
	"Quick launch bar"
],
	"\u0000Quota\u0001": [
	"Quota"
],
	"compose\u0000RE\u0001": [
	"RE"
],
	"\u0000RSS Feed\u0001": [
	"RSS Feed"
],
	"\u0000RSS Feeds\u0001": [
	"RSS Feeds"
],
	"\u0000Read all objects\u0001": [
	"Read all objects"
],
	"\u0000Read and write\u0001": [
	"Read and write"
],
	"\u0000Read only\u0001": [
	"Read only"
],
	"\u0000Read own objects\u0001": [
	"Read own objects"
],
	"\u0000Read permissions\u0001": [
	"Read permissions"
],
	"\u0000Read, write and delete\u0001": [
	"Read, write and delete"
],
	"\u0000Reading\u0001": [
	"Reading"
],
	"\u0000Reading pane\u0001": [
	"Reading pane"
],
	"\u0000Reauthentication required for this action\u0001": [
	"Re-authentication required for this action"
],
	"\u0000Reauthorize\u0001": [
	"Reauthorise"
],
	"\u0000Receive notification when someone accesses the file(s)\u0001": [
	"Receive notification when someone accesses the file(s)"
],
	"\u0000Receive notification when someone finished downloading file(s)\u0001": [
	"Receive notification when someone finished downloading file(s)"
],
	"\u0000Receive notification when the link expires\u0001": [
	"Receive notification when the link expires"
],
	"\u0000Receive notifications when a participant accepted or declined a task created by you\u0001": [
	"Receive notifications when a participant accepted or declined a task created by you"
],
	"\u0000Receive notifications when a participant accepted or declined a task in which you participate\u0001": [
	"Receive notifications when a participant accepted or declined a task in which you participate"
],
	"\u0000Receive notifications when a task in which you participate is created, modified or deleted\u0001": [
	"Receive notifications when a task in which you participate is created, modified or deleted"
],
	"\u0000Received\u0001": [
	"Received"
],
	"\u0000Received mails\u0001": [
	"Received mails"
],
	"\u0000Recent conversations\u0001": [
	"Recent conversations"
],
	"\u0000Recent files\u0001": [
	"Recent files"
],
	"\u0000Recently changed files\u0001": [
	"Recently changed files"
],
	"\u0000Recently used\u0001": [
	"Recently used"
],
	"\u0000Recipient\u0001": [
	"Recipient"
],
	"\u0000Recover\u0001": [
	"Recover"
],
	"\u0000Recover external account passwords\u0001": [
	"Recover external account passwords"
],
	"\u0000Recovery Code\u0001": [
	"Recovery Code"
],
	"\u0000Recovery Options\u0001": [
	"Recovery Options"
],
	"\u0000Recovery code\u0001": [
	"Recovery code"
],
	"\u0000Recovery code must be 32 characters long.\u0001": [
	"Recovery code must be 32 characters long."
],
	"\u0000Recurring tasks need a valid due date.\u0001": [
	"Recurring tasks need a valid due date."
],
	"\u0000Recurring tasks need a valid start date.\u0001": [
	"Recurring tasks need a valid start date."
],
	"\u0000Red\u0001": [
	"Red"
],
	"\u0000Redirect mails from %1$s to %2$s\u0001": [
	"Redirect e-mail messages from %1$s to %2$s"
],
	"\u0000Redirect mails to %1$s to %2$s\u0001": [
	"Redirect e-mail messages to %1$s to %2$s"
],
	"\u0000Redirect mails with subject %1$s to %2$s\u0001": [
	"Redirect e-mail messages with subject %1$s to %2$s"
],
	"\u0000Redirect to\u0001": [
	"Redirect to"
],
	"\u0000Reduce to widget summary on smartphones\u0001": [
	"Reduce to widget summary on smartphones"
],
	"\u0000Refresh\u0001": [
	"Refresh"
],
	"\u0000Refresh folders\u0001": [
	"Refresh folders"
],
	"\u0000Refresh rate in minutes\u0001": [
	"Refresh rate in minutes"
],
	"\u0000Refresh this calendar\u0001": [
	"Refresh this calendar"
],
	"\u0000Refresh. Current interval (%1$s min) can be customized in settings.\u0001": [
	"Refresh. Current interval (%1$s min) can be customised in settings."
],
	"\u0000Refreshing calendar might take some time…\u0001": [
	"Refreshing calendar might take some time…"
],
	"\u0000Regex\u0001": [
	"Regex"
],
	"\u0000Regional settings\u0001": [
	"Regional settings"
],
	"\u0000Register now\u0001": [
	"Register now"
],
	"\u0000Registered phone number:\u0001": [
	"Registered phone number:"
],
	"\u0000Reject changes\u0001": [
	"Reject changes"
],
	"\u0000Reject mails from %1$s with reason %2$s\u0001": [
	"Reject e-mail messages from %1$s with reason %2$s"
],
	"\u0000Reject mails to %1$s with reason %2$s\u0001": [
	"Reject e-mail messages to %1$s with reason %2$s"
],
	"\u0000Reject mails with subject %1$s with reason %2$s\u0001": [
	"Reject e-mail messages with subject %1$s with reason %2$s"
],
	"\u0000Reject participant\u0001": [
	"Reject participant"
],
	"\u0000Reject with reason\u0001": [
	"Reject with reason"
],
	"\u0000Reload\u0001": [
	"Reload"
],
	"\u0000Reload QR code\u0001": [
	"Reload QR code"
],
	"\u0000Reload now\u0001": [
	"Reload now"
],
	"\u0000Reload page\u0001": [
	"Reload page"
],
	"\u0000Remaining time: %1$s\u0001": [
	"Remaining time: %1$s"
],
	"\u0000Remind me\u0001": [
	"Remind me"
],
	"\u0000Remind me again\u0001": [
	"Remind me again"
],
	"\u0000Remind me later\u0001": [
	"Remind me later"
],
	"\u0000Reminder\u0001": [
	"Reminder"
],
	"\u0000Reminder %1$d\u0001": [
	"Reminder %1$d"
],
	"\u0000Reminder date\u0001": [
	"Reminder date"
],
	"\u0000Reminder for appointment %1$s.\u0001": [
	"Reminder for appointment %1$s."
],
	"\u0000Reminder for task %1$s.\u0001": [
	"Reminder for task %1$s."
],
	"\u0000Reminder for: %1$s\u0001": [
	"Reminder for: %1$s"
],
	"\u0000Reminder has been created\u0001": [
	"Reminder has been created"
],
	"\u0000Reminders\u0001": [
	"Reminders"
],
	"\u0000Remove\u0001": [
	"Remove"
],
	"\u0000Remove %1$s\u0001": [
	"Remove %1$s"
],
	"\u0000Remove Appointment\u0001": [
	"Remove Appointment"
],
	"\u0000Remove IMAP keyword\u0001": [
	"Remove IMAP keyword"
],
	"\u0000Remove account\u0001": [
	"Remove account"
],
	"\u0000Remove all shares\u0001": [
	"Remove all shares"
],
	"\u0000Remove attachment \"%1$s\"\u0001": [
	"Remove attachment \"%1$s\""
],
	"\u0000Remove category %s\u0001": [
	"Remove category %s"
],
	"\u0000Remove certificate\u0001": [
	"Remove certificate"
],
	"\u0000Remove certificate %1$s\u0001": [
	"Remove certificate %1$s"
],
	"\u0000Remove contact\u0001": [
	"Remove contact"
],
	"\u0000Remove contact from selection\u0001": [
	"Remove contact from selection"
],
	"\u0000Remove copy from server after retrieving a message\u0001": [
	"Remove copy from server after retrieving a message"
],
	"\u0000Remove deputy %1$s\u0001": [
	"Remove deputy %1$s"
],
	"\u0000Remove filter \"%1$s %2$s\"\u0001": [
	"Remove filter \"%1$s %2$s\""
],
	"\u0000Remove from %1$s\u0001": [
	"Remove from %1$s"
],
	"\u0000Remove from favorites\u0001": [
	"Remove from favourites"
],
	"\u0000Remove member\u0001": [
	"Remove member"
],
	"\u0000Remove passwords\u0001": [
	"Remove passwords"
],
	"\u0000Remove photo\u0001": [
	"Remove photo"
],
	"\u0000Remove reminder\u0001": [
	"Remove reminder"
],
	"\u0000Remove resource calendar\u0001": [
	"Remove resource calendar"
],
	"\u0000Remove shares\u0001": [
	"Remove shares"
],
	"\u0000Removed %1$s, %2$s.\u0001": [
	"Removed %1$s, %2$s."
],
	"\u0000Removed %1$s.\u0001": [
	"Removed %1$s."
],
	"\u0000Rename\u0001": [
	"Rename"
],
	"\u0000Rename File\u0001": [
	"Rename File"
],
	"\u0000Rename automatically and keep both files separately\u0001": [
	"Rename automatically and keep both files separately"
],
	"\u0000Rename folder\u0001": [
	"Rename folder"
],
	"\u0000Rename resource group\u0001": [
	"Rename resource group"
],
	"\u0000Repeat\u0001": [
	"Repeat"
],
	"\u0000Repeat by\u0001": [
	"Repeat by"
],
	"\u0000Repeat new password\u0001": [
	"Repeat new password"
],
	"\u0000Repeat slideshow\u0001": [
	"Repeat slideshow"
],
	"\u0000Reply\u0001": [
	"Reply"
],
	"\u0000Reply To\u0001": [
	"Reply To"
],
	"compose\u0000Reply To\u0001": [
	"Reply To"
],
	"\u0000Reply all\u0001": [
	"Reply all"
],
	"\u0000Reply to\u0001": [
	"Reply to"
],
	"\u0000Reply to all recipients\u0001": [
	"Reply to all recipients"
],
	"\u0000Reply to email\u0001": [
	"Reply to email"
],
	"\u0000Reply to sender\u0001": [
	"Reply to sender"
],
	"\u0000Request Appointment\u0001": [
	"Request Appointment"
],
	"\u0000Request download\u0001": [
	"Request download"
],
	"\u0000Request new download\u0001": [
	"Request new download"
],
	"\u0000Request read receipt\u0001": [
	"Request read receipt"
],
	"\u0000Requesting device information. Please wait…\u0001": [
	"Requesting device information. Please wait…"
],
	"\u0000Resend invitation\u0001": [
	"Resend invitation"
],
	"\u0000Resent-From\u0001": [
	"Resent-From"
],
	"\u0000Resent-To\u0001": [
	"Resent-To"
],
	"\u0000Reservation for: %1$s\u0001": [
	"Reservation for: %1$s"
],
	"\u0000Reservation not possible in the past\u0001": [
	"Reservation not possible in the past"
],
	"\u0000Reserved\u0001": [
	"Reserved"
],
	"\u0000Reset\u0001": [
	"Reset"
],
	"\u0000Reset password\u0001": [
	"Reset password"
],
	"\u0000Reset this list\u0001": [
	"Reset this list"
],
	"\u0000Resource\u0001": [
	"Resource"
],
	"\u0000Resource booking request\u0001": [
	"Resource booking request"
],
	"\u0000Resource booking request for: %1$s\u0001": [
	"Resource booking request for: %1$s"
],
	"\u0000Resource booking requests\u0001": [
	"Resource booking requests"
],
	"\u0000Resource calendar group name\u0001": [
	"Resource calendar group name"
],
	"\u0000Resource delegates\u0001": [
	"Resource delegates"
],
	"\u0000Resource delegates manually accept or decline the booking request.\u0001": [
	"Resource delegates manually accept or decline the booking request."
],
	"\u0000Resource group\u0001": [
	"Resource group"
],
	"\u0000Resource list\u0001": [
	"Resource list"
],
	"\u0000Resources\u0001": [
	"Resources"
],
	"\u0000Restart initial setup\u0001": [
	"Restart initial setup"
],
	"\u0000Restore\u0001": [
	"Restore"
],
	"\u0000Restore contact\u0001": [
	"Restore contact"
],
	"\u0000Restore draft\u0001": [
	"Restore draft"
],
	"\u0000Restored into folder:\n\n%s\u0001": [
	"Restored into folder:\n\n%s"
],
	"\u0000Restored into multiple folders:\n\n%s\u0001": [
	"Restored into multiple folders:\n\n%s"
],
	"\u0000Restrict showing external images to reduce tracking\u0001": [
	"Restrict showing external images to reduce tracking"
],
	"\u0000Retry\u0001": [
	"Retry"
],
	"\u0000Reviewer\u0001": [
	"Reviewer"
],
	"\u0000Revoke\u0001": [
	"Revoke"
],
	"\u0000Revoke access\u0001": [
	"Revoke access"
],
	"\u0000Rich Text Area. Press ALT-F10 for toolbar\u0001": [
	"Rich Text Area. Press ALT-F10 for tool bar"
],
	"\u0000Room number\u0001": [
	"Room number"
],
	"\u0000Rotate left\u0001": [
	"Rotate left"
],
	"\u0000Rotate right\u0001": [
	"Rotate right"
],
	"\u0000Rows\u0001": [
	"Rows"
],
	"\u0000Rule name\u0001": [
	"Rule name"
],
	"\u0000Rules\u0001": [
	"Rules"
],
	"\u0000Rules provide you with the power to effortlessly organize and streamline your email inbox, enabling actions like automatically moving emails from specific senders to designated folders, deleting or marking them as read, or forwarding them to another email address.\u0001": [
	"Rules provide you with the power to effortlessly organise and streamline your email inbox, enabling actions like automatically moving email messages from specific senders to designated folders, deleting or marking them as read, or forwarding them to another email address."
],
	"\u0000Run slideshow\u0001": [
	"Run slideshow"
],
	"\u0000SMS\u0001": [
	"SMS"
],
	"\u0000SMS Code\u0001": [
	"SMS Code"
],
	"\u0000SMTP\u0001": [
	"SMTP"
],
	"\u0000SSL/TLS\u0001": [
	"SSL/TLS"
],
	"\u0000Sales Volume\u0001": [
	"Sales volume"
],
	"superessive\u0000Saturday\u0001": [
	"Saturday"
],
	"\u0000Save\u0001": [
	"Save"
],
	"\u0000Save and apply rule now\u0001": [
	"Save and apply rule now"
],
	"\u0000Save and close\u0001": [
	"Save and close"
],
	"\u0000Save appointment\u0001": [
	"Save appointment"
],
	"\u0000Save as PDF\u0001": [
	"Save as PDF"
],
	"\u0000Save as distribution list\u0001": [
	"Save as distribution list"
],
	"\u0000Save as file\u0001": [
	"Save as file"
],
	"\u0000Save attachment\u0001": [
	"Save attachment"
],
	"\u0000Save changes\u0001": [
	"Save changes"
],
	"\u0000Save contact\u0001": [
	"Save contact"
],
	"\u0000Save draft\u0001": [
	"Save draft"
],
	"\u0000Save draft and close\u0001": [
	"Save draft and close"
],
	"\u0000Save task\u0001": [
	"Save task"
],
	"\u0000Save to %1$s\u0001": [
	"Save to %1$s"
],
	"\u0000Saved %s\u0001": [
	"Saved %s"
],
	"\u0000Saved appointment attachment\u0001": [
	"Saved appointment attachment"
],
	"\u0000Saved attachment\u0001": [
	"Saved attachment"
],
	"\u0000Saved contact attachment\u0001": [
	"Saved contact attachment"
],
	"\u0000Saved email attachment\u0001": [
	"Saved e-mail attachment"
],
	"\u0000Saved in\u0001": [
	"Saved in"
],
	"\u0000Saved task attachment\u0001": [
	"Saved task attachment"
],
	"\u0000Saving attachments…\u0001": [
	"Saving attachments…"
],
	"\u0000Saving attachment…\u0001": [
	"Saving attachment…"
],
	"\u0000Saving…\u0001": [
	"Saving…"
],
	"\u0000Scan the QR code with your authenticator.\u0001": [
	"Scan the QR code with your authenticator."
],
	"\u0000Scan this QR code to sign in on another device\u0001": [
	"Scan this QR code to sign in on another device"
],
	"\u0000Scan this code with your phone's camera to synchronize your \"%1$s\":\u0001": [
	"Scan this code with your phone's camera to synchronise your \"%1$s\":"
],
	"\u0000Scan this code with your phone's camera to synchronize your Mail, Calendar and Address Book via Exchange Active Sync:\u0001": [
	"Scan this code with your phone's camera to synchronise your Mail, Calendar and Address Book via Exchange Active Sync:"
],
	"\u0000Schedule\u0001": [
	"Schedule"
],
	"\u0000Schedule email\u0001": [
	"Schedule email"
],
	"\u0000Schedule send\u0001": [
	"Schedule send"
],
	"\u0000Schedule will be discarded\u0001": [
	"Schedule will be discarded"
],
	"\u0000Scheduled date\u0001": [
	"Scheduled date"
],
	"\u0000Scheduled email sending\u0001": [
	"Scheduled email sending"
],
	"\u0000Scheduling\u0001": [
	"Scheduling"
],
	"app\u0000Scheduling\u0001": [
	"Scheduling"
],
	"\u0000Search\u0001": [
	"Search"
],
	"\u0000Search all address lists\u0001": [
	"Search all address lists"
],
	"\u0000Search appointments\u0001": [
	"Search appointments"
],
	"\u0000Search contacts\u0001": [
	"Search contacts"
],
	"\u0000Search email\u0001": [
	"Search mail"
],
	"\u0000Search files\u0001": [
	"Search files"
],
	"\u0000Search for contacts\u0001": [
	"Search for contacts"
],
	"\u0000Search for name, department, position\u0001": [
	"Search for name, department, position"
],
	"\u0000Search for resources\u0001": [
	"Search for resources"
],
	"\u0000Search in\u0001": [
	"Search in"
],
	"search\u0000Search in\u0001": [
	"Search in"
],
	"\u0000Search in %1$s\u0001": [
	"Search in %1$s"
],
	"\u0000Search in %1$s, after %2$s\u0001": [
	"Search in %1$s, after %2$s"
],
	"\u0000Search in %1$s, before %2$s \u0001": [
	"Search in %1$s, before %2$s "
],
	"\u0000Search in %1$s, between %2$s and %3$s\u0001": [
	"Search in %1$s, between %2$s and %3$s"
],
	"\u0000Search photos\u0001": [
	"Search photos"
],
	"\u0000Search resources\u0001": [
	"Search resources"
],
	"\u0000Search results\u0001": [
	"Search results"
],
	"\u0000Search tasks\u0001": [
	"Search tasks"
],
	"\u0000Search: %1$s\u0001": [
	"Search: %1$s"
],
	"\u0000Searching is one of the most used functions. We have simplified and improved the search feature. It is now located in the most prominent position: upper, top central navigation bar. It's a simple and easy-to-use text field and more sophisticated filters are available in a separate dropdown.\u0001": [
	"Searching is one of the most used functions. We have simplified and improved the search feature. It is now located in the most prominent position: upper, top central navigation bar. It's a simple and easy-to-use text field and more sophisticated filters are available in a separate dropdown."
],
	"\u0000Secret\u0001": [
	"Secret"
],
	"\u0000Security\u0001": [
	"Security"
],
	"\u0000Security & Privacy\u0001": [
	"Security & Privacy"
],
	"\u0000Security Token\u0001": [
	"Security Token"
],
	"\u0000See which devices are currently signed in\u0001": [
	"See which devices are currently signed in"
],
	"\u0000Select\u0001": [
	"Select"
],
	"dropdown\u0000Select\u0001": [
	"Select"
],
	"select-contacts\u0000Select\u0001": [
	"Select"
],
	"\u0000Select 2-step verification method\u0001": [
	"Select 2-step verification method"
],
	"\u0000Select <b>Add to Dock</b>\u0001": [
	"Select <b>Add to Dock</b>"
],
	"\u0000Select <b>Add to Home Screen</b>\u0001": [
	"Select <b>Add to Home Screen</b>"
],
	"\u0000Select <b>Add to Home Screen</b>.\u0001": [
	"Select <b>Add to Home Screen</b>."
],
	"\u0000Select BCC contacts\u0001": [
	"Select BCC contacts"
],
	"\u0000Select CC contacts\u0001": [
	"Select CC contacts"
],
	"\u0000Select a checkbox to define a custom name for that address; otherwise the mail account's default name will be used. If you want to use an address anonymously, select the checkbox and leave the field empty.\u0001": [
	"Select a checkbox to define a custom name for that address; otherwise the e-mail account's default name will be used. If you want to use an address anonymously, select the checkbox and leave the field empty."
],
	"\u0000Select all\u0001": [
	"Select all"
],
	"\u0000Select all messages\u0001": [
	"Select all messages"
],
	"\u0000Select contacts\u0001": [
	"Select contacts"
],
	"\u0000Select file\u0001": [
	"Select file"
],
	"\u0000Select folder\u0001": [
	"Select folder"
],
	"\u0000Select newest read message automatically at start\u0001": [
	"Select newest read message automatically at start"
],
	"\u0000Select print layout\u0001": [
	"Select print layout"
],
	"\u0000Select reply-to email addresses\u0001": [
	"Select reply-to email addresses"
],
	"\u0000Select resources\u0001": [
	"Select resources"
],
	"\u0000Select time zone\u0001": [
	"Select time zone"
],
	"\u0000Select users\u0001": [
	"Select users"
],
	"\u0000Select your default sender address\u0001": [
	"Select your default sender address"
],
	"\u0000Select your language and time zone\u0001": [
	"Select your language and time zone"
],
	"\u0000Select your preferred mail app layout.\u0001": [
	"Select your preferred email app layout."
],
	"\u0000Selected resources were automatically added to this appointment.\u0001": [
	"Selected resources were automatically added to this appointment."
],
	"\u0000Selection Details\u0001": [
	"Selection Details"
],
	"\u0000Send\u0001": [
	"Send"
],
	"\u0000Send Appointment\u0001": [
	"Send Appointment"
],
	"\u0000Send Monday morning\u0001": [
	"Send Monday morning"
],
	"\u0000Send SMS %1$s after end.\u0001": [
	"Send SMS %1$s after end."
],
	"\u0000Send SMS %1$s after start.\u0001": [
	"Send SMS %1$s after start."
],
	"\u0000Send SMS %1$s before end.\u0001": [
	"Send SMS %1$s before end."
],
	"\u0000Send SMS %1$s before start.\u0001": [
	"Send SMS %1$s before start."
],
	"\u0000Send SMS at %1$s.\u0001": [
	"Send SMS at %1$s."
],
	"\u0000Send SMS at end.\u0001": [
	"Send SMS at end."
],
	"\u0000Send SMS at start.\u0001": [
	"Send SMS at start."
],
	"\u0000Send a read receipt\u0001": [
	"Send a read receipt"
],
	"\u0000Send as vCard\u0001": [
	"Send as vCard"
],
	"\u0000Send by email\u0001": [
	"Send by e-mail"
],
	"\u0000Send email\u0001": [
	"Send e-mail"
],
	"\u0000Send email %1$s after end.\u0001": [
	"Send e-mail %1$s after end."
],
	"\u0000Send email %1$s after start.\u0001": [
	"Send e-mail %1$s after start."
],
	"\u0000Send email %1$s before end.\u0001": [
	"Send e-mail %1$s before end."
],
	"\u0000Send email %1$s before start.\u0001": [
	"Send e-mail %1$s before start."
],
	"\u0000Send email at %1$s.\u0001": [
	"Send e-mail at %1$s."
],
	"\u0000Send email at end.\u0001": [
	"Send e-mail at end."
],
	"\u0000Send email at start.\u0001": [
	"Send e-mail at start."
],
	"\u0000Send email to all participants\u0001": [
	"Send e-mail to all participants"
],
	"\u0000Send from\u0001": [
	"Send from"
],
	"\u0000Send invitations\u0001": [
	"Send invitations"
],
	"\u0000Send notification by email\u0001": [
	"Send notification by e-mail"
],
	"\u0000Send this morning\u0001": [
	"Send this morning"
],
	"\u0000Send tomorrow morning\u0001": [
	"Send tomorrow morning"
],
	"\u0000Send vacation notice during this time only\u0001": [
	"Send vacation notice during this time only"
],
	"\u0000Send with empty attachment\u0001": [
	"Send with empty attachment"
],
	"\u0000Send without attachment\u0001": [
	"Send without attachment"
],
	"\u0000Sender\u0001": [
	"Sender"
],
	"\u0000Sender address\u0001": [
	"Sender address"
],
	"\u0000Sender email address\u0001": [
	"Sender email address"
],
	"\u0000Sender name\u0001": [
	"Sender name"
],
	"\u0000Sending email can be delayed so that you can cancel sending if it happens by mistake or you forgot something.\u0001": [
	"Sending email can be delayed so that you can cancel sending if it happens by mistake or you forgot something."
],
	"\u0000Sending email in progress\u0001": [
	"Sending email in progress"
],
	"\u0000Sending has been canceled. The email has been moved to the drafts folder.\u0001": [
	"Sending has been canceled. The email has been moved to the drafts folder."
],
	"\u0000Sending planned for\u0001": [
	"Sending planned for"
],
	"\u0000Sending…\u0001": [
	"Sending…"
],
	"\u0000Sent\u0001": [
	"Sent"
],
	"\u0000Sent by\u0001": [
	"Sent by"
],
	"\u0000Sent date\u0001": [
	"Sent date"
],
	"\u0000Sent mails\u0001": [
	"Sent emails"
],
	"folder\u0000Sent messages\u0001": [
	"Sent messages"
],
	"\u0000Serial number\u0001": [
	"Serial number"
],
	"\u0000Server\u0001": [
	"Server"
],
	"\u0000Server Name\u0001": [
	"Server Name"
],
	"\u0000Server URL\u0001": [
	"Server URL"
],
	"\u0000Server did not send a response\u0001": [
	"Server did not send a response"
],
	"\u0000Server name\u0001": [
	"Server name"
],
	"\u0000Server port\u0001": [
	"Server port"
],
	"\u0000Server shutting down.\u0001": [
	"Server shutting down."
],
	"\u0000Server type\u0001": [
	"Server type"
],
	"\u0000Server unreachable\u0001": [
	"Server unreachable"
],
	"\u0000Set IMAP keywords\u0001": [
	"Set IMAP keywords"
],
	"\u0000Set categories\u0001": [
	"Set categories"
],
	"\u0000Set color\u0001": [
	"Set colour"
],
	"\u0000Set color flag\u0001": [
	"Set colour flag"
],
	"\u0000Set default signatures\u0001": [
	"Set default signatures"
],
	"\u0000Set how long the \"Undo\" notification stays visible after an action, such as deleting an email. Only the most recent action can be undone.\u0001": [
	"Set how long the \"Undo\" notification stays visible after an action, such as deleting an email. Only the most recent action can be undone."
],
	"\u0000Set inbox category\u0001": [
	"Set inbox category"
],
	"\u0000Set password\u0001": [
	"Set password"
],
	"\u0000Set up and configure %s meetings\u0001": [
	"Set up and configure %s meetings"
],
	"\u0000Set up and configure Zoom meetings\u0001": [
	"Set up and configure Zoom meetings"
],
	"\u0000Set your preferred duration here %1$s\u0001": [
	"Set your preferred duration here %1$s"
],
	"\u0000Set your preferred setting for reading e-mails.\u0001": [
	"Set your preferred setting for reading email messages."
],
	"\u0000Set your preferred working hours. This timeframe will be highlighted in day, week, and workweek view.\u0001": [
	"Set your preferred working hours. This timeframe will be highlighted in day, week, and workweek view."
],
	"\u0000Settings\u0001": [
	"Settings"
],
	"\u0000Settings Folders\u0001": [
	"Settings Folders"
],
	"\u0000Settings got a new search\u0001": [
	"Settings got a new search"
],
	"\u0000Share\u0001": [
	"Share"
],
	"\u0000Share %1$s \"%2$s\"\u0001": [
	"Share %1$s \"%2$s\""
],
	"\u0000Share / Permissions\u0001": [
	"Share / Permissions"
],
	"\u0000Share with subfolders\u0001": [
	"Share with subfolders"
],
	"\u0000Shared\u0001": [
	"Shared"
],
	"\u0000Shared Appointments\u0001": [
	"Shared Appointments"
],
	"\u0000Shared Categories\u0001": [
	"Shared Categories"
],
	"\u0000Shared address books\u0001": [
	"Shared address books"
],
	"\u0000Shared address lists\u0001": [
	"Shared address lists"
],
	"\u0000Shared by other users\u0001": [
	"Shared by other users"
],
	"\u0000Shared by public link\u0001": [
	"Shared by public link"
],
	"\u0000Shared calendars\u0001": [
	"Shared calendars"
],
	"\u0000Shared folders\u0001": [
	"Shared folders"
],
	"\u0000Shared folders from \"%1$s\"\u0001": [
	"Shared folders from \"%1$s\""
],
	"\u0000Shared lists\u0001": [
	"Shared lists"
],
	"\u0000Shared tasks folders\u0001": [
	"Shared tasks folders"
],
	"\u0000Shared with guest users\u0001": [
	"Shared with guest users"
],
	"\u0000Shared with internal and guest users\u0001": [
	"Shared with internal and guest users"
],
	"\u0000Shared with internal users\u0001": [
	"Shared with internal users"
],
	"\u0000Shared with others\u0001": [
	"Shared with others"
],
	"\u0000Shares\u0001": [
	"Shares"
],
	"\u0000Sharing folders without permissions\u0001": [
	"Sharing folders without permissions"
],
	"\u0000Sharing options\u0001": [
	"Sharing options"
],
	"\u0000Shortcut profile\u0001": [
	"Shortcut profile"
],
	"\u0000Shortcuts can be configured in %1$s\u0001": [
	"Shortcuts can be configured in %1$s"
],
	"\u0000Shortly\u0001": [
	"Shortly"
],
	"\u0000Show\u0001": [
	"Show"
],
	"\u0000Show advanced options\u0001": [
	"Show advanced options"
],
	"\u0000Show all\u0001": [
	"Show all"
],
	"\u0000Show all calendars\u0001": [
	"Show all calendars"
],
	"\u0000Show all images just once\u0001": [
	"Show all images just once"
],
	"\u0000Show appointment details\u0001": [
	"Show appointment details"
],
	"\u0000Show as free\u0001": [
	"Show as free"
],
	"\u0000Show birthday calendar\u0001": [
	"Show birthday calendar"
],
	"\u0000Show birthdays in notification area\u0001": [
	"Show birthdays in notification area"
],
	"\u0000Show blind carbon copy input field\u0001": [
	"Show blind carbon copy input field"
],
	"\u0000Show carbon copy input field\u0001": [
	"Show carbon copy input field"
],
	"\u0000Show categories\u0001": [
	"Show categories"
],
	"\u0000Show contact details\u0001": [
	"Show contact details"
],
	"\u0000Show countdown\u0001": [
	"Show countdown"
],
	"\u0000Show countdowns only for appointments with multiple participants or a link to join online meetings\u0001": [
	"Show countdowns only for appointments with multiple participants or a link to join online meetings"
],
	"\u0000Show declined appointments\u0001": [
	"Show declined appointments"
],
	"\u0000Show desktop notifications\u0001": [
	"Show desktop notifications"
],
	"\u0000Show details\u0001": [
	"Show details"
],
	"\u0000Show done tasks\u0001": [
	"Show completed tasks"
],
	"\u0000Show editor toolbar\u0001": [
	"Show editor tool bar"
],
	"\u0000Show entire message\u0001": [
	"Show entire message"
],
	"\u0000Show entire message including all external images\u0001": [
	"Show entire message including all external images"
],
	"\u0000Show fine grid\u0001": [
	"Show fine grid"
],
	"\u0000Show folders\u0001": [
	"Show folders"
],
	"\u0000Show free/busy information to others.\u0001": [
	"Show free/busy information to others."
],
	"\u0000Show hidden files and folders\u0001": [
	"Show hidden files and folders"
],
	"\u0000Show icons\u0001": [
	"Show icons"
],
	"\u0000Show images\u0001": [
	"Show images"
],
	"\u0000Show in  %1$s\u0001": [
	"Show in  %1$s"
],
	"\u0000Show less options\u0001": [
	"Show less options"
],
	"\u0000Show list\u0001": [
	"Show list"
],
	"\u0000Show manual configuration options\u0001": [
	"Show manual configuration options"
],
	"\u0000Show message size\u0001": [
	"Show message size"
],
	"\u0000Show mini calendar\u0001": [
	"Show mini calendar"
],
	"\u0000Show more options\u0001": [
	"Show more options"
],
	"\u0000Show name\u0001": [
	"Show name"
],
	"\u0000Show or hide alternative options for advanced users.\u0001": [
	"Show or hide alternative options for advanced users."
],
	"\u0000Show quoted text\u0001": [
	"Show quoted text"
],
	"\u0000Show reminders for past appointments\u0001": [
	"Show reminders for past appointments"
],
	"\u0000Show reply-to input field\u0001": [
	"Show reply-to input field"
],
	"\u0000Show requests for read receipts\u0001": [
	"Show requests for read receipts"
],
	"\u0000Show shortcut help\u0001": [
	"Show shortcut help"
],
	"\u0000Show task details\u0001": [
	"Show task details"
],
	"\u0000Show text preview\u0001": [
	"Show text preview"
],
	"\u0000Show this calendar only\u0001": [
	"Show this calendar only"
],
	"\u0000Show this group only\u0001": [
	"Show this group only"
],
	"\u0000Show this resource only\u0001": [
	"Show this resource only"
],
	"\u0000Show tiles\u0001": [
	"Show tiles"
],
	"\u0000Show toolbar\u0001": [
	"Show tool bar"
],
	"\u0000Shown as\u0001": [
	"Shown as"
],
	"\u0000Shown as %1$s\u0001": [
	"Shown as %1$s"
],
	"\u0000Shrink\u0001": [
	"Shrink"
],
	"\u0000Sign in\u0001": [
	"Sign in"
],
	"word\u0000Sign in\u0001": [
	"Sign in"
],
	"\u0000Sign in with Google. This will add your Gmail account.\u0001": [
	"Sign in with Google. This will add your Gmail account."
],
	"\u0000Sign out\u0001": [
	"Sign out"
],
	"\u0000Sign out from all devices\u0001": [
	"Sign out from all devices"
],
	"\u0000Sign out from device\u0001": [
	"Sign out from device"
],
	"\u0000Sign out now\u0001": [
	"Sign out now"
],
	"\u0000Signature\u0001": [
	"Signature"
],
	"\u0000Signature Position\u0001": [
	"Signature Position"
],
	"\u0000Signature name\u0001": [
	"Signature name"
],
	"\u0000Signatures\u0001": [
	"Signatures"
],
	"\u0000Signatures for all mail accounts\u0001": [
	"Signatures for all email accounts"
],
	"\u0000Signed in as\u0001": [
	"Signed in as"
],
	"\u0000Simple\u0001": [
	"Simple"
],
	"\u0000Simply scan the QR code and your device will connect seamlessly - no need to manually enter login credentials or go through lengthy setup processes.\u0001": [
	"Simply scan the QR code and your device will connect seamlessly - no need to manually enter login credentials or go through lengthy setup processes."
],
	"\u0000Six months\u0001": [
	"Six months"
],
	"\u0000Size\u0001": [
	"Size"
],
	"\u0000Skip to main content\u0001": [
	"Skip to main content"
],
	"\u0000Slideshow\u0001": [
	"Slideshow"
],
	"\u0000Slideshow for images\u0001": [
	"Slideshow for images"
],
	"\u0000Small\u0001": [
	"Small"
],
	"\u0000Small (%1$s px)\u0001": [
	"Small (%1$s px)"
],
	"\u0000Smarter participant sorting\u0001": [
	"Smarter participant sorting"
],
	"\u0000Smoke Gray\u0001": [
	"Smoke Gray"
],
	"\u0000Snooze\u0001": [
	"Snooze"
],
	"\u0000Some contacts could not be added as they have no valid email field.\u0001": [
	"Some contacts could not be added as they have no valid e-mail field."
],
	"\u0000Some contacts could not be added because their email address is already in the list.\u0001": [
	"Some contacts could not be added because their email address is already in the list."
],
	"\u0000Some files or folders are shared with others. They will not be available for them anymore.\u0001": [
	"Some files or folders are shared with others. They will not be available for them anymore."
],
	"\u0000Some mandatory configuration could not be loaded.\u0001": [
	"Some mandatory configuration could not be loaded."
],
	"\u0000Something went wrong. Maybe the session expired or the token is invalid.\u0001": [
	"Something went wrong. Maybe the session expired or the token is invalid."
],
	"\u0000Something went wrong. Please close this browser tab and try again.\u0001": [
	"Something went wrong. Please close this browser tab and try again."
],
	"\u0000Something went wrong. Please try again later.\u0001": [
	"Something went wrong. Please try again later."
],
	"\u0000Something went wrong. Please try again.\u0001": [
	"Something went wrong. Please try again."
],
	"\u0000Sorry, there is no preview available for this file.\u0001": [
	"Sorry, there is no preview available for this file."
],
	"\u0000Sorry, there is no preview available for this image.\u0001": [
	"Sorry, there is no preview available for this image."
],
	"\u0000Sorry, there is no preview available.\u0001": [
	"Sorry, there is no preview available."
],
	"\u0000Sort by\u0001": [
	"Sort by"
],
	"dropdown\u0000Sort by\u0001": [
	"Sort by"
],
	"\u0000Sort options\u0001": [
	"Sort options"
],
	"\u0000Sort order\u0001": [
	"Sort order"
],
	"\u0000Sound\u0001": [
	"Sound"
],
	"\u0000Source\u0001": [
	"Source"
],
	"folder\u0000Spam\u0001": [
	"Spam"
],
	"\u0000Split\u0001": [
	"Split"
],
	"\u0000Spouse's name\u0001": [
	"Spouse's name"
],
	"\u0000Spreadsheet\u0001": [
	"Spreadsheet"
],
	"\u0000Spreadsheets\u0001": [
	"Spreadsheets"
],
	"\u0000Standard\u0001": [
	"Standard"
],
	"\u0000Standard folders\u0001": [
	"Standard folders"
],
	"\u0000Standard time zone\u0001": [
	"Standard time zone"
],
	"\u0000Start\u0001": [
	"Start"
],
	"\u0000Start app\u0001": [
	"Start app"
],
	"\u0000Start countdown\u0001": [
	"Start countdown"
],
	"\u0000Start date\u0001": [
	"Start date"
],
	"\u0000Start date time zone\u0001": [
	"Start date time zone"
],
	"\u0000Start in \"%1$s\" address book\u0001": [
	"Start in \"%1$s\" address book"
],
	"\u0000Start in global address book\u0001": [
	"Start in global address book"
],
	"\u0000Start time\u0001": [
	"Start time"
],
	"\u0000Start tour\u0001": [
	"Start tour"
],
	"\u0000Start typing to search for user names\u0001": [
	"Start typing to search for user names"
],
	"\u0000Start video\u0001": [
	"Start video"
],
	"\u0000StartTLS\u0001": [
	"StartTLS"
],
	"\u0000Starting letter index\u0001": [
	"Starting letter index"
],
	"\u0000Starts not with\u0001": [
	"Does not start with"
],
	"\u0000Starts on\u0001": [
	"Starts on"
],
	"\u0000Starts with\u0001": [
	"Starts with"
],
	"\u0000State\u0001": [
	"State"
],
	"\u0000Statistics\u0001": [
	"Statistics"
],
	"\u0000Status\u0001": [
	"Status"
],
	"\u0000Stay informed about what's new and discover the latest features and enhancements in our latest updates of %1$s.\u0001": [
	"Stay informed about what's new and discover the latest features and enhancements in our latest updates of %1$s."
],
	"\u0000Stay signed in\u0001": [
	"Stay signed in"
],
	"\u0000Stay up-to-date on your favorite devices.\u0001": [
	"Stay up-to-date on your favourite devices."
],
	"\u0000Steel gray\u0001": [
	"Steel gray"
],
	"\u0000Step\u0001": [
	"Step"
],
	"\u0000Stick to the right side\u0001": [
	"Stick to the right side"
],
	"\u0000Stop slideshow\u0001": [
	"Stop slideshow"
],
	"\u0000Storage\u0001": [
	"Storage"
],
	"\u0000Street\u0001": [
	"Street"
],
	"\u0000String\u0001": [
	"String"
],
	"\u0000Subject\u0001": [
	"Subject"
],
	"\u0000Subject: %1$s\u0001": [
	"Subject: %1$s"
],
	"\u0000Subscribe\u0001": [
	"Subscribe"
],
	"\u0000Subscribe to Google calendar\u0001": [
	"Subscribe to Google calendar"
],
	"\u0000Subscribe to IMAP folders\u0001": [
	"Subscribe to IMAP folders"
],
	"\u0000Subscribe to address book\u0001": [
	"Subscribe to address book"
],
	"\u0000Subscribe to calendar\u0001": [
	"Subscribe to calendar"
],
	"\u0000Subscribe to folder\u0001": [
	"Subscribe to folder"
],
	"\u0000Subscribe to iCal feed\u0001": [
	"Subscribe to iCal feed"
],
	"\u0000Subscribe to shared address books\u0001": [
	"Subscribe to shared address books"
],
	"\u0000Subscribe to shared calendars\u0001": [
	"Subscribe to shared calendars"
],
	"\u0000Subscribe to shared task folders\u0001": [
	"Subscribe to shared task folders"
],
	"\u0000Subscribe to shared tasks folders\u0001": [
	"Subscribe to shared tasks folders"
],
	"\u0000Subscribe to task folder\u0001": [
	"Subscribe to task folder"
],
	"\u0000Subscription refresh\u0001": [
	"Subscription refresh"
],
	"\u0000Subscription successfully created.\u0001": [
	"Subscription successfully created."
],
	"\u0000Subscriptions\u0001": [
	"Subscriptions"
],
	"\u0000Success\u0001": [
	"Success"
],
	"\u0000Successfully refreshed calendar\u0001": [
	"Successfully refreshed calendar"
],
	"\u0000Suffix\u0001": [
	"Suffix"
],
	"\u0000Summary\u0001": [
	"Summary"
],
	"superessive\u0000Sunday\u0001": [
	"Sunday"
],
	"\u0000Sunsets\u0001": [
	"Sunsets"
],
	"\u0000Support starts with Chrome %1$d, Firefox %2$d, Edge %3$d, and Safari %4$d.\u0001": [
	"Support starts with Chrome %1$d, Firefox %2$d, Edge %3$d, and Safari %4$d."
],
	"\u0000Switch camera\u0001": [
	"Switch camera"
],
	"\u0000Switch to parent folder\u0001": [
	"Switch to parent folder"
],
	"\u0000Symbols\u0001": [
	"Symbols"
],
	"\u0000Sync via DAV\u0001": [
	"Sync via DAV"
],
	"\u0000System\u0001": [
	"System"
],
	"\u0000TAX ID\u0001": [
	"TAX ID"
],
	"\u0000TB\u0001": [
	"TB"
],
	"\u0000TTY/TDD\u0001": [
	"TTY/TDD"
],
	"\u0000Tag mails from %1$s with %2$s\u0001": [
	"Tag e-mail messages from %1$s with %2$s"
],
	"\u0000Tag mails to %1$s with %2$s\u0001": [
	"Tag e-mail messages to %1$s with %2$s"
],
	"\u0000Tag mails with subject %1$s with %2$s\u0001": [
	"Tag e-mail messages with subject %1$s with %2$s"
],
	"\u0000Take %1$s with you!\u0001": [
	"Take %1$s with you!"
],
	"\u0000Take %1$s with you! Stay up-to-date on your favorite devices.\u0001": [
	"Take %1$s with you! Stay up-to-date on your favorite devices."
],
	"\u0000Take a photo\u0001": [
	"Take a photo"
],
	"\u0000Tap <b>Install</b> in the popup.\u0001": [
	"Tap <b>Install</b> in the popup."
],
	"\u0000Tap on the sharing icon\u0001": [
	"Tap on the sharing icon"
],
	"\u0000Tap the More button\u0001": [
	"Tap the More button"
],
	"\u0000Tap the install icon\u0001": [
	"Tap the install icon"
],
	"\u0000Task\u0001": [
	"Task"
],
	"\u0000Task Details\u0001": [
	"Task Details"
],
	"\u0000Task actions\u0001": [
	"Task actions"
],
	"\u0000Task has been deleted\u0001": [
	"Task has been deleted"
],
	"\u0000Task has been deleted already\u0001": [
	"Task has been deleted already"
],
	"\u0000Task invitation\u0001": [
	"Task invitation"
],
	"\u0000Task invitations, changes or deletions\u0001": [
	"Task invitations, changes or deletions"
],
	"\u0000Task marked as done\u0001": [
	"Task marked as done"
],
	"\u0000Task marked as undone\u0001": [
	"Task marked as undone"
],
	"\u0000Task reminder\u0001": [
	"Task reminder"
],
	"\u0000Tasks\u0001": [
	"Tasks"
],
	"app\u0000Tasks\u0001": [
	"Tasks"
],
	"\u0000Tasks can not be moved to or out of shared folders\u0001": [
	"Tasks cannot be moved to or out of shared folders"
],
	"\u0000Tasks have been deleted\u0001": [
	"Tasks have been deleted"
],
	"\u0000Tasks in folders\u0001": [
	"Tasks in folders"
],
	"\u0000Tasks in public folders\u0001": [
	"Tasks in public folders"
],
	"\u0000Tasks in shared folders\u0001": [
	"Tasks in shared folders"
],
	"\u0000Tasks marked as done\u0001": [
	"Tasks marked as done"
],
	"\u0000Tasks marked as undone\u0001": [
	"Tasks marked as undone"
],
	"\u0000Tasks toolbar\u0001": [
	"Tasks tool bar"
],
	"\u0000Telephone (ISDN)\u0001": [
	"Telephone (ISDN)"
],
	"\u0000Telephone callback\u0001": [
	"Telephone callback"
],
	"\u0000Telephone primary\u0001": [
	"Telephone primary"
],
	"\u0000Telephone radio\u0001": [
	"Telephone radio"
],
	"\u0000Telex\u0001": [
	"Telex"
],
	"\u0000Tell us about yourself\u0001": [
	"Tell us about yourself"
],
	"\u0000Template name\u0001": [
	"Template name"
],
	"\u0000Templates\u0001": [
	"Templates"
],
	"\u0000Tentative\u0001": [
	"Tentative"
],
	"\u0000Tentatively accepted\u0001": [
	"Tentatively accepted"
],
	"\u0000Text documents\u0001": [
	"Text documents"
],
	"\u0000Text templates\u0001": [
	"Text templates"
],
	"\u0000Text templates: A powerful tool for creating and editing pre-defined snippets that enable quick responses and visually captivating content. Seamlessly insert plain or formatted text, including images, into new emails with ease, boosting productivity and efficiency.\u0001": [
	"Text templates: A powerful tool for creating and editing pre-defined snippets that enable quick responses and visually captivating content. Seamlessly insert plain or formatted text, including images, into new email messages with ease, boosting productivity and efficiency."
],
	"\u0000Thank you for your feedback\u0001": [
	"Thank you for your feedback"
],
	"\u0000The \"Connect your device\" wizard now allows you to setup email, contacts, and calendar synchronization with your iPhone, iPad, or Macbook in one step\u0001": [
	"The \"Connect your device\" wizard now allows you to setup email, contacts, and calendar synchronisation with your iPhone, iPad, or Macbook in one step"
],
	"\u0000The %1$s client lets you store and share your photos, files, documents and videos, anytime, anywhere. Access any file you save to %1$s from all your computers, iPhone, iPad or from within %2$s itself.\u0001": [
	"The %1$s client lets you store and share your photos, files, documents and videos, anytime, anywhere. Access any file you save to %1$s from all your computers, iPhone, iPad or from within %2$s itself."
],
	"\u0000The PDF could not be exported. The file name contains invalid characters:\u0001": [
	"The PDF could not be exported. The file name contains invalid characters:"
],
	"\u0000The PDF file is password protected and cannot be displayed\u0001": [
	"The PDF file is password protected and cannot be displayed"
],
	"\u0000The PDF file structure is invalid.\u0001": [
	"The PDF file structure is invalid."
],
	"\u0000The PDF has been saved to \"/drive/myfiles/documents\" due to not having write access for the current folder.\u0001": [
	"The PDF has been saved to \"/drive/myfiles/documents\" due to not having write access for the current folder."
],
	"\u0000The Zoom integration service is currently unavailable. Please try again later.\u0001": [
	"The Zoom integration service is currently unavailable. Please try again later."
],
	"\u0000The account must be named\u0001": [
	"The account must be named"
],
	"\u0000The allowed quota is reached.\u0001": [
	"The allowed quota is reached."
],
	"\u0000The appointment description might contain outdated information from a previous zoom conference that needs to be deleted manually.\u0001": [
	"The appointment description might contain outdated information from a previous zoom conference that needs to be deleted manually."
],
	"\u0000The appointment has been added to your calendar\u0001": [
	"The appointment has been added to your calendar"
],
	"\u0000The appointment has been deleted\u0001": [
	"The appointment has been deleted"
],
	"\u0000The appointment has been updated\u0001": [
	"The appointment has been updated"
],
	"\u0000The appointment was added\u0001": [
	"The appointment was added"
],
	"\u0000The attached file is empty. Maybe this file was deleted on your local hard drive. Do you want to send it anyway?\u0001": [
	"The attached file is empty. Maybe this file was deleted on your local hard drive. Do you want to send it anyway?"
],
	"\u0000The attachment cannot be uploaded because it exceeds the infostore quota limit of %2$s\u0001": [
	"The attachment cannot be uploaded because it exceeds the InfoStore quota limit of %2$s"
],
	"\u0000The below item was open last time you exited %1$s.\u0001": [
	"The below item was open the last time you exited %1$s."
],
	"\u0000The below items were open last time you exited %1$s.\u0001": [
	"The below items were open the last time you exited %1$s."
],
	"\u0000The categories will appear once your search is done.\u0001": [
	"The categories will appear once your search is done."
],
	"\u0000The certificate list is empty\u0001": [
	"The certificate list is empty"
],
	"\u0000The changes have been accepted\u0001": [
	"The changes have been accepted"
],
	"\u0000The changes have been rejected\u0001": [
	"The changes have been rejected"
],
	"\u0000The countdown window will pop up before a scheduled meeting.\u0001": [
	"The countdown window will pop up before a scheduled meeting."
],
	"\u0000The current folder is not supported\u0001": [
	"The current folder is not supported"
],
	"\u0000The deputy has the following permissions\u0001": [
	"The deputy has the following permissions"
],
	"\u0000The dialog contains invalid data\u0001": [
	"The dialogue contains invalid data"
],
	"\u0000The due date cannot be before start date. Adjust start date?\u0001": [
	"The due date cannot be before the start date. Adjust the start date?"
],
	"\u0000The due date must not be before the start date.\u0001": [
	"The due date must not be before the start date."
],
	"\u0000The email has been sent\u0001": [
	"The e-mail has been sent"
],
	"\u0000The end date must be after the start date.\u0001": [
	"The end date must be after the start date."
],
	"\u0000The entered credential or authentication information does not work\u0001": [
	"The entered credential or authentication information does not work"
],
	"\u0000The file \"%1$s\" cannot be uploaded because it exceeds the attachment publication maximum file size of %2$s\u0001": [
	"The file \"%1$s\" cannot be uploaded because it exceeds the attachment publication maximum file size of %2$s"
],
	"\u0000The file \"%1$s\" cannot be uploaded because it exceeds the maximum file size of %2$s\u0001": [
	"The file \"%1$s\" cannot be uploaded because it exceeds the maximum file size of %2$s"
],
	"\u0000The file \"%1$s\" cannot be uploaded because it exceeds the total attachment size limit of %2$s\u0001": [
	"The file \"%1$s\" cannot be uploaded because it exceeds the total attachment size limit of %2$s"
],
	"\u0000The file cannot be uploaded because it exceeds the maximum email size of %1$s\u0001": [
	"The file cannot be uploaded because it exceeds the maximum email size of %1$s"
],
	"\u0000The file type \"%1$s\" cannot be used as a contact photo. Supported file types are JPEG, GIF, BMP, and PNG.\u0001": [
	"The file type \"%1$s\" cannot be used as a contact photo. Supported file types are JPEG, GIF, BMP, and PNG."
],
	"\u0000The first record of a valid CSV file must define proper column names. Supported separators are comma and semi-colon.\u0001": [
	"The first record of a valid CSV file must define proper column names. Supported separators are comma and semi-colon."
],
	"\u0000The folder cannot be added because it was removed by the owner.\u0001": [
	"The folder cannot be added because it was removed by the owner."
],
	"\u0000The folder cannot be added because the link is invalid.\u0001": [
	"The folder cannot be added because the link is invalid."
],
	"\u0000The folder has been cleaned up.\u0001": [
	"The folder has been cleaned up."
],
	"\u0000The folder has been emptied\u0001": [
	"The folder has been emptied"
],
	"\u0000The folder is currently unavailable and cannot be added. Please try again later.\u0001": [
	"The folder is currently unavailable and cannot be added. Please try again later."
],
	"\u0000The folder was added successfully.\u0001": [
	"The folder was added successfully."
],
	"\u0000The folder was removed successfully.\u0001": [
	"The folder was removed successfully."
],
	"\u0000The following apps will not be shown on the mobile quick launcher bar due to space limitations.\u0001": [
	"The following apps will not be shown on the mobile quick launcher bar due to space limitations."
],
	"\u0000The following email addresses cannot be used: %1$s\u0001": [
	"The following e-mail addresses cannot be used: %1$s"
],
	"\u0000The following external applications/services can access your data:\u0001": [
	"The following external applications/services can access your data:"
],
	"\u0000The given address is always added to BCC when replying or composing new emails.\u0001": [
	"The given address is always added to BCC when replying or composing new email messages."
],
	"\u0000The image cannot not be resized because it was not found on your hard drive.\u0001": [
	"The image cannot not be resized because it was not found on your hard drive."
],
	"\u0000The link has been copied to the clipboard.\u0001": [
	"The link has been copied to the clipboard."
],
	"\u0000The list below shows all devices you're currently signed in to. There might be multiple sessions from the same device.\u0001": [
	"The list below shows all devices you are currently signed in to. There might be multiple sessions from the same device."
],
	"\u0000The loading behavior has been improved to achieve faster loading times\u0001": [
	"The loading behaviour has been improved to achieve faster loading times"
],
	"\u0000The mail draft could not be found on the server. It was sent or deleted in the meantime.\u0001": [
	"The mail draft could not be found on the server. It was sent or deleted in the meantime."
],
	"\u0000The majority of app icons have been visually updated\u0001": [
	"The majority of app icons have been visually updated"
],
	"\u0000The meeting has already started\u0001": [
	"The meeting has already started"
],
	"\u0000The meeting has just started\u0001": [
	"The meeting has just started"
],
	"\u0000The meeting will start in a minute\u0001": [
	"The meeting will start in a minute"
],
	"\u0000The meeting will start soon\u0001": [
	"The meeting will start soon"
],
	"\u0000The new appointment conflicts with existing appointments.\u0001": [
	"The new appointment conflicts with existing appointments."
],
	"\u0000The notice is sent out for messages received by %1$s. You may choose to send it out for other recipient addresses too:\u0001": [
	"The notice is sent out for messages received by %1$s. You may choose to send it out for other recipient addresses too:"
],
	"\u0000The notification has been resent\u0001": [
	"The notification has been resent"
],
	"\u0000The number of versions is limited to %1$d version.\u0001The number of versions is limited to %1$d versions.": [
	"The number of versions is limited to %1$d version.",
	"The number of versions is limited to %1$d versions."
],
	"\u0000The number of versions is not limited.\u0001": [
	"The number of versions is not limited."
],
	"\u0000The order of participants has been adjusted to better suit different use cases: When viewing appointment details, participants are now ordered by their participation status, prioritizing those who have accepted or declined. In contrast, when creating or editing an appointment, participants are sorted alphabetically by name for easier reference.\u0001": [
	"The order of participants has been adjusted to better suit different use cases: When viewing appointment details, participants are now ordered by their participation status, prioritising those who have accepted or declined. In contrast, when creating or editing an appointment, participants are sorted alphabetically by name for easier reference."
],
	"\u0000The password was changed recently. Please enter the new password.\u0001": [
	"The password was changed recently. Please enter the new password."
],
	"\u0000The photo exceeds the allowed file size of %1$s\u0001": [
	"The photo exceeds the allowed file size of %1$s"
],
	"\u0000The provided filename exceeds the allowed length.\u0001": [
	"The provided filename exceeds the allowed length."
],
	"\u0000The provided password for the email address %1$s is incorrect\u0001": [
	"The provided password for the e-mail address %1$s is incorrect"
],
	"\u0000The requested application is not available at this moment.\u0001": [
	"The requested application is not available at this moment."
],
	"\u0000The search section has been cleaned up and made easier to navigate, with the most important settings now prioritized and placed upfront. We've also improved the wording throughout the interface to ensure better understandability.\u0001": [
	"The search section has been cleaned up and made easier to navigate, with the most important settings now prioritized and placed up front. We have also improved the wording throughout the interface to ensure better understandability."
],
	"\u0000The selected addresses. Press Backspace or Delete to remove.\u0001": [
	"The selected addresses. Press Backspace or Delete to remove."
],
	"\u0000The selected calendar \"%1$s\" is public. Do you really want to create an appointment in this calendar?\u0001": [
	"The selected calendar \"%1$s\" is public. Do you really want to create an appointment in this calendar?"
],
	"\u0000The selected calendar is shared by %1$s. Appointments in shared calendars will generally be created on behalf of the owner.\u0001": [
	"The selected calendar is shared by %1$s. Appointments in shared calendars will generally be created on behalf of the owner."
],
	"\u0000The selected items. Press Backspace or Delete to remove.\u0001": [
	"The selected items. Press Backspace or Delete to remove."
],
	"\u0000The selected timezone is already a favorite.\u0001": [
	"The selected timezone is already a favourite."
],
	"\u0000The sender wants to get notified when you have read this email\u0001": [
	"The sender would like to be notified when you have read this e-mail"
],
	"\u0000The sending of the message has been canceled.\u0001": [
	"The sending of the message has been canceled."
],
	"\u0000The series ends after %1$d occurrence.\u0001The series ends after %1$d occurrences.": [
	"The series ends after %1$d occurrence.",
	"The series ends after %1$d occurrences."
],
	"\u0000The series ends on %1$s.\u0001": [
	"The series ends on %1$s."
],
	"\u0000The series never ends.\u0001": [
	"The series never ends."
],
	"\u0000The server provided an invalid configuration. Please try again or contact support.\u0001": [
	"The server provided an invalid configuration. Please try again or contact support."
],
	"\u0000The service is not available right now.\u0001": [
	"The service is not available right now."
],
	"\u0000The setting requires a reload or logging in again to take effect.\u0001": [
	"The setting requires a reload or logging in again to take effect."
],
	"\u0000The signature exists and is valid\u0001": [
	"The signature exists and is valid"
],
	"\u0000The signature is missing or is not valid\u0001": [
	"The signature is missing or is not valid"
],
	"\u0000The start date must be before the due date.\u0001": [
	"The start date must be before the due date."
],
	"\u0000The subscription could not be created.\u0001": [
	"The subscription could not be created."
],
	"\u0000The subscription could not be updated due to an error and must be recreated.\u0001": [
	"The subscription could not be updated due to an error and must be recreated."
],
	"\u0000The task could not be deleted.\u0001": [
	"The task could not be deleted."
],
	"\u0000The tasks could not be deleted.\u0001": [
	"The tasks could not be deleted."
],
	"\u0000The time frame is in the past.\u0001": [
	"The time frame is in the past."
],
	"\u0000The time scale works like a zoom level in the calendar view. A lower number zooms in.\u0001": [
	"The time scale works like a zoom level in the calendar view. A lower number zooms in."
],
	"\u0000The timeframe is limited to %1$d day.\u0001The timeframe is limited to %1$d days.": [
	"The timeframe is limited to %1$d day.",
	"The timeframe is limited to %1$d days."
],
	"\u0000The timeframe is not limited.\u0001": [
	"The timeframe is not limited."
],
	"\u0000The two newly entered passwords do not match.\u0001": [
	"The two newly entered passwords do not match."
],
	"\u0000The unrecoverable items have been cleaned up successfully. Please refresh this page to see the changes.\u0001": [
	"The unrecoverable items have been cleaned up successfully. Please refresh this page to see the changes."
],
	"\u0000The uploaded attachment exceeds the maximum email size of %1$s\u0001": [
	"The uploaded attachment exceeds the maximum email size of %1$s"
],
	"\u0000The uploaded file does not match the requested file type.\u0001": [
	"The uploaded file does not match the requested file type."
],
	"\u0000The user doesn't share his free/busy information with you.\u0001": [
	"The user does not share his free/busy information with you."
],
	"\u0000The user interface is now more resilient in handling unstable internet connections\u0001": [
	"The user interface is now more resilient in handling unstable Internet connections"
],
	"\u0000The widget \"%s\" was disabled as the account might have been removed or is no longer available.\u0001": [
	"The widget \"%s\" was disabled as the account might have been removed or is no longer available."
],
	"\u0000Theme\u0001": [
	"Theme"
],
	"\u0000Theme preference\u0001": [
	"Theme preference"
],
	"\u0000Theme settings\u0001": [
	"Theme settings"
],
	"\u0000Themes\u0001": [
	"Themes"
],
	"\u0000There are currently no compatible media devices available on your device.\u0001": [
	"There are currently no compatible media devices available on your device."
],
	"\u0000There are no backup devices available for this account. Please notify support for help.\u0001": [
	"There are no backup devices available for this account. Please notify support for help."
],
	"\u0000There are no external applications/services which can access your account.\u0001": [
	"There are no external applications/services which can access your account."
],
	"\u0000There are no notifications\u0001": [
	"There are no notifications"
],
	"\u0000There are unsaved changes.\u0001": [
	"There are unsaved changes."
],
	"\u0000There is %1$d message in this folder; not all messages are displayed in the list currently.\u0001There are %1$d messages in this folder; not all messages are displayed in the list currently.": [
	"There is %1$d message in this folder; not all messages are displayed in the list currently.",
	"There are %1$d messages in this folder; not all messages are displayed in the list currently."
],
	"\u0000There is a new notification\u0001There are %1$d new notifications": [
	"There is a new notification",
	"There are %1$d new notifications"
],
	"\u0000There is a notification\u0001There are %1$d notifications": [
	"There is a notification",
	"There are %1$d notifications"
],
	"\u0000There is a problem with this account. Click for more information\u0001": [
	"There is a problem with this account. Click for more information"
],
	"\u0000There is an update available! Please reload the app.\u0001": [
	"There is an update available! Please reload the app."
],
	"\u0000There is currently an archive download available. By requesting a new download the current archive will be deleted and is no longer available.\u0001": [
	"There is currently an archive download available. By requesting a new download the current archive will be deleted and will be no longer available."
],
	"\u0000There is no preview for this file type.\u0001": [
	"There is no preview for this file type."
],
	"\u0000There is no rule defined\u0001": [
	"There is no rule defined"
],
	"\u0000There was a problem adding the password.\u0001": [
	"There was a problem adding the password."
],
	"\u0000There was a problem getting the list of available applications from the server.\u0001": [
	"There was a problem getting the list of available applications from the server."
],
	"\u0000There was a problem getting the list of passwords from the server.\u0001": [
	"There was a problem getting the list of passwords from the server."
],
	"\u0000There was a problem removing the password.\u0001": [
	"There was a problem removing the password."
],
	"\u0000There was an error scheduling the email\u0001": [
	"There was an error scheduling the email"
],
	"\u0000There was no appointment data to import\u0001": [
	"There was no appointment data to import"
],
	"\u0000There was no contact data to import\u0001": [
	"There was no contact data to import"
],
	"\u0000There was no suitable server found for this email/password combination\u0001": [
	"There was no suitable server found for this email/password combination"
],
	"\u0000There was no task data to import\u0001": [
	"There was no task data to import"
],
	"\u0000These files have not been deleted\u0001": [
	"These files have not been deleted"
],
	"\u0000These files have not been deleted, as they are locked by their owner.\u0001": [
	"These files have not been deleted, as they are locked by their owner."
],
	"\u0000This action may take some time.\u0001": [
	"This action may take some time."
],
	"\u0000This action takes some time, so please be patient, while the import runs in the background.\u0001": [
	"This action takes some time. Please be patient while the import runs in the background."
],
	"\u0000This address book is empty\u0001": [
	"This address book is empty"
],
	"\u0000This afternoon\u0001": [
	"This afternoon"
],
	"\u0000This appointment has just started\u0001": [
	"This appointment just started"
],
	"\u0000This appointment has started %s ago\u0001": [
	"This appointment started %s ago"
],
	"\u0000This appointment is an exception. Changing the exception does not affect the series.\u0001": [
	"This appointment is an exception. Changing the exception does not affect the series."
],
	"\u0000This appointment is part of a series.\u0001": [
	"This appointment is part of a series."
],
	"\u0000This appointment is part of a series. Do you want to change your confirmation for the whole series or just for this appointment within the series?\u0001": [
	"This appointment is part of a series. Do you want to change your confirmation for the whole series or just for this appointment within the series?"
],
	"\u0000This appointment is part of a series. Do you want to change your reminders for the whole series or just for this appointment within the series?\u0001": [
	"This appointment is part of a series. Do you want to change your reminders for the whole series or just for this appointment within the series?"
],
	"\u0000This appointment is part of a series. Do you want to delete all appointments of the series or just this appointment?\u0001": [
	"This appointment is part of a series. Do you want to delete all appointments in the series or just this appointment?"
],
	"\u0000This appointment is part of a series. Do you want to delete this and all future appointments of the series or just this appointment?\u0001": [
	"This appointment is part of a series. Do you want to delete this and all future appointments in the series or just this appointment?"
],
	"\u0000This appointment might not take place because all other attendees declined\u0001": [
	"This appointment might not take place because all other attendees declined"
],
	"\u0000This appointment starts in %s\u0001": [
	"This appointment starts in %s"
],
	"\u0000This appointment was canceled.\u0001": [
	"This appointment was canceled."
],
	"\u0000This browser is not compatible with your configured authentication device. Please use Chrome browser, or Firefox with U2F enabled.\u0001": [
	"This browser is not compatible with your configured authentication device. Please use Chrome browser, or Firefox with U2F enabled."
],
	"\u0000This browser is not supported on your current platform.\u0001": [
	"This browser is not supported on your current platform."
],
	"\u0000This calendar is shared with others. It won't be available for them any more.\u0001": [
	"This calendar is shared with others. It will not be available to them any more."
],
	"\u0000This contact is private and cannot be shared\u0001": [
	"This contact is private and cannot be shared"
],
	"\u0000This device is not eligible for this request. Wrong hardware key?\u0001": [
	"This device is not eligible for this request. Wrong hardware key?"
],
	"\u0000This dialog is limited to %1$d entries and this group exceeds this limitation. Therefore, some entries are not listed.\u0001": [
	"This dialogue is limited to %1$d entries and this group exceeds this limitation. Therefore, some entries are not listed."
],
	"\u0000This dialog is limited to %1$d entries and your address book exceeds this limitation. Therefore, some entries are not listed.\u0001": [
	"This dialogue is limited to %1$d entries and your address book exceeds this limitation. Therefore, some entries are not listed."
],
	"\u0000This distribution list has been added to the portal\u0001": [
	"This distribution list has been added to the portal"
],
	"\u0000This document cannot be viewed at the moment because a new version is being uploaded. Please wait until the upload is completed.\u0001": [
	"This document cannot be viewed at the moment because a new version is being uploaded. Please wait until the upload is complete."
],
	"\u0000This document is password protected and cannot be displayed.\u0001": [
	"This document is password protected and cannot be displayed."
],
	"\u0000This draft has been changed in another tab or browser. Please continue editing the most recent version. If you have closed that tab in the meantime, you can restore the most recent draft here.\u0001": [
	"This draft has been changed in another tab or browser. Please continue editing the most recent version. If you have closed that tab in the meantime, you can restore the most recent draft here."
],
	"\u0000This email address cannot be used\u0001": [
	"This e-mail address cannot be used"
],
	"\u0000This email address is already used. Please choose a different one.\u0001": [
	"This email address is already used. Please choose a different one."
],
	"\u0000This email address is invalid.\u0001": [
	"This email address is invalid."
],
	"\u0000This email contains a task\u0001": [
	"This email contains a task"
],
	"\u0000This email contains an appointment\u0001": [
	"This email contains an appointment"
],
	"\u0000This email contains images from external sources that are currently hidden.\u0001": [
	"This email contains images from external sources that are currently hidden."
],
	"\u0000This email has been added to the portal\u0001": [
	"This e-mail has been added to the portal"
],
	"\u0000This email has no content\u0001": [
	"This email has no content"
],
	"\u0000This email has no subject. Do you want to send it anyway?\u0001": [
	"This e-mail has no subject. Do you want to send it anyway?"
],
	"\u0000This email has not been sent. You can save the draft to work on later.\u0001": [
	"This e-mail has not been sent. You can save the draft to work on later."
],
	"\u0000This email is scheduled to be sent on %1$s.\u0001": [
	"This email is scheduled to be sent on %1$s."
],
	"\u0000This email just contains your email address as sender. Your real name is not used.\u0001": [
	"This e-mail just contains your e-mail address as sender. Your real name is not used."
],
	"\u0000This email may contain images from external sources.\u0001": [
	"This email may contain images from external sources."
],
	"\u0000This email was sent on behalf of another person.\u0001": [
	"This email was sent on behalf of another person."
],
	"\u0000This email will be sent by %1$s on behalf of %2$s.\u0001": [
	"This email will be sent by %1$s on behalf of %2$s."
],
	"\u0000This evening\u0001": [
	"This evening"
],
	"\u0000This feature isn't available for non-secure connections.\u0001": [
	"This feature is not available for non-secure connections."
],
	"\u0000This field is mandatory\u0001": [
	"This field is mandatory"
],
	"\u0000This file could not be uploaded.\u0001": [
	"This file could not be uploaded."
],
	"\u0000This file has been added to the portal\u0001": [
	"This file has been added to the portal"
],
	"\u0000This file has not been deleted\u0001": [
	"This file has not been deleted"
],
	"\u0000This file has not been deleted, as it is locked by its owner.\u0001": [
	"This file has not been deleted, as it is locked by its owner."
],
	"\u0000This file or folder is shared with others. It will not be available for them anymore.\u0001": [
	"This file or folder is shared with others. It will not be available for them anymore."
],
	"\u0000This file will be written in your default folder to allow editing\u0001": [
	"This file will be written in your default folder to allow editing"
],
	"\u0000This folder has been shared with another user. You are not allowed to add this folder.\u0001": [
	"This folder has been shared with another user. You are not allowed to add this folder."
],
	"\u0000This folder has no publications\u0001": [
	"This folder has no publications"
],
	"\u0000This folder has no subscriptions\u0001": [
	"This folder has no subscriptions"
],
	"\u0000This folder has publications but you are not allowed to view or edit them\u0001": [
	"This folder has publications but you are not allowed to view or edit them"
],
	"\u0000This folder has subscriptions\u0001": [
	"This folder has subscriptions"
],
	"\u0000This folder has subscriptions but you are not allowed to view or edit them\u0001": [
	"This folder has subscriptions but you are not allowed to view or edit them"
],
	"\u0000This folder is empty\u0001": [
	"This folder is empty"
],
	"\u0000This folder is shared with others. It won't be available for them any more.\u0001": [
	"This folder is shared with others. It will not be available to them any more."
],
	"\u0000This info will be shown in your profile and to the recipients of your emails\u0001": [
	"This info will be shown in your profile and to the recipients of your email messages"
],
	"\u0000This is a booking request for %1$s\u0001": [
	"This is a booking request for %1$s"
],
	"\u0000This is a browser feature for developers. If you were asked to copy and paste anything here, somebody might want to take over your account. Do not enter any script code without knowing what it does.\u0001": [
	"This is a browser feature for developers. If you were asked to copy and paste anything here, somebody might want to take over your account. Do not enter any script code without knowing what it does."
],
	"\u0000This is a dangerous email containing spam or malware.\u0001": [
	"This is a dangerous e-mail containing spam or malware."
],
	"\u0000This is a standard folder, which can't be renamed.\u0001": [
	"This is a standard folder, which cannot be renamed."
],
	"\u0000This is an invalid email address.\u0001": [
	"This is an invalid e-mail address."
],
	"\u0000This is how your message text will look like.\u0001": [
	"This is what your message text will look like."
],
	"\u0000This is not a valid email address\u0001": [
	"This is not a valid email address"
],
	"\u0000This is not a valid email address. If you want to specify multiple addresses, please use a comma to separate them.\u0001": [
	"This is not a valid email address. If you want to specify multiple addresses, please use a comma to separate them."
],
	"\u0000This is the email preview. You can also turn it off.\u0001": [
	"This is the email preview. You can also turn it off."
],
	"\u0000This is your recovery code. Please write it down, print it, or save the file. Be sure to save this in a secure location.\u0001": [
	"This is your recovery code. Please write it down, print it, or save the file. Be sure to save this in a secure location."
],
	"\u0000This list has no delegates yet\u0001": [
	"This list does not have any delegates yet"
],
	"\u0000This list has no entries yet\u0001": [
	"This list does not have any entries yet"
],
	"\u0000This list has no members yet\u0001": [
	"This list has no members yet"
],
	"\u0000This list has no participants yet\u0001": [
	"This list has no participants yet"
],
	"\u0000This message has been truncated due to size limitations.\u0001": [
	"This message has been truncated due to size limitations."
],
	"\u0000This message was sent via a mailing list.\u0001": [
	"This message was sent via a mailing list."
],
	"\u0000This message was sent via the mailing list %1$s.\u0001": [
	"This message was sent via the mailing list %1$s."
],
	"\u0000This name is already used. Please choose a different one.\u0001": [
	"This name is already used. Please choose a different one."
],
	"\u0000This note will not be printed\u0001": [
	"This note will not be printed"
],
	"\u0000This page is not served with http2. It is likely that you encounter performance issues. \u0001": [
	"This page is not served with HTTP2. It is likely that you will encounter performance issues. "
],
	"\u0000This platform is currently not supported.\u0001": [
	"This platform is currently not supported."
],
	"\u0000This release brings a completely new look and feel to your mobile device, including a faster navigation for switching apps, a redesigned mail app, updated compose windows, a new launcher design, and many more.\u0001": [
	"This release brings a completely new look and feel to your mobile device, including faster navigation for switching apps, a redesigned mail app, updated compose windows, a new launcher design, and much more."
],
	"\u0000This release brings a completely new look and feel to your mobile device, including a faster navigation for switching apps, a redesigned mail app, updated compose windows, a new launcher design, and many more. You can now also install %1$s on your device like an App. On Android using Chrome, tap the three dots in the top right, and select \"Install app\". On iOS, tap the share icon at the bottom, and choose \"Add to Home Screen\" to install.\u0001": [
	"This release brings a completely new look and feel to your mobile device, including faster navigation for switching apps, a redesigned email app, updated compose windows, a new launcher design, and much more. You can now also install %1$s on your device like an App. On Android using Chrome, tap the three dots in the top right, and select \"Install app\". On iOS, tap the share icon at the bottom, and choose \"Add to Home Screen\" to install."
],
	"\u0000This rule applies to all messages. Please add a condition to restrict this rule to specific messages.\u0001": [
	"This rule applies to all messages. Please add a condition to restrict this rule to specific messages."
],
	"\u0000This rule contains unsupported properties. \u0001": [
	"This rule contains unsupported properties. "
],
	"\u0000This sender address is related to a disabled email account. Please choose another sender address or visit settings to enable again.\u0001": [
	"This sender address is related to a disabled email account. Please choose another sender address or visit settings to enable again."
],
	"\u0000This setting allows you to choose how names consisting of first and last name are formatted.\u0001": [
	"This setting allows you to choose how names consisting of first and last name are formatted."
],
	"\u0000This setting defines for how long file version are kept until they get deleted automatically after next sign-in\u0001": [
	"This setting defines for how long file versions are kept until they get deleted automatically after next sign-in"
],
	"\u0000This setting defines how many versions will be kept. Older versions that exceed this limit will be automatically deleted\u0001": [
	"This setting defines how many versions will be kept. Older versions that exceed this limit will be automatically deleted"
],
	"\u0000This task has no participants yet\u0001": [
	"This task has no participants yet"
],
	"\u0000This task list is empty\u0001": [
	"This task list is empty"
],
	"\u0000This task recurs\u0001": [
	"This task recurs"
],
	"\u0000This type of link is unsupported and can't be added.\u0001": [
	"This type of link is unsupported and can't be added."
],
	"\u0000This value is too long. The allowed length is %1$d characters.\u0001": [
	"This value is too long. The allowed length is %1$d characters."
],
	"\u0000This version of %1$s introduces a fresh calendar layout and enhanced usability for mobile users. Navigate your week with ease through our new, dynamic week view. The updated month view displays additional details, optimizing your daily routine.\u0001": [
	"This version of %1$s introduces a fresh calendar layout and enhanced usability for mobile users. Navigate your week with ease through our new, dynamic week view. The updated month view displays additional details, optimising your daily routine."
],
	"\u0000This weekend\u0001": [
	"This weekend"
],
	"\u0000This will assign a name to the device\u0001": [
	"This will assign a name to the device"
],
	"\u0000This will delete the device named %s.\u0001": [
	"This will delete the device named %s."
],
	"\u0000This will edit the name for device (%s)\u0001": [
	"This will edit the name for device (%s)"
],
	"\u0000This would also delete a currently edited draft.\u0001This would also delete %1$d currently edited drafts.": [
	"This would also delete a currently edited draft.",
	"This would also delete %1$d currently edited drafts."
],
	"\u0000Thread contains %1$d message\u0001Thread contains %1$d messages": [
	"Thread contains %1$d message",
	"Thread contains %1$d messages"
],
	"\u0000Three months\u0001": [
	"Three months"
],
	"\u0000Thumbnail\u0001": [
	"Thumbnail"
],
	"\u0000Thumbnails\u0001": [
	"Thumbnails"
],
	"superessive\u0000Thursday\u0001": [
	"Thursday"
],
	"\u0000Tiles\u0001": [
	"Tiles"
],
	"\u0000Time\u0001": [
	"Time"
],
	"\u0000Time format\u0001": [
	"Time format"
],
	"\u0000Time period back\u0001": [
	"Time period back"
],
	"\u0000Time period forward\u0001": [
	"Time period forward"
],
	"\u0000Time scale\u0001": [
	"Time scale"
],
	"\u0000Time zone\u0001": [
	"Timezone"
],
	"\u0000Timeframe\u0001": [
	"Time frame"
],
	"\u0000Timeout\u0001": [
	"Timeout"
],
	"\u0000Title\u0001": [
	"Title"
],
	"salutation\u0000Title\u0001": [
	"Title"
],
	"title\u0000Title\u0001": [
	"Title"
],
	"\u0000To\u0001": [
	"To"
],
	"\u0000To add a password, select an application to use with a new password, as well as a new descriptive name for the password.\u0001": [
	"To add a password, select an application to use with a new password, as well as a new descriptive name for the password."
],
	"\u0000To add contacts manually, just provide a valid email address (e.g john.doe@example.com or \"John Doe\" <jd@example.com>)\u0001": [
	"To add contacts manually, provide a valid email address (e.g john.doe@example.com or \"John Doe\" <jd@example.com>)"
],
	"\u0000To install %1$s like an app, simply scan the QR code with your device's camera.\u0001": [
	"To install %1$s like an app, simply scan the QR code with your device's camera."
],
	"\u0000To install %1$s, please click on the download button:\u0001": [
	"To install %1$s, please click on the download button:"
],
	"\u0000To install %1$s, please scan this QR code with your phone or click on the download button:\u0001": [
	"To install %1$s, please scan this QR code with your phone or click on the download button:"
],
	"\u0000To learn more about the new and improved features you can visit \u0001": [
	"To learn more about the new and improved features you can visit "
],
	"\u0000To navigate between the %1$s applications, just click on the new App Launcher icon.\u0001": [
	"To navigate between the %1$s applications, just click on the new App Launcher icon."
],
	"\u0000To print this file, please use \"Print as PDF\" in the viewer.\u0001": [
	"To print this file, please use \"Print as PDF\" in the viewer."
],
	"\u0000To synchronize Address Book, please enter the following settings in your CardDav client:\u0001": [
	"To synchronise Address Book, please enter the following settings in your CardDav client:"
],
	"\u0000To synchronize Calendar, please enter the following settings in your CalDav client:\u0001": [
	"To synchronise Calendar, please enter the following settings in your CalDav client:"
],
	"\u0000To synchronize Mail, Calendar and Address Book via Exchange Active Sync, please enter the following settings:\u0001": [
	"To synchronise Mail, Calendar and Address Book via Exchange Active Sync, please enter the following settings:"
],
	"\u0000To: %1$s\u0001": [
	"To: %1$s"
],
	"\u0000Today\u0001": [
	"Today"
],
	"\u0000Today,\u0001": [
	"Today,"
],
	"\u0000Today: %1$s\u0001": [
	"Today: %1$s"
],
	"\u0000Toggle category\u0001": [
	"Toggle category"
],
	"\u0000Toggle panel\u0001": [
	"Toggle panel"
],
	"\u0000Toggle preview\u0001": [
	"Toggle preview"
],
	"\u0000Tomorrow\u0001": [
	"Tomorrow"
],
	"\u0000Tonight\u0001": [
	"Tonight"
],
	"\u0000Top 10 you got email from\u0001": [
	"Top 10 you received email from"
],
	"\u0000Top 10 you sent email to\u0001": [
	"Top 10 you sent email to"
],
	"\u0000Total\u0001": [
	"Total"
],
	"\u0000Total: %1$d\u0001": [
	"Total: %1$d"
],
	"\u0000Trash folder\u0001": [
	"Trash folder"
],
	"\u0000Trust\u0001": [
	"Trust"
],
	"\u0000Trust certificate\u0001": [
	"Trust certificate"
],
	"\u0000Trust certificate %1$s\u0001": [
	"Trust certificate %1$s"
],
	"\u0000Trusted\u0001": [
	"Trusted"
],
	"\u0000Try again\u0001": [
	"Try again"
],
	"\u0000Try again.\u0001": [
	"Try again."
],
	"\u0000Trying to auto-configure your email account\u0001": [
	"Trying to auto-configure your email account"
],
	"superessive\u0000Tuesday\u0001": [
	"Tuesday"
],
	"\u0000Two-step verification\u0001": [
	"Two-step verification"
],
	"\u0000Type\u0001": [
	"Type"
],
	"search\u0000Type\u0001": [
	"Type"
],
	"\u0000UI version\u0001": [
	"UI version"
],
	"\u0000URI\u0001": [
	"URI"
],
	"\u0000URL\u0001": [
	"URL"
],
	"\u0000Unable to connect to email server. Possible reasons: The email server is (temporarily) down or there are network connection problems. Please try again in a few minutes.\u0001": [
	"Unable to connect to e-mail server. Possible reasons: The e-mail server is (temporarily) down or there are network connection problems. Please try again in a few minutes."
],
	"\u0000Unable to delete\u0001": [
	"Unable to delete"
],
	"\u0000Unable to edit name.\u0001": [
	"Unable to edit name."
],
	"\u0000Unable to load email rule settings.\u0001": [
	"Unable to load email rule settings."
],
	"\u0000Unable to load mail filter settings.\u0001": [
	"Unable to load mail filter settings."
],
	"\u0000Unable to load your auto forward settings. Please retry later.\u0001": [
	"Unable to load your auto forward settings. Please retry later."
],
	"\u0000Unable to load your vacation notice. Please retry later.\u0001": [
	"Unable to load your vacation notice. Please retry later."
],
	"\u0000Unable to perform anti-virus check for the requested file(s)\u0001": [
	"Unable to perform anti-virus check for the requested file(s)"
],
	"\u0000Unable to set image. Image might be too large or malformed.\u0001": [
	"Unable to set image. Image might be too large or malformed."
],
	"\u0000Unable to upload attachment. The referenced email may no longer exist or has been moved.\u0001": [
	"Unable to upload attachment. The referenced email may no longer exist or has been moved."
],
	"\u0000Unable to upload file\u0001": [
	"Unable to upload file"
],
	"\u0000Unable to upload files\u0001": [
	"Unable to upload files"
],
	"\u0000Unconfirmed\u0001": [
	"Unconfirmed"
],
	"\u0000Underline\u0001": [
	"Underline"
],
	"\u0000Undo\u0001": [
	"Undo"
],
	"\u0000Undo Send\u0001": [
	"Undo Send"
],
	"\u0000Undo action\u0001": [
	"Undo action"
],
	"\u0000Undo mail operations\u0001": [
	"Undo email operations"
],
	"\u0000Undo send\u0001": [
	"Undo send"
],
	"\u0000Undone\u0001": [
	"Undone"
],
	"\u0000Unflag\u0001": [
	"Unflag"
],
	"verb\u0000Unflag\u0001": [
	"Unflag"
],
	"\u0000Unfortunately your browser doesn't support listing available media devices.\u0001": [
	"Unfortunately your browser does not support listing available media devices."
],
	"\u0000Unicolor\u0001": [
	"Uni-colour"
],
	"\u0000Unknown\u0001": [
	"Unknown"
],
	"\u0000Unknown %1$s\u0001": [
	"Unknown %1$s"
],
	"\u0000Unknown Sender\u0001": [
	"Unknown Sender"
],
	"\u0000Unknown application\u0001": [
	"Unknown application"
],
	"\u0000Unknown recipient\u0001": [
	"Unknown recipient"
],
	"\u0000Unknown sender\u0001": [
	"Unknown sender"
],
	"\u0000Unknown system\u0001": [
	"Unknown system"
],
	"\u0000Unlimited\u0001": [
	"Unlimited"
],
	"\u0000Unlock\u0001": [
	"Unlock"
],
	"\u0000Unnamed subscription\u0001": [
	"Unnamed subscription"
],
	"\u0000Unread\u0001": [
	"Unread"
],
	"\u0000Unread folder that contains all unread emails\u0001": [
	"Unread folder that contains all unread email messages"
],
	"\u0000Unread messages\u0001": [
	"Unread messages"
],
	"\u0000Unread: %1$d\u0001": [
	"Unread: %1$d"
],
	"\u0000Unsaved documents will be lost. Do you want to sign out now?\u0001": [
	"Unsaved documents will be lost. Do you want to sign out now?"
],
	"\u0000Unshare\u0001": [
	"Unshare"
],
	"\u0000Unsubscribed calendars\u0001": [
	"Unsubscribed calendars"
],
	"\u0000Unsubscribed folders\u0001": [
	"Unsubscribed folders"
],
	"\u0000Untrust\u0001": [
	"Untrust"
],
	"\u0000Untrust certificate %1$s\u0001": [
	"Untrust certificate %1$s"
],
	"\u0000Update\u0001": [
	"Update"
],
	"\u0000Update Appointment\u0001": [
	"Update Appointment"
],
	"\u0000Update photo\u0001": [
	"Update photo"
],
	"\u0000Updated %1$d minutes ago\u0001": [
	"Updated %1$d minutes ago"
],
	"\u0000Updated at %1$d\u0001": [
	"Updated at %1$d"
],
	"\u0000Updated just now\u0001": [
	"Updated just now"
],
	"\u0000Updates\u0001": [
	"Updates"
],
	"software\u0000Updates\u0001": [
	"Updates"
],
	"\u0000Upgrade\u0001": [
	"Upgrade"
],
	"\u0000Upgrade your account\u0001": [
	"Upgrade your account"
],
	"\u0000Upload\u0001": [
	"Upload"
],
	"\u0000Upload Recovery File\u0001": [
	"Upload Recovery File"
],
	"\u0000Upload a photo\u0001": [
	"Upload a photo"
],
	"\u0000Upload file\u0001": [
	"Upload file"
],
	"\u0000Upload files\u0001": [
	"Upload files"
],
	"\u0000Upload folder\u0001": [
	"Upload folder"
],
	"\u0000Upload local file\u0001": [
	"Upload local file"
],
	"\u0000Upload new version\u0001": [
	"Upload new version"
],
	"\u0000Upload progress\u0001": [
	"Upload progress"
],
	"\u0000Uploading \"%1$s\"\u0001": [
	"Uploading \"%1$s\""
],
	"\u0000Uploading Attachment…\u0001": [
	"Uploading Attachment…"
],
	"\u0000Uploading attachments\u0001": [
	"Uploading attachments"
],
	"\u0000Uploading folders is not supported in this display area.\u0001": [
	"Uploading folders is not supported in this display area."
],
	"\u0000Uploading folders is not supported.\u0001": [
	"Uploading folders is not supported."
],
	"\u0000Urgency\u0001": [
	"Urgency"
],
	"\u0000Usability\u0001": [
	"Usability"
],
	"\u0000Use %1$s\u0001": [
	"Use %1$s"
],
	"\u0000Use Yubikey's One Time Password System\u0001": [
	"Use Yubikey's One Time Password System"
],
	"\u0000Use browser default\u0001": [
	"Use browser default"
],
	"\u0000Use calendar color\u0001": [
	"Use calendar colour"
],
	"\u0000Use colors for quoted lines\u0001": [
	"Use colours for quoted lines"
],
	"\u0000Use cursor keys to change the date. Press ctrl-key at the same time to change year or shift-key to change month. Close date-picker by pressing ESC key.\u0001": [
	"Use cursor keys to change the date. Press [Ctrl] at the same time to change year or [Shift] to change month. Close date-picker by pressing [Esc]."
],
	"\u0000Use cursor keys to navigate, press enter to select a date\u0001": [
	"Use cursor keys to navigate, press enter to select a date"
],
	"\u0000Use cursor keys to reorder items\u0001": [
	"Use cursor keys to reorder items"
],
	"\u0000Use custom name\u0001": [
	"Use custom name"
],
	"\u0000Use default\u0001": [
	"Use default"
],
	"\u0000Use first category color for appointments\u0001": [
	"Use first category colour for appointments"
],
	"\u0000Use fixed-width font for text mails\u0001": [
	"Use fixed-width font for text email messages"
],
	"\u0000Use inbox categories to organize your incoming emails in different tabs\u0001": [
	"Use inbox categories to organise your incoming email messages in different tabs"
],
	"\u0000Use native desktop notifications\u0001": [
	"Use native desktop notifications"
],
	"\u0000Use password\u0001": [
	"Use password"
],
	"\u0000Use separate username and password\u0001": [
	"Use separate username and password"
],
	"\u0000Use system setting\u0001": [
	"Use system setting"
],
	"\u0000Use the 'Forward Appointment' feature to share appointment invitations with others. Please note that the meeting organizer must approve any new attendees you invite.\u0001": [
	"Use the 'Forward Appointment' feature to share appointment invitations with others. Please note that the meeting organiser must approve any new attendees you invite."
],
	"\u0000Use unified mail for this account\u0001": [
	"Use unified mail for this account"
],
	"\u0000User\u0001": [
	"User"
],
	"\u0000User Categories\u0001": [
	"User Categories"
],
	"\u0000User ID\u0001": [
	"User ID"
],
	"\u0000User Name\u0001": [
	"User Name"
],
	"\u0000User data\u0001": [
	"User data"
],
	"\u0000User defined color\u0001": [
	"User defined colour"
],
	"\u0000Username\u0001": [
	"Username"
],
	"\u0000Username must not be empty.\u0001": [
	"Username must not be empty."
],
	"\u0000Username: %s\u0001": [
	"Username: %s"
],
	"\u0000Vacation notice\u0001": [
	"Vacation notice"
],
	"\u0000Verification Options\u0001": [
	"Verification Options"
],
	"\u0000Version Comment\u0001": [
	"Version Comment"
],
	"\u0000Version comment\u0001": [
	"Version comment"
],
	"\u0000Version of %1$s\u0001": [
	"Version of %1$s"
],
	"\u0000Version retention period\u0001": [
	"Version retention period"
],
	"\u0000Versions\u0001": [
	"Versions"
],
	"\u0000Vertical\u0001": [
	"Vertical"
],
	"\u0000Very large\u0001": [
	"Very large"
],
	"\u0000Very likely\u0001": [
	"Very likely"
],
	"\u0000Very small\u0001": [
	"Very small"
],
	"\u0000Via\u0001": [
	"Via"
],
	"\u0000Videos\u0001": [
	"Videos"
],
	"\u0000View\u0001": [
	"View"
],
	"\u0000View all attachments\u0001": [
	"View all attachments"
],
	"\u0000View details\u0001": [
	"View details"
],
	"\u0000View folder\u0001": [
	"View folder"
],
	"\u0000View message\u0001": [
	"View message"
],
	"\u0000View more\u0001": [
	"View more"
],
	"\u0000View options\u0001": [
	"View options"
],
	"\u0000View source\u0001": [
	"View source"
],
	"\u0000View the folder\u0001": [
	"View the folder"
],
	"\u0000View this version\u0001": [
	"View this version"
],
	"\u0000Viewer\u0001": [
	"Viewer"
],
	"\u0000Viewer (read emails)\u0001": [
	"Viewer (read email messages)"
],
	"\u0000Viewer (view appointments)\u0001": [
	"Viewer (view appointments)"
],
	"\u0000Visibility\u0001": [
	"Visibility"
],
	"\u0000Waiting\u0001": [
	"Waiting"
],
	"\u0000Warm Gray\u0001": [
	"Warm Gray"
],
	"\u0000Warning\u0001": [
	"Warning"
],
	"\u0000Warning!\u0001": [
	"Warning!"
],
	"\u0000Warning:\u0001": [
	"Warning:"
],
	"\u0000Warning: This message might be a phishing or scam mail\u0001": [
	"Warning: This message might be a phishing or scam email"
],
	"\u0000Warnings\u0001": [
	"Warnings"
],
	"\u0000Warnings:\u0001": [
	"Warnings:"
],
	"\u0000Washed out\u0001": [
	"Washed out"
],
	"\u0000We appreciate your feedback\u0001": [
	"We appreciate your feedback"
],
	"\u0000We are very happy to introduce you to our brand-new user interface. We changed countless little details to offer you a great and contemporary user experience.\u0001": [
	"We are very happy to introduce you to our brand-new user interface. We changed countless little details to offer you a great and contemporary user experience."
],
	"\u0000We could not verify that this email is from %1$s.\u0001": [
	"We could not verify that this e-mail is from %1$s."
],
	"\u0000We could verify that this email is from %1$s.\u0001": [
	"We could verify that this e-mail is from %1$s."
],
	"\u0000We encountered an issue for your upload\u0001": [
	"We encountered an issue for your upload"
],
	"\u0000We encountered some issues for your upload\u0001": [
	"We encountered some issues for your upload"
],
	"\u0000We have given the settings a new look and added a search function. Now you can find your way around the settings even faster.\u0001": [
	"We have given the settings a new look and added a search function. Now you can find your way around the settings even faster."
],
	"\u0000We will guide you through the basic settings\u0001": [
	"We will guide you through the basic settings"
],
	"\u0000We're excited to announce that you can now schedule emails to be sent on a specific future date. This feature makes planning and sending emails at your convenience incredibly easy.\u0001": [
	"We're excited to announce that you can now schedule email messages to be sent on a specific future date. This feature makes planning and sending email messages at your convenience incredibly easy."
],
	"\u0000We've expanded category support! While previously limited to appointments, contacts, and tasks, you can now assign categories to your emails as well.\u0001": [
	"We've expanded category support! While previously limited to appointments, contacts, and tasks, you can now assign categories to your email messages as well."
],
	"\u0000Web auth\u0001": [
	"Web auth"
],
	"\u0000Webcam\u0001": [
	"Webcam"
],
	"superessive\u0000Wednesday\u0001": [
	"Wednesday"
],
	"\u0000Week\u0001": [
	"Week"
],
	"\u0000Week that contains January 1st (e.g. US, Canada)\u0001": [
	"Week that contains January 1st (e.g. US, Canada)"
],
	"\u0000Week that contains January 4th (e.g. Europe, ISO-8601)\u0001": [
	"Week that contains January 4th (e.g. Europe, ISO-8601)"
],
	"\u0000Week view\u0001": [
	"Week view"
],
	"\u0000Weekday\u0001": [
	"Weekday"
],
	"\u0000Weekly\u0001": [
	"Weekly"
],
	"\u0000Welcome\u0001": [
	"Welcome"
],
	"\u0000Welcome to %1$s\u0001": [
	"Welcome to %1$s"
],
	"\u0000Welcome to %1$s.\nWe've made some exciting changes to %1$s. This quick tour will guide you through some of the new and improved features.\u0001": [
	"Welcome to %1$s.\nWe have made some exciting changes to %1$s. This quick tour will guide you through some of the new and improved features."
],
	"\u0000Welcome to %s\u0001": [
	"Welcome to %s"
],
	"\u0000Welcome to your calendar\u0001": [
	"Welcome to your calendar"
],
	"\u0000Welcome to your files\u0001": [
	"Welcome to your files"
],
	"\u0000Welcome to your inbox\u0001": [
	"Welcome to your inbox"
],
	"\u0000Welcome to your tasks\u0001": [
	"Welcome to your tasks"
],
	"\u0000What do you want to use?\u0001": [
	"What do you want to use?"
],
	"\u0000What is the one thing we could do to make you happier?\u0001": [
	"What is the one thing we could do to make you happier?"
],
	"\u0000What is the primary reason for your score?\u0001": [
	"What is the primary reason for your score?"
],
	"\u0000What should happen when adding files with identical names?\u0001": [
	"What should happen when adding files with identical names?"
],
	"\u0000What type of device do you want to configure?\u0001": [
	"What type of device do you want to configure?"
],
	"\u0000What's new\u0001": [
	"What is new"
],
	"\u0000What's new in %1$s\u0001": [
	"What's new in %1$s"
],
	"\u0000When you respond to an email, you typically reply to the person who sent it. However, there are situations where it's preferred that the recipients of the response are different, such as a whole team or group. In these cases, the original sender can specify one or even multiple email addresses in the \"reply-to\" field, indicating who the response should be directed to. Additionally, if the same group of people often needs to receive the responses, default \"reply-to\" addresses can be set to simplify the process.\u0001": [
	"When you respond to an email, you typically reply to the person who sent it. However, there are situations where it is preferred that the recipients of the response are different, such as a whole team or group. In these cases, the original sender can specify one or even multiple email addresses in the \"reply-to\" field, indicating who the response should be directed to. Additionally, if the same group of people often needs to receive the responses, default \"reply-to\" addresses can be set to simplify the process."
],
	"\u0000Which application do you want to use?\u0001": [
	"Which application do you want to use?"
],
	"\u0000Which device do you want to configure?\u0001": [
	"Which device do you want to configure?"
],
	"\u0000Which features do you value or use the most?\u0001": [
	"Which features do you value or use the most?"
],
	"\u0000While reading\u0001": [
	"While reading"
],
	"\u0000While sending\u0001": [
	"While sending"
],
	"\u0000While the site may work as expected, we recommend using Safari on iOS.\u0001": [
	"While the site may work as expected, we recommend using Safari on iOS."
],
	"\u0000White\u0001": [
	"White"
],
	"\u0000Who can access this calendar?\u0001": [
	"Who can access this calendar?"
],
	"\u0000Who can access this file?\u0001": [
	"Who can access this file?"
],
	"\u0000Who can access this folder?\u0001": [
	"Who can access this folder?"
],
	"\u0000Windows\u0001": [
	"Windows"
],
	"\u0000Windows PC\u0001": [
	"Windows PC"
],
	"\u0000Windows you have minimized will appear in all applications for easy access. You can maximize a window again by clicking on it.\u0001": [
	"Windows you have minimized will appear in all applications for easy access. You can maximize a window again by clicking on it."
],
	"\u0000With this feature, you can now seamlessly switch between apps using your browser's back and forward functions, providing a level of convenience and flexibility that was not previously available.\u0001": [
	"With this feature, you can now seamlessly switch between apps using your browser's back and forward functions, providing a level of convenience and flexibility that was not previously available."
],
	"\u0000Without delay\u0001": [
	"Without delay"
],
	"\u0000Wood\u0001": [
	"Wood"
],
	"\u0000Work\u0001": [
	"Work"
],
	"\u0000Working Time\u0001": [
	"Working Time"
],
	"\u0000Working time & workweek\u0001": [
	"Working time & work week"
],
	"\u0000Working times\u0001": [
	"Working times"
],
	"\u0000Workweek\u0001": [
	"Work week"
],
	"\u0000Write permissions\u0001": [
	"Write permissions"
],
	"\u0000XML profile could not be loaded\u0001": [
	"XML profile could not be loaded"
],
	"\u0000YB\u0001": [
	"YB"
],
	"\u0000Year\u0001": [
	"Year"
],
	"\u0000Year view\u0001": [
	"Year view"
],
	"\u0000Year view in mobile calendar\u0001": [
	"Year view in mobile calendar"
],
	"\u0000Yearly\u0001": [
	"Yearly"
],
	"\u0000Yellow\u0001": [
	"Yellow"
],
	"\u0000Yes\u0001": [
	"Yes"
],
	"\u0000Yesterday\u0001": [
	"Yesterday"
],
	"\u0000You are currently acting on behalf of the calendar owner.\u0001": [
	"You are currently acting on behalf of the calendar owner."
],
	"\u0000You are currently signed in with the following devices\u0001": [
	"You are currently signed in with the following devices"
],
	"\u0000You are moving one or more items that are shared with other people. These people will lose access.\u0001": [
	"You are moving one or more items that are shared with other people. These people will lose access."
],
	"\u0000You are no longer using a public calendar. You were added as organizer.\u0001": [
	"You are no longer using a public calendar. You were added as organiser."
],
	"\u0000You are no longer using a shared calendar. You were added as organizer.\u0001": [
	"You are no longer using a shared calendar. You were added as organiser."
],
	"\u0000You are the organizer\u0001": [
	"You are the organiser"
],
	"\u0000You are using a shared calendar. The calendar owner was added as organizer.\u0001": [
	"You are using a shared calendar. The calendar owner was added as organiser."
],
	"\u0000You can adjust the countdown in %1$s\u0001": [
	"You can adjust the countdown in %1$s"
],
	"\u0000You can adjust the time to undo sending an email in %1$s\u0001": [
	"You can adjust the time to undo sending an email in %1$s"
],
	"\u0000You can always change them later\u0001": [
	"You can always change them later"
],
	"\u0000You can download a copy of your personal data from your account, if you want to save it or transfer it to another provider.\u0001": [
	"You can download a copy of your personal data from your account, if you want to save it or transfer it to another provider."
],
	"\u0000You can edit the list of countries in your Zoom profile.\u0001": [
	"You can edit the list of countries in your Zoom profile."
],
	"\u0000You can edit your favorite apps as a shortcut.\u0001": [
	"You can edit your favourite apps as a shortcut."
],
	"\u0000You can enable categories again via the \"Inbox categories\" entry in the settings dropdown\u0001": [
	"You can enable categories again via the \"Inbox categories\" entry in the settings dropdown"
],
	"\u0000You can find these options in %1$s\u0001": [
	"You can find these options in %1$s"
],
	"\u0000You can manage the templates in %1$s\u0001": [
	"You can manage the templates in %1$s"
],
	"\u0000You can now add additional verification options to enhance the security of your account.\u0001": [
	"You can now add additional verification options to enhance the security of your account."
],
	"\u0000You can now attach files from %1$s directly to appointments, contacts, or tasks\u0001": [
	"You can now attach files from %1$s directly to appointments, contacts, or tasks"
],
	"\u0000You can now easily forward meeting invitations to others, facilitating seamless sharing and coordination of appointments.\u0001": [
	"You can now easily forward meeting invitations to others, facilitating seamless sharing and coordination of appointments."
],
	"\u0000You can now easily reuse attachments from your previous emails! %s automatically remembers your recent attachments and makes them easily accessible when you're composing a new message. Say goodbye to the hassle of downloading and reuploading files.\u0001": [
	"You can now easily reuse attachments from your previous email messages! %s automatically remembers your recent attachments and makes them easily accessible when you are composing a new message. Say goodbye to the hassle of downloading and reuploading files."
],
	"\u0000You can now install %1$s like an app for quick and easy access!\u0001": [
	"You can now install %1$s like an app for quick and easy access!"
],
	"\u0000You can now install %1$s like an app for quick and easy access! A new wizard will walk you through all the necessary steps on your device. Please note that this feature is only available if your browser supports Progressive Web Apps (PWAs) - currently some browsers do not support PWA installation.\u0001": [
	"You can now install %1$s like an app for quick and easy access! A new wizard will walk you through all the necessary steps on your device. Please note that this feature is only available if your browser supports Progressive Web Apps (PWAs) - currently some browsers do not support PWA installation."
],
	"\u0000You can now recover deleted contacts from the new trash folder before they are permanently removed.\u0001": [
	"You can now recover deleted contacts from the new trash folder before they are permanently removed."
],
	"\u0000You can now set a default signature for alias addresses as well\u0001": [
	"You can now set a default signature for alias addresses as well"
],
	"\u0000You can perform common tasks with keyboard shortcuts. You can choose which profile you want to use or turn them off.\u0001": [
	"You can perform common tasks with keyboard shortcuts. You can choose which profile you want to use or turn them off."
],
	"\u0000You can quick-save your changes via Cmd+Enter.\u0001": [
	"You can quick-save your changes via Cmd+Enter."
],
	"\u0000You can quick-save your changes via Ctrl+Enter.\u0001": [
	"You can quick-save your changes via Ctrl+Enter."
],
	"\u0000You can set the default addresses in %1$s\u0001": [
	"You can set the default addresses in %1$s"
],
	"\u0000You cannot add contacts in \"%1$s\". Do you want to add a new contact to your default address book instead?\u0001": [
	"You cannot add contacts in \"%1$s\". Do you want to add a new contact to your default address book instead?"
],
	"\u0000You cannot add tasks in \"%1$s\". Do you want to add a new task to your default folder instead?\u0001": [
	"You cannot add tasks in \"%1$s\". Do you want to add a new task to your default folder instead?"
],
	"\u0000You cannot mark the appointment as secret, when blocking a resource.\u0001": [
	"You cannot mark the appointment as secret, when blocking a resource."
],
	"\u0000You cannot move items to this folder\u0001": [
	"You cannot move items to this folder"
],
	"\u0000You cannot select this folder.\u0001": [
	"You cannot select this folder."
],
	"\u0000You cannot work on more than %1$s drafts at the same time.\u0001": [
	"You cannot work on more than %1$s drafts at the same time."
],
	"\u0000You declined this appointment\u0001": [
	"You declined this appointment"
],
	"\u0000You declined this task\u0001": [
	"You declined this task"
],
	"\u0000You don't have any appointments in the near future.\u0001": [
	"You do not have any appointments in the near future."
],
	"\u0000You don't have any publications yet\u0001": [
	"You do not have any publications yet"
],
	"\u0000You don't have any subscriptions yet\u0001": [
	"You do not have any subscriptions yet"
],
	"\u0000You don't have any tasks that are either due soon or overdue.\u0001": [
	"You do not have any tasks that are either due soon or overdue."
],
	"\u0000You first need to connect %1$s with Zoom. To do so, you need a Zoom Account. If you don't have an account yet, it is sufficient to create a free one.\u0001": [
	"You first need to connect %1$s with Zoom. To do so, you need a Zoom Account. If you do not have an account, it is sufficient to create a free one."
],
	"\u0000You forgot to sign out last time. Always use the sign-out button when you finished your work.\u0001": [
	"You forgot to sign out last time. Always use the sign-out button when you finish your work."
],
	"\u0000You have %1$d unread message\u0001You have %1$d unread messages": [
	"You have %1$d unread message",
	"You have %1$d unread messages"
],
	"\u0000You have accepted the appointment\u0001": [
	"You have accepted the appointment"
],
	"\u0000You have accepted this appointment\u0001": [
	"You have accepted this appointment"
],
	"\u0000You have accepted this task\u0001": [
	"You have accepted this task"
],
	"\u0000You have been automatically signed out\u0001": [
	"You have been automatically signed out"
],
	"\u0000You have currently no deputies assigned.\u0001": [
	"You currently have no deputies assigned."
],
	"\u0000You have declined the appointment\u0001": [
	"You have declined the appointment"
],
	"\u0000You have linked the following Zoom account:\u0001": [
	"You have linked the following Zoom account:"
],
	"\u0000You have new email\u0001": [
	"You have new e-mail"
],
	"\u0000You have no unread messages\u0001": [
	"You have no unread messages"
],
	"\u0000You have reached the limit of %1$d contacts to display. Please enter a search term to narrow down your results.\u0001": [
	"You have reached the limit of %1$d contacts to display. Please enter a search term to narrow down your results."
],
	"\u0000You have tentatively accepted the appointment\u0001": [
	"You have tentatively accepted the appointment"
],
	"\u0000You have to select a file to upload.\u0001": [
	"You have to select a file to upload."
],
	"\u0000You have to sign in again\u0001": [
	"You have to sign in again"
],
	"\u0000You mentioned \"%s\" in your email, but there are no files attached.\u0001": [
	"You mentioned \"%s\" in your e-mail, but there are no files attached."
],
	"\u0000You must enter a folder name\u0001": [
	"You must enter a folder name"
],
	"\u0000You need to invite at least one participant.\u0001": [
	"You need to invite at least one participant."
],
	"\u0000You need to use Android %n or higher.\u0001": [
	"You need to use Android %n or higher."
],
	"\u0000You need to use iOS %n or higher.\u0001": [
	"You need to use iOS %n or higher."
],
	"\u0000You recently changed your password. Please provide your last password to recover passwords for external accounts.\u0001": [
	"You recently changed your password. Please provide your last password to recover passwords for external accounts."
],
	"\u0000You secured your account with 2-step verification. Please enter the verification code from the Authenticator App.\u0001": [
	"You secured your account with 2-step verification. Please enter the verification code from the Authenticator App."
],
	"\u0000You secured your account with 2-step verification. Please enter the verification code we sent to your phone.\u0001": [
	"You secured your account with 2-step verification. Please enter the verification code we sent to your phone."
],
	"\u0000You secured your account with 2-step verification. Please use your authentication token to complete verification.\u0001": [
	"You secured your account with 2-step verification. Please use your authentication token to complete verification."
],
	"\u0000You share this folder with other users\u0001": [
	"You share this folder with other users"
],
	"\u0000You tentatively accepted this appointment\u0001": [
	"You tentatively accepted this appointment"
],
	"\u0000You tentatively accepted this task\u0001": [
	"You tentatively accepted this task"
],
	"\u0000You unsubscribed from all folders on \"%1$s\". Those folders will be removed from your account.\u0001": [
	"You unsubscribed from all folders on \"%1$s\". Those folders will be removed from your account."
],
	"\u0000You will be automatically signed out in %1$d second\u0001You will be automatically signed out in %1$d seconds": [
	"You will be automatically signed out in %1$d second",
	"You will be automatically signed out in %1$d seconds"
],
	"\u0000Your Accounts\u0001": [
	"Your Accounts"
],
	"\u0000Your Comment\u0001": [
	"Your Comment"
],
	"\u0000Your IP address has changed\u0001": [
	"Your IP address has changed"
],
	"\u0000Your account password\u0001": [
	"Your account password"
],
	"\u0000Your approval for one or more resources is required.\u0001": [
	"Your approval for one or more resources is required."
],
	"\u0000Your archive\u0001": [
	"Your archive"
],
	"\u0000Your are sharing one or more folders for which you do not have permissions. These folders will not be shared.\u0001": [
	"Your are sharing one or more folders for which you do not have permissions. These folders will not be shared."
],
	"\u0000Your browser does not support the audio format of this file.\u0001": [
	"Your browser does not support the audio format of this file."
],
	"\u0000Your browser does not support the video format of this file.\u0001": [
	"Your browser does not support the video format of this file."
],
	"\u0000Your browser is not officially supported on your current platform.\u0001": [
	"Your browser is not officially supported on your current platform."
],
	"\u0000Your browser is not supported\u0001": [
	"Your browser is not supported"
],
	"\u0000Your browser's cookie functionality is disabled. Please turn it on.\u0001": [
	"Your browser's cookie functionality is disabled. Please turn it on."
],
	"\u0000Your changes are automatically saved while you compose your email until you finally send it.\u0001": [
	"Your changes are automatically saved while you compose your e-mail until you finally send it."
],
	"\u0000Your credentials will be sent over a secure connection only\u0001": [
	"Your credentials will only be sent over a secure connection"
],
	"\u0000Your current password\u0001": [
	"Your current password"
],
	"\u0000Your current selection contains too many appointments for the chosen timeframe.\u0001": [
	"Your current selection contains too many appointments for the chosen time frame."
],
	"\u0000Your data archive from %1$s is ready for download. The download is available until %2$s.\u0001": [
	"Your data archive from %1$s is ready for download. The download is available until %2$s."
],
	"\u0000Your default reminders will be applied to this calendar.\u0001": [
	"Your default reminders will be applied to this calendar."
],
	"\u0000Your devices\u0001": [
	"Your devices"
],
	"\u0000Your email address\u0001": [
	"Your email address"
],
	"\u0000Your name\u0001": [
	"Your name"
],
	"\u0000Your new password may not be empty.\u0001": [
	"Your new password may not be empty."
],
	"\u0000Your old password\u0001": [
	"Your old password"
],
	"\u0000Your password\u0001": [
	"Your password"
],
	"\u0000Your password is expired. Please change your password to continue.\u0001": [
	"Your password is expired. Please change your password to continue."
],
	"\u0000Your password is more secure if it also contains capital letters, numbers, and special characters like %1$s\u0001": [
	"Your password is more secure if it also contains capital letters, numbers, and special characters like %1$s"
],
	"\u0000Your platform is not supported\u0001": [
	"Your platform is not supported"
],
	"\u0000Your platform is not supported!\u0001": [
	"Your platform is not supported!"
],
	"\u0000Your preview is being generated.\u0001": [
	"Your preview is being generated."
],
	"\u0000Your recurrence rule does not fit to your start date.\u0001": [
	"Your recurrence rule does not fit to your start date."
],
	"\u0000Your recurrence rule was changed automatically.\u0001": [
	"Your recurrence rule was changed automatically."
],
	"\u0000Your requested archive is currently being created. Depending on the size of the requested data this may take hours or days. You will be informed via email when your download is ready.\u0001": [
	"Your requested archive is currently being created. Depending on the size of the requested data this may take hours or days. You will be informed via e-mail when your download is ready."
],
	"\u0000Your session is expired\u0001": [
	"Your session has expired"
],
	"\u0000Your timezone\u0001": [
	"Your timezone"
],
	"\u0000Your url\u0001": [
	"Your URL"
],
	"\u0000Your user name\u0001": [
	"Your user name"
],
	"\u0000Your vacation notice is active\u0001": [
	"Your vacation notice is active"
],
	"\u0000Your week\u0001": [
	"Your week"
],
	"\u0000Yubikey\u0001": [
	"Yubikey"
],
	"\u0000Yubikey, Google Security Keys, or compatible FIDO device\u0001": [
	"Yubikey, Google Security Keys, or compatible FIDO device"
],
	"\u0000ZB\u0001": [
	"ZB"
],
	"\u0000Zoom\u0001": [
	"Zoom"
],
	"\u0000Zoom Meeting\u0001": [
	"Zoom Meeting"
],
	"\u0000Zoom in\u0001": [
	"Zoom in"
],
	"\u0000Zoom meetings\u0001": [
	"Zoom meetings"
],
	"\u0000Zoom meetings expire after 365 days. We recommend to limit the series to one year. Alternatively, you can update the series before the Zoom meeting expires.\u0001": [
	"Zoom meetings expire after 365 days. We recommend limiting the series to one year. Alternatively, you can update the series before the Zoom meeting expires."
],
	"\u0000Zoom out\u0001": [
	"Zoom out"
],
	"\u0000Zoom: %1$d%\u0001": [
	"Zoom: %1$d%"
],
	"\u0000[Copy] \u0001": [
	"[Copy] "
],
	"\u0000[Copy] %1$s\u0001": [
	"[Copy] %1$s"
],
	"\u0000a full match (allows DOS-style wildcards)\u0001": [
	"a full match (allows DOS-style wildcards)"
],
	"\u0000accepted\u0001": [
	"accepted"
],
	"search\u0000address\u0001": [
	"address"
],
	"search\u0000after\u0001": [
	"after"
],
	"\u0000after end\u0001": [
	"after end"
],
	"\u0000after start\u0001": [
	"after start"
],
	"\u0000an exact, full match\u0001": [
	"an exact, full match"
],
	"\u0000and %1$d others\u0001": [
	"and %1$d others"
],
	"\u0000and %1$s more appointments\u0001": [
	"and %1$s more appointments"
],
	"a11y\u0000at %1$s\u0001": [
	"at %1$s"
],
	"search\u0000attachments\u0001": [
	"attachments"
],
	"\u0000autoforward\u0001": [
	"Auto forward"
],
	"\u0000back\u0001": [
	"back"
],
	"search\u0000before\u0001": [
	"before"
],
	"\u0000before end\u0001": [
	"before end"
],
	"\u0000before start\u0001": [
	"before start"
],
	"search\u0000business\u0001": [
	"business"
],
	"\u0000calendar\u0001": [
	"calendar"
],
	"search\u0000categories\u0001": [
	"categories"
],
	"\u0000choose a different platform\u0001": [
	"choose a different platform"
],
	"\u0000choose a different scenario\u0001": [
	"choose a different scenario"
],
	"\u0000continue if all conditions are met\u0001": [
	"continue if all conditions are met"
],
	"\u0000continue if all of these conditions are met\u0001": [
	"continue if all of these conditions are met"
],
	"\u0000continue if any of these conditions are met\u0001": [
	"continue if any of these conditions are met"
],
	"\u0000datepicker\u0001": [
	"date picker"
],
	"\u0000day(s)\u0001": [
	"day(s)"
],
	"\u0000declined\u0001": [
	"declined"
],
	"\u0000deleted\u0001": [
	"deleted"
],
	"\u0000department %1$s\u0001": [
	"department %1$s"
],
	"\u0000does not match a substring\u0001": [
	"does not match a substring"
],
	"search\u0000email\u0001": [
	"email"
],
	"\u0000email address %1$s\u0001": [
	"email address %1$s"
],
	"\u0000ends:\u0001": [
	"ends:"
],
	"\u0000fifth / last\u0001": [
	"fifth / last"
],
	"\u0000file\u0001": [
	"file"
],
	"search\u0000file\u0001": [
	"file"
],
	"\u0000first\u0001": [
	"first"
],
	"\u0000flagged\u0001": [
	"flagged"
],
	"search\u0000flagged\u0001": [
	"flagged"
],
	"\u0000folder\u0001": [
	"folder"
],
	"\u0000fourth\u0001": [
	"fourth"
],
	"\u0000has attachments\u0001": [
	"has attachments"
],
	"\u0000has participants\u0001": [
	"has participants"
],
	"\u0000iCal URL\u0001": [
	"iCal URL"
],
	"\u0000iCal feed\u0001": [
	"iCal feed"
],
	"\u0000iCal feed has been imported successfully\u0001": [
	"iCal feed has been imported successfully"
],
	"\u0000iCalendar\u0001": [
	"iCalendar"
],
	"\u0000iOS\u0001": [
	"iOS"
],
	"\u0000iOS Mail\u0001": [
	"iOS Mail"
],
	"\u0000iOS devices can be automatically configured by installing the configuration profile.\u0001": [
	"iOS devices can be automatically configured by installing the configuration profile."
],
	"\u0000iPhone or iPad\u0001": [
	"iPhone or iPad"
],
	"\u0000kB\u0001": [
	"kB"
],
	"\u0000list of available actions\u0001": [
	"list of available actions"
],
	"\u0000list of available devices\u0001": [
	"list of available devices"
],
	"\u0000list of available platforms\u0001": [
	"list of available platforms"
],
	"\u0000loading\u0001": [
	"loading"
],
	"a11y\u0000location %1$s\u0001": [
	"location %1$s"
],
	"\u0000macOS\u0001": [
	"macOS"
],
	"\u0000matches a substring\u0001": [
	"matches a substring"
],
	"\u0000message\u0001": [
	"message"
],
	"\u0000modified\u0001": [
	"modified"
],
	"\u0000month(s)\u0001": [
	"month(s)"
],
	"search\u0000name\u0001": [
	"name"
],
	"\u0000no color\u0001": [
	"no colour"
],
	"\u0000none\u0001": [
	"none"
],
	"\u0000not a full match (allows DOS-style wildcards)\u0001": [
	"not a full match (allows DOS-style wildcards)"
],
	"\u0000not an exact, full match \u0001": [
	"not an exact, full match "
],
	"search\u0000note\u0001": [
	"note"
],
	"\u0000of %1$d\u0001": [
	"of %1$d"
],
	"\u0000on behalf of\u0001": [
	"on behalf of"
],
	"\u0000one hour\u0001%d hours": [
	"one hour",
	"%d hours"
],
	"\u0000one minute\u0001%d minutes": [
	"one minute",
	"%d minutes"
],
	"\u0000only sets accent colors in darkmode\u0001": [
	"only sets accent colours in darkmode"
],
	"\u0000or\u0001": [
	"or"
],
	"\u0000original time zone\u0001": [
	"original timezone"
],
	"search\u0000phone\u0001": [
	"phone"
],
	"\u0000phone number %1$s\u0001": [
	"phone number %1$s"
],
	"\u0000position %1$s\u0001": [
	"position %1$s"
],
	"\u0000private\u0001": [
	"private"
],
	"\u0000recovery\u0001": [
	"recovery"
],
	"\u0000room %1$s\u0001": [
	"room %1$s"
],
	"\u0000second\u0001": [
	"second"
],
	"\u0000see attached|see attachment|see included|is attached|attached is|are attached|attached are|attached to this email|attached to this message|I'm attaching|I am attaching|I've attached|I have attached|I attach|I attached|find attached|find the attached|find included|find the included|attached file|see the attached|see attachments|attached files|see the attachment\u0001": [
	"see attached|see attachment|see included|is attached|attached is|are attached|attached are|attached to this e-mail|attached to this message|I'm attaching|I am attaching|I've attached|I have attached|I attach|I attached|find attached|find the attached|find included|find the included|attached file|see the attached|see attachments|attached files|see the attachment"
],
	"\u0000seen\u0001": [
	"seen"
],
	"\u0000select format\u0001": [
	"select format"
],
	"\u0000size\u0001": [
	"size"
],
	"\u0000some category\u0001": [
	"some category"
],
	"\u0000tentative\u0001": [
	"tentative"
],
	"\u0000then\u0001": [
	"then"
],
	"\u0000third\u0001": [
	"third"
],
	"\u0000thumbnail\u0001": [
	"thumbnail"
],
	"\u0000timeframe\u0001": [
	"time frame"
],
	"\u0000timeframe relation\u0001": [
	"time frame relation"
],
	"\u0000toggle password visibility\u0001": [
	"toggle password visibility"
],
	"\u0000type\u0001": [
	"type"
],
	"\u0000unconfirmed\u0001": [
	"unconfirmed"
],
	"\u0000unknown\u0001": [
	"unknown"
],
	"\u0000unknown Domain\u0001": [
	"unknown Domain"
],
	"\u0000unknown sender\u0001": [
	"unknown sender"
],
	"\u0000unlimited\u0001": [
	"unlimited"
],
	"\u0000vCard\u0001": [
	"vCard"
],
	"\u0000vacation notice\u0001": [
	"vacation notice"
],
	"\u0000via\u0001": [
	"via"
],
	"\u0000week(s)\u0001": [
	"week(s)"
],
	"search\u0000year\u0001": [
	"year"
],
	"\u0000year(s)\u0001": [
	"year(s)"
],
	"search\u0000yes\u0001": [
	"yes"
],
	"\u0000your platform\u0001": [
	"your platform"
],
	"\u0000„Undo send“ is a new feature that gives you the ability to cancel sending an email shortly after you've clicked the \"send\" button. This feature is super handy if you've made a mistake, such as forgetting to attach a file or sending an email to the wrong recipient or simply hit „send“ by accident.\u0001": [
	"\"Undo send“ is a new feature that gives you the ability to cancel sending an email shortly after you've clicked the \"send\" button. This feature is super handy if you have made a mistake, such as forgetting to attach a file or sending an email to the wrong recipient or simply hit \"send“ by accident."
]
};
